webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("50Yw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/kSE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0EFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1oBF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ALQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mover_helper__ = __webpack_require__("A0ws");

// import { getAbbreviation } from '../../helpers/state-abbreviation'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'review',
  created: function created() {},
  mounted: function mounted() {
    this.getPartnersData();
  },
  data: function data() {
    return {
      partners: []
    };
  },

  methods: {
    getPartnersData: function getPartnersData() {
      var _this = this;

      this.$http.get("https://movermap-api.irelo.com" + '/filters?order=created_at,asc').then(function (response) {
        response = response.data || response;
        console.log();
        response = __WEBPACK_IMPORTED_MODULE_0_lodash__["groupBy"](response, 'client_id');
        __WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"](response, function (data, key) {
          var zipcodes = __WEBPACK_IMPORTED_MODULE_0_lodash__["join"](__WEBPACK_IMPORTED_MODULE_0_lodash__["map"](data, 'filter_id'), ', ');
          var completed = data[0].completed == 1 ? true : false;
          data = {};
          data.client_id = key;
          data.completed = completed;
          data.zipcodes = zipcodes;
          _this.partners.push(data);
        });
        console.log(_this.partners);
      });
    },
    setCompleted: function setCompleted(partner) {
      console.log(partner.completed);
      var params = {
        "completed": partner.completed
      };

      this.$http.post("https://movermap-api.irelo.com" + '/filters/update-by-client-id/' + partner.client_id, params).then(function (response) {
        console.log(response);
      });
      console.log(partner);
    },
    refreshUser: function refreshUser(partner, index) {
      var _this2 = this;

      if (confirm("Do you really want to delete this user?")) {
        this.$http.delete("https://movermap-api.irelo.com" + '/user/' + partner.client_id).then(function (response) {
          console.log(response, index);
          _this2.partners.splice(index, 1);
        });
      }
    }
  }
});

/***/ }),

/***/ "2Ldv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'header',
	created: function created() {},
	mounted: function mounted() {},
	data: function data() {
		return {};
	},

	methods: {
		gototHome: function gototHome() {
			this.$router.push({ name: "home" });
		}
	}
});

/***/ }),

/***/ "43sL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center w-100 justify-content-center get-code-wrapper"},[(_vm.showCodeHelp)?_c('div',{staticClass:"help-text l-font ls-1 grey",attrs:{"id":"popup"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closeHelperMsg("popup")}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v("Next, select the area codes you pickup moves in.")])]):_vm._e(),_vm._v(" "),(_vm.showUnselectAreaHelp)?_c('div',{staticClass:"help-text l-font ls-1 grey",attrs:{"id":"unselect-popup"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closeHelperMsg("unselect-popup")}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v("To deselect an area code click on the area again until the color becomes grey.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"side-menu"},[_c('div',{staticClass:"col-md-12 py-4 br-down-grey"},[_c('div',{staticClass:"d-inline-flex justify-content-center w-100"},[_c('div',{staticClass:"oval mr-3 my-auto"}),_c('h1',{staticClass:"xl-font ls-1 text-center m-0"},[_vm._v(_vm._s(_vm.state))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 py-4 br-down-grey"},[(_vm.stateData.totals)?_c('div',{staticClass:"justify-content-center"},[_c('h1',{staticClass:"xl-font ls-1 text-center grey "},[_vm._v(_vm._s(_vm.stateData.totals.total_leads))]),_vm._v(" "),_c('h3',{staticClass:"md-font text-center grey m-0"},[_vm._v("Monthly Lead Qty")])]):_vm._e()]),_vm._v(" "),(_vm.stateData.totals)?_c('div',{staticClass:"d-flex flex-row br-down-grey"},[_c('div',{staticClass:"col-md-6 br-right-grey justify-content-center py-4"},[_c('h1',{staticClass:"l-font ls-1 text-center"},[_vm._v(_vm._s(Math.round((_vm.stateData.totals.long_distance/_vm.stateData.totals.total_leads)*100) || "0")+"%")]),_vm._v(" "),_c('h3',{staticClass:"sm-font text-center grey m-0"},[_vm._v("Interstate")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 justify-content-center py-4"},[_c('h1',{staticClass:"l-font ls-1 text-center"},[_vm._v(_vm._s(Math.round((_vm.stateData.totals.local/_vm.stateData.totals.total_leads)*100) || "0")+"%")]),_vm._v(" "),_c('h3',{staticClass:"sm-font text-center grey m-0"},[_vm._v("Intrastate")])])]):_vm._e(),_vm._v(" "),(_vm.stateData.totals)?_c('div',{staticClass:"py-2"},[_c('div',{staticClass:"col-md-12 justify-content-center w-90 mx-4 my-2 py-2 mx-auto"},[_c('div',{staticClass:"d-flex flex-row"},[_c('h1',{staticClass:"sm-font col-md-9 pull-left ls-1 m-0 text-left grey p-0"},[_vm._v("Move Size > 2 bedrooms")]),_vm._v(" "),_c('h3',{staticClass:"pull-right text-right col-md-3 md-font ls-1 my-auto ml-3 grey"},[_vm._v(_vm._s(Math.round((_vm.stateData.totals.two_rooms_or_more/_vm.stateData.totals.total_leads)*100) || "0")+"%")])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row my-1 py-1 "},[_c('div',{staticClass:"col-md-12 my-auto p-0 indicator-parent"},[_c('div',{staticClass:"indicator",style:({width : (_vm.stateData.totals.two_rooms_or_more/_vm.stateData.totals.total_leads)*100 + '%'})})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 justify-content-center w-90 mx-4 my-2 py-2 mx-auto"},[_c('div',{staticClass:"d-flex flex-row"},[_c('h1',{staticClass:"sm-font col-md-9 pull-left ls-1 m-0 text-left grey p-0"},[_vm._v("Move Date < 90 Days")]),_vm._v(" "),_c('h3',{staticClass:"pull-right text-right col-md-3 md-font ls-1 my-auto ml-3 grey"},[_vm._v(_vm._s(Math.round((_vm.stateData.totals.move_date_under_2_months/_vm.stateData.totals.total_leads)*100) || "0")+"%")])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row my-1 py-1"},[_c('div',{staticClass:"col-md-12 my-auto p-0 indicator-parent"},[_c('div',{staticClass:"indicator",style:({width :(_vm.stateData.totals.move_date_under_2_months/_vm.stateData.totals.total_leads)*100  + '%'})})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 justify-content-center w-90 mx-4 my-2 py-2 mx-auto"},[_c('div',{staticClass:"d-flex flex-row"},[_c('h1',{staticClass:"sm-font col-md-9 pull-left ls-1 m-0 text-left grey p-0"},[_vm._v("# of Leads Undersold")]),_vm._v(" "),_c('h3',{staticClass:"pull-right text-right col-md-3 md-font ls-1 my-auto ml-3 grey"},[_vm._v(_vm._s(Math.round((_vm.stateData.totals.unmatched/_vm.stateData.totals.total_leads)*100) || "0")+"%")])]),_vm._v(" "),_c('div',{staticClass:" d-flex flex-row my-1 py-1"},[_c('div',{staticClass:"col-md-12 my-auto p-0 indicator-parent"},[_c('div',{staticClass:"indicator",style:({width :(_vm.stateData.totals.unmatched/_vm.stateData.totals.total_leads)*100  + '%'})})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-md-12 mx-auto w-100 py-2 back row justify-content-center"},[(!_vm.all_selected)?_c('button',{staticClass:"get-started error md-font ls-1 w-90 my-1 d-flex",attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.selectEntireState()}}},[_c('p',{staticClass:"m-0 mx-auto"},[_vm._v("Select Entire State")])]):_vm._e(),_vm._v(" "),(_vm.all_selected)?_c('button',{staticClass:"get-started error md-font ls-1 w-90 my-1 d-flex",attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.unselectEntireState()}}},[_c('p',{staticClass:"m-0 mx-auto"},[_vm._v("Unselect Entire State")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"get-started md-font ls-1 w-90 my-1 d-flex",attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.backToMap()}}},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"m-0 mx-auto"},[_vm._v("Back to Map")])])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader-map"},[_c('app-loader')],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-container my-auto mr-4"},[_c('div',{staticClass:"arrow-left m-0"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4hlo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAbCAYAAACJISRoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjlCNDFBMTI2QTQxQzExRTdCQzBCOTIyQkQyQTRGNERBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjlCNDFBMTI3QTQxQzExRTdCQzBCOTIyQkQyQTRGNERBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUI0MUExMjRBNDFDMTFFN0JDMEI5MjJCRDJBNEY0REEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OUI0MUExMjVBNDFDMTFFN0JDMEI5MjJCRDJBNEY0REEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6YRMp+AAACRUlEQVR42rxWPW/TUBS996WgCJlEIoGgqv0BwB9gogJVoLLBBIIfAAtjNyZGNsTMBAgWEAtCbAx8/AEYWUAI28+KHRuIWtzLPW5jmapOHyn1WxL73XvOu1/nmWmXJSIHoihZ2iA+zUTzItRjpkiIvhmSD71e9w0zr0/D4LqNLMsGP8f5baW5pmZdIfnIwl+FybJQX38X1fmk7ie6/+hQu3XH8zyfXFdgk1tBGKd+GH/2bXwzyLLjO9rpe+zDDvbwI4fUHAxs/ECN1307WsWzy6FgB3v4wR8pnhIBCOKhtek5mmHBD/7AqU+RnmRWgr+JENG21KHIRQ00ZPoPq0id4gG3GsV9FM+1BnUrTdOjZY3QDIqLZ7NZJLmuzXxX+31tVgIFvPdrvPEeBAWO4qH9gW8waNrnHW7PPd8Lgf7cEDark4Nu4nEX+AaTjEE75nnfK8U7MbUNdyIgc2XQP/xs8h54qgqfgG8gFZjkas/nlL8KouSp/p+bhaCUE6EvwDfQIkhFuVHk01zVzeUwSp7UEe1GUBxYcYFvIHbQourmoNd5J8askNAFJXqsRK1/JdiKpA98AzUVloXtBoMjnbfUMit6kouhHT2cELkSbEWyCHy2Nl7W4rymdmu+Wvzy1MP0jPzOX2oeX2gKI1eCQlTHOa6D88V9Ab2BmtY5hMN0SYfrh0ax5tv0stvUq3orbtmlLhMfhulZa0eXnFW5MvHNaVcjKtzYfdLYzbhfd/wevlZkgYlPuXytcCPfXQpC+70MNbD+CDAAOsBFam2irQkAAAAASUVORK5CYII="

/***/ }),

/***/ "4k7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'loader',
	created: function created() {},
	mounted: function mounted() {},
	data: function data() {
		return {};
	},

	methods: {}
});

/***/ }),

/***/ "50Yw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5D5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7x6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"logo-wrapper",on:{"click":function($event){_vm.gototHome()}}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("dLd/")}})]),_vm._v(" "),_c('div',{staticClass:"logo-underline",class:{step2 : _vm.$route.name == 'get-code', step3: _vm.$route.name == 'get-state-exclusion', step4 : _vm.$route.name == 'review', step5 : _vm.$route.name == 'thankyou' }}),_vm._v(" "),_c('h2',{staticClass:"l-font ls-1"},[_vm._v("+1 48O 785 74OO")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8j7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid w-100 p-0 review-wrapper"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"order"},[_c('h1',{staticClass:"xl-font fs-1 heading pb-2 ml-1"},[_vm._v("Lead Order Review")]),_vm._v(" "),_c('div',{staticClass:"order-table py-4"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.selectedAreas),function(selected_area){return (selected_area.status == "Active")?_c('div',{staticClass:"row order-data w-98 mx-auto mt-3"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-md-3  align-items-center text-center justify-content-center l-font d-flex"},[_c('strong',[_vm._v(_vm._s(selected_area.state))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 align-items-center text-center justify-content-center l-font d-flex flex-row flex-wrap"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(_vm._s(selected_area.area_codes))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 align-items-center text-center justify-content-center l-font d-flex flex-wrap"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(_vm._s(_vm.excludedAreas))])])])]):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"row buttons justify-content-between"},[_c('button',{staticClass:"text-center get-started btn xl-font fs-1 d-flex justify-content-center",on:{"click":function($event){_vm.goBack()}}},[_vm._m(2),_c('p',{staticClass:"m-0"},[_vm._v("Edit Lead Order")])]),_vm._v(" "),_c('button',{staticClass:"get-started text-center btn error xl-font fs-1",on:{"click":function($event){_vm.getLeads()}}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.processing ? 'Saving Data': 'Get Leads')),(_vm.processing)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row w-98 m-auto"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center l-font grey"},[_c('h3',{staticClass:"l-font"},[_vm._v("Pickup State")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center l-font grey"},[_c('h3',{staticClass:"l-font"},[_vm._v("Pickup Area Codes")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center l-font grey"},[_c('h3',{staticClass:"l-font"},[_vm._v("Exclusion State")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1 p-4 success text-center d-flex flex-row align-items-center "},[_c('i',{staticClass:"fa fa-check xl-font m-auto",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-container my-auto mr-4"},[_c('div',{staticClass:"arrow-left m-0"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9RQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A0ws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_abbreviation__ = __webpack_require__("YWhn");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      static_promise: null
    };
  },

  login: function login(client_id, _login) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post("https://movermap-api.irelo.com" + '/auth/login', { "id": client_id, 'login': _login }).then(function (response) {
        if (response.status == 200 && !response.data.error) {
          _this.setUserData(response.data);
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch(function (err) {
        resolve(false);
      });
    });
  },
  getFilterSetDetails: function getFilterSetDetails() {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var api_url = "https://movermap-api.irelo.com" + '/filtersets';
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(api_url, { params: { 'token': __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].getters.accessToken } }).then(function (response) {
        var filter_sets = response.data || response;
        var context = _this2;
        __WEBPACK_IMPORTED_MODULE_4_lodash__["each"](filter_sets, function (next_item) {
          if (next_item.status == "Active") {
            context.setStatesAreaCode(__WEBPACK_IMPORTED_MODULE_5__state_abbreviation__["a" /* default */].getStateByAbbreviation(next_item.states), next_item.detail);
          }
        });
        setTimeout(function () {
          resolve(true);
        }, 5000);
      }).catch(function (error) {
        reject(true);
      });
    });
  },
  saveClientData: function saveClientData() {
    var context = this;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var filter_sets = context.getFormattedData();
      var api_url = "https://movermap-api.irelo.com" + '/filtersets';
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(api_url, { 'pickups': filter_sets }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getSelectedArea: function getSelectedArea(state) {
    var selectedAreas = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].getters.selectedAreas;
    var response = __WEBPACK_IMPORTED_MODULE_4_lodash__["find"](selectedAreas, { 'state': state });
    return response;
  },
  setUserData: function setUserData(user_data) {
    var user = user_data;
    delete user.filter_sets;
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit("setUser", user);
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit("setAccessToken", user.token);
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit("setClientId", user.id);
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit("setCompany", user.company);
    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
  },
  setSelectedAreas: function setSelectedAreas(filter_sets) {
    var selectedAreas = [];
    __WEBPACK_IMPORTED_MODULE_4_lodash__["each"](filter_sets, function (filter_set) {
      selectedAreas.push({
        filter_set_id: filter_set.id || null,
        abbreviation: filter_set.states,
        state: __WEBPACK_IMPORTED_MODULE_5__state_abbreviation__["a" /* default */].getStateByAbbreviation(filter_set.states),
        area_codes: [],
        status: filter_set.status,
        prev_status: filter_set.status
      });
    });
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit('setSelectedAreas', selectedAreas);
  },
  setExcludedAreas: function setExcludedAreas(exclusions) {
    var excluded_areas = [];
    __WEBPACK_IMPORTED_MODULE_4_lodash__["each"](exclusions, function (state) {
      excluded_areas.push({
        state: __WEBPACK_IMPORTED_MODULE_5__state_abbreviation__["a" /* default */].getStateByAbbreviation(state),
        abbreviation: state
      });
    });
    __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit('setExcludedAreas', excluded_areas);
  },
  setStatesAreaCode: function setStatesAreaCode(state, filter_set) {
    var selected_area = this.getSelectedArea(state);
    var selected_area_codes = [];

    var zip_codes = filter_set.origin_zip;
    zip_codes = __WEBPACK_IMPORTED_MODULE_4_lodash__["split"](zip_codes, ',');

    this.getZipCodesByState(filter_set.origin_state).then(function (area_codes) {
      __WEBPACK_IMPORTED_MODULE_4_lodash__["each"](zip_codes, function (zip_code) {
        zip_code = __WEBPACK_IMPORTED_MODULE_4_lodash__["split"](zip_code, '*');
        console.log('state', state, zip_codes);
        if (zip_code.length > 1) {
          zip_code = zip_code[0];
          __WEBPACK_IMPORTED_MODULE_4_lodash__["each"](area_codes, function (next_item) {
            console.log("in area _ codes", next_item, state);
            if (__WEBPACK_IMPORTED_MODULE_4_lodash__["startsWith"](next_item.zipcode, zip_code, 0)) {
              selected_area_codes.push({
                area_code: next_item.area_code,
                zip_code: next_item.zipcode
              });
            }
          });
        } else {
          if (__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"](zip_code[0])) {
            return;
          }
          zip_code = zip_code[0];
          var area_code = __WEBPACK_IMPORTED_MODULE_4_lodash__["find"](area_codes, { "zipcode": zip_code });
          selected_area_codes.push({
            area_code: area_code.area_code,
            zip_code: area_code.zipcode
          });
        }
        console.log(zip_code, selected_area_codes, 'selected_areas', selected_area);
      });
      selected_area.area_codes = selected_area_codes;
      selected_area.total_area_codes = area_codes.length;
      __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].commit('updateSelectedArea', selected_area);
      console.log('area_codes', selected_area);
    });
  },
  getZipCodesByState: function getZipCodesByState(state) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get('https://valet.irelo.com/api/service/areacodes/' + state).then(function (response) {
        response = response.data || response;
        resolve(response);
      }).catch(function (error) {
        reject();
      });
    });
  },
  getFormattedCodes: function getFormattedCodes(selected_area) {
    var selected_area_codes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selected_area.area_codes));
    var codes = __WEBPACK_IMPORTED_MODULE_4_lodash__["join"](__WEBPACK_IMPORTED_MODULE_4_lodash__["map"](selected_area.area_codes, 'area_code'), ',');
    selected_area_codes = __WEBPACK_IMPORTED_MODULE_4_lodash__["filter"](selected_area_codes, function (area) {
      if (__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"](area.additional_areacodes)) {
        return false;
      }
      return true;
    });
    var additonal_codes = __WEBPACK_IMPORTED_MODULE_4_lodash__["join"](__WEBPACK_IMPORTED_MODULE_4_lodash__["map"](selected_area_codes, 'additional_areacodes'), ',');
    var total_codes = additonal_codes ? codes + "," + additonal_codes : codes;
    return total_codes;
  },
  getFormattedData: function getFormattedData() {
    var filter_sets = [];
    var selected_areas = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].getters.selectedAreas;
    var excluded_areas = this.getExcludedAreas();

    for (var i = 0; i < selected_areas.length; i++) {

      var filter_set = {
        state: selected_areas[i].abbreviation,
        areacodes: this.getFormattedCodes(selected_areas[i]),
        zipcodes: selected_areas[i].area_codes.length != selected_areas[i].total_area_codes ? __WEBPACK_IMPORTED_MODULE_4_lodash__["join"](__WEBPACK_IMPORTED_MODULE_4_lodash__["map"](__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"](selected_areas[i].area_codes, function (code) {
          if (__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"](code.zip_code)) {
            return false;
          }
          return true;
        }), 'zip_code'), ',') : '',
        exclusions: __WEBPACK_IMPORTED_MODULE_4_lodash__["join"](__WEBPACK_IMPORTED_MODULE_4_lodash__["map"](excluded_areas, 'abbreviation'), ','),
        status: selected_areas[i].status || "Active",
        prev_status: selected_areas[i].prev_status || ""
      };
      if (selected_areas[i].filter_set_id) {
        filter_set['filter_set_id'] = selected_areas[i].filter_set_id;
      }

      filter_sets.push(filter_set);
    }

    return filter_sets;
  },
  getExcludedAreas: function getExcludedAreas() {
    var excluded_areas = __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */].getters.excludedAreas;
    __WEBPACK_IMPORTED_MODULE_4_lodash__["filter"](excluded_areas, function (excluded_area) {
      return excluded_area.abbreviation != "AK" || excluded_area.abbreviation != "HI", excluded_area.abbreviation != "PR";
    });
    var compulsory_states = [{
      state: "Alaska",
      abbreviation: "AK"
    }, {
      state: "Hawaii",
      abbreviation: "HI"
    }, {
      state: "Puerto Rico",
      abbreviation: "PR"
    }];

    excluded_areas = excluded_areas.concat(compulsory_states);
    return excluded_areas;
  }
});

/***/ }),

/***/ "BLLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_state_selector__ = __webpack_require__("KMmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__ = __webpack_require__("YWhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__ = __webpack_require__("A0ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__ = __webpack_require__("gs7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wellknown__ = __webpack_require__("KGwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_wellknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_wellknown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polylabel__ = __webpack_require__("LGRV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polylabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_polylabel__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'get-code',
  data: function data() {
    return {
      moveSize: 42,
      moveDate: 62,
      undersoldLeads: 32,
      areaCodes: {},
      state: null,
      loading: true,
      stateData: {},
      current_size: 24,
      showCodeHelp: false,
      showUnselectAreaHelp: false,
      bound: null,
      all_selected: false
    };
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    if (user && user.completed_process) {
      next('/thankyou');
    }
    next(true);
  },
  created: function created() {},
  mounted: function mounted() {
    console.log(this.$route.params.state);
    this.$store.commit('setSelectedState', this.$route.params.state);

    this.showInitialHelperMsg();
    this.checkMap();
    this.retriveStateData();
    this.getFilterSet();
    this.$store.dispatch('removeSelectedAreas');
  },
  destroyed: function destroyed() {
    this.$store.dispatch('removeAreaCodes');
  },

  methods: {
    showInitialHelperMsg: function showInitialHelperMsg() {
      var _this = this;

      var showText = localStorage.getItem('showGetCodeHelpText');
      if (!showText) {
        this.showCodeHelp = true;
        localStorage.setItem('showGetCodeHelpText', true);
        setTimeout(function () {
          _this.showCodeHelp = false;
        }, 5000);
      }
    },
    showUnselectHelperMsg: function showUnselectHelperMsg() {
      var _this2 = this;

      var showUnselectText = localStorage.getItem('showUnselectAreaHelpText');
      if (!showUnselectText) {
        this.showUnselectAreaHelp = true;
        localStorage.setItem('showUnselectAreaHelpText', true);
        setTimeout(function () {
          _this2.showUnselectAreaHelp = false;
        }, 5000);
      }
    },
    closeHelperMsg: function closeHelperMsg(id) {
      document.getElementById(id).style.display = 'none';
    },
    unselectPolygon: function unselectPolygon(polygon) {
      polygon.setOptions({ strokeOpacity: 0, fillOpacity: 0 });
    },
    getFilterSet: function getFilterSet() {
      var state = this.$store.getters.selectedState;
      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(state);

      if (selected_area && selected_area.filter_set_id && !selected_area.area_codes.length) {
        var api_url = "https://movermap-api.irelo.com" + '/filtersets/' + selected_area.filter_set_id + "?token=" + this.$store.getters.accessToken;
        if (selected_area.status == "Active") {
          this.$http.get(api_url).then(function (response) {
            var filter_set = response.data || response;
            __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].setStatesAreaCode(state, filter_set);
            console.log('filter set data', filter_set);
          });
        }
      }
    },
    setZoom: function setZoom(zoom) {
      this.$store.getters.map.setZoom(zoom);
    },
    checkMap: function checkMap() {
      var _this3 = this;

      this.loading = true;
      this.show_tag_box = true;

      __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__["a" /* default */]._isGoogleLoaded({ infobox: true }).then(function (val) {
        __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__["a" /* default */].refreshMap().then(function (val) {
          var boundaries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_state_selector__["a" /* getBoundaries */])();
          _this3.bound = new google.maps.LatLngBounds();

          for (var i = 0; i < boundaries[_this3.$store.getters.selectedState].length; i++) {
            var point = new google.maps.LatLng(boundaries[_this3.$store.getters.selectedState][i].lat(), boundaries[_this3.$store.getters.selectedState][i].lng());
            _this3.bound.extend(point);
          }
          _this3.showAreaCodePolygons();
        });
      });
    },
    polygonHoverListners: function polygonHoverListners(city) {
      var _this4 = this;

      google.maps.event.addListener(city.polygon, 'mouseover', function () {
        if (city.mapLabel) {
          city.mapLabel.setContent("<div style='font-size:" + _this4.current_size + "px;' class='maplabel map_label_selected fs-1 text-center '>" + city.display + "</div>");
          city.polygon.setOptions({ fillColor: '#DF5435', strokeColor: '#DF5435' });
        }
      });
      google.maps.event.addListener(city.polygon, 'mouseout', function () {
        if (city.mapLabel && !city.selected) {
          city.mapLabel.setContent("<div style='font-size:" + _this4.current_size + "px;' class='maplabel fs-1 text-center '>" + city.display + "</div>");
          city.polygon.setOptions({ fillColor: '#8A8E93', strokeColor: '#8A8E93' });
        }
      });
    },
    polygonClickListners: function polygonClickListners(city) {
      var _this5 = this;

      google.maps.event.addListener(city.polygon, 'click', function () {
        if (city.mapLabel && !city.selected) {
          city.mapLabel.setContent("<div style='font-size:" + _this5.current_size + "px;' class='maplabel map_label_selected fs-1 text-center '>" + city.display + "</div>");
          city.polygon.setOptions({ fillColor: '#DF5435', strokeColor: '#DF5435' });
          _this5.selectAreaCode(city);
        } else {
          city.mapLabel.setContent("<div style='font-size:" + _this5.current_size + "px;' class='maplabel fs-1 text-center '>" + city.display + "</div>");
          city.polygon.setOptions({ fillColor: '#8A8E93', strokeColor: '#8A8E93' });
          _this5.unselectAreaCode(city);
        }
      });
    },
    createMapLabel: function createMapLabel(city, myLatLng) {
      city.mapLabel = new InfoBox({
        content: "<div id=" + city.area_code + " style='font-size:" + this.current_size + "px;' class='maplabel fs-1 text-center '>" + city.display + "</div>",
        disableAutoPan: false,
        maxWidth: city.width,
        alignBottom: true,
        pixelOffset: new google.maps.Size(-35, 20),
        position: myLatLng,
        zIndex: null,
        boxStyle: {
          opacity: 1,
          zIndex: 1,
          width: city.width + "px",
          height: "50px",
          overflow: "hidden",
          color: "#DF5435"
        },
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        enableEventPropagation: true
      });
      // city.mapLabel.setPosition()
      city.mapLabel.open(this.$store.getters.map);
    },
    setZoomAndSize: function setZoomAndSize() {
      if (this.$store.getters.areaCodes.length > 10) {
        this.current_size = 18;
        this.setZoom(8);
      } else {
        this.current_size = 24;
      }
    },
    createPolygon: function createPolygon(city, tmp) {
      city.polygon = new google.maps.Polygon({
        paths: tmp,
        strokeColor: '#8A8E93',
        strokeOpacity: 0.8,
        strokeWeight: 4,
        fillColor: '#8A8E93',
        fillOpacity: 0.3,
        zIndex: 1
      });
      city.polygon.setMap(this.$store.getters.map);
    },
    getCenter: function getCenter(city, shape, tmp2) {
      var geojson = __WEBPACK_IMPORTED_MODULE_4_wellknown__(shape);
      var center = null;
      if (tmp2.length > 1) {
        var pos = city.polygon.my_getBounds().getCenter();
        center = [pos.lng(), pos.lat()];
      } else {
        center = __WEBPACK_IMPORTED_MODULE_5_polylabel__(geojson.coordinates, 1.0);
      }

      var lat = center[1];
      var lng = center[0];

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: this.$store.getters.map
      });
      marker.setVisible(false);
      var myLatLng = city.polygon.my_getBounds().getCenter();

      if (!google.maps.geometry.poly.containsLocation(myLatLng, city.polygon)) {
        myLatLng = marker.getPosition();
      }
      return myLatLng;
    },
    checkForAdditionalAreaCode: function checkForAdditionalAreaCode(city, areacode) {
      if (!city.additional_areacodes) city.additional_areacodes = [];
      city.display += "/" + areacode;
      city.width += 35;
      var ad = {
        areacode: areacode,
        flag: "extra"
      };
      var index = _.find(this.$store.getters.areaCodes, function (area) {
        return area.area_code == areacode;
      });
      if (index && index.area_code) {
        ad.flag = "true";
        ad.zipcode_list = index.zipcode_list;
      }
      city.additional_areacodes.push(ad);
      return city;
    },
    showAreaCodePolygons: function showAreaCodePolygons() {
      var _this6 = this;

      this.$store.getters.map.fitBounds(this.bound);
      this.state = this.$store.getters.selectedState;
      var state_abbr = __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__["a" /* default */].getAbbreviationByState(this.state);
      var api_url = "https://movermap-api.irelo.com" + '/areacodes/get-by-state/' + state_abbr;

      this.$http.get('https://valet.irelo.com/api/service/areacodes/' + this.$store.getters.selectedState).then(function (response) {
        _this6.$store.commit("setAreaCodes", response.data);
        var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(_this6.$store.getters.selectedState);
        _this6.setZoomAndSize();
        var context = _this6;
        context.$http.get(api_url).then(function (response) {

          if (!response.data.areacodes || response.data.areacodes.length == 0) return;

          var areacodes = response.data.areacodes;
          if (selected_area) {
            _this6.all_selected = selected_area.area_codes.length == areacodes.length;
          }

          _.forEach(_this6.$store.getters.areaCodes, function (city) {
            var areacode = areacodes.find(function (area) {
              return area.npa == city.area_code;
            });
            if (!areacode) return;
            city.display = city.area_code;
            city.width = 70;

            if (areacode.npa_2) {
              city = _this6.checkForAdditionalAreaCode(city, areacode.npa_2);
            }
            if (areacode.npa_3) {
              city = _this6.checkForAdditionalAreaCode(city, areacode.npa_3);
            }

            city.zindex = areacode.zindex;
            var tmp = context.parsePolyStrings(areacode.shape);
            var tmp2 = tmp;
            if (tmp.length) {
              if (tmp2.length > 1) {
                tmp = tmp2[0];
              }

              context.createPolygon(city, tmp);
              var myLatLng = context.getCenter(city, areacode.shape, tmp2);
              context.createMapLabel(city, myLatLng);
              context.polygonHoverListners(city);
              context.polygonClickListners(city);
            }
          });

          context.initialziSelected();
          context.checkForInnerPolygons();
        });
      }, function (response) {});
    },
    checkForInnerPolygons: function checkForInnerPolygons() {
      var _this7 = this;

      _.forEach(this.$store.getters.areaCodes, function (item) {
        if (item.zindex && item.polygon && item.mapLabel) {
          item.mapLabel.setZIndex(3);
          item.polygon.setOptions({ zIndex: 3 });
          if (item.area_code == 213) {
            item.mapLabel.setZIndex(3000);
            item.polygon.setOptions({ zIndex: 3000 });
          }
          return;
        } else {
          if (item.polygon && item.mapLabel) {
            var center = new google.maps.LatLng(item.mapLabel.getPosition().lat(), item.mapLabel.getPosition().lng());
            _.forEach(_this7.$store.getters.areaCodes, function (next_item) {
              if (item.area_code != next_item.area_code && next_item.polygon && center) {
                if (google.maps.geometry.poly.containsLocation(center, next_item.polygon)) {
                  item.mapLabel.setZIndex(2);
                  item.polygon.setOptions({ zIndex: 2 });
                }
              }
            });
          }
        }
      });
    },
    initialziSelected: function initialziSelected() {
      var _this8 = this;

      this.loading = false;

      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(this.$store.getters.selectedState);
      var area_codes = this.$store.getters.areaCodes;
      if (!selected_area) {
        return;
      }

      _.forEach(selected_area.area_codes, function (code) {
        if (!area_codes.length) {
          return;
        }
        var index = area_codes.findIndex(function (acode) {
          return acode.area_code == code.area_code;
        });
        if (index > -1 && area_codes[index].mapLabel) {
          area_codes[index].selected = true;
          area_codes[index].mapLabel.setContent("<div style='font-size:" + _this8.current_size + "px;' class='maplabel map_label_selected fs-1 text-center '>" + area_codes[index].display + "</div>");
          area_codes[index].polygon.setOptions({ fillColor: '#DF5435', strokeColor: '#DF5435' });
        }
      });
    },
    selectAreaCode: function selectAreaCode(state) {
      console.log('state', state);
      // console.log(city, this.$store.getters.selectedState)
      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(this.$store.getters.selectedState);
      if (selected_area && selected_area.filter_set_id) {
        selected_area.total_area_codes = this.$store.getters.areaCodes.length;
      }
      if (!selected_area) {
        selected_area = {
          filter_set_id: null,
          abbreviation: state.state,
          state: __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__["a" /* default */].getStateByAbbreviation(state.state),
          area_codes: [],
          total_area_codes: this.$store.getters.areaCodes.length
        };
        this.$store.dispatch('addSelectedArea', selected_area);
      }

      if (!selected_area.area_codes.length) {
        this.showUnselectHelperMsg();
      }

      selected_area.status = "Active";
      var index = _.findIndex(selected_area.area_codes, function (area) {
        return area.area_code == state.area_code;
      });
      if (index < 0) {
        selected_area.area_codes.push({
          area_code: state.area_code,
          zip_code: state.zipcode_list || state.zipcode,
          additional_areacodes: _.map(_.filter(state.additional_areacodes, ['flag', 'extra']), 'areacode')
        });

        _.forEach(_.filter(state.additional_areacodes, ['flag', 'true']), function (code) {
          selected_area.area_codes.push({
            area_code: code.areacode,
            zip_code: code.zipcode_list || []
          });
        });

        this.$store.commit('updateSelectedArea', selected_area);
      }
      state.selected = true;
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    unselectAreaCode: function unselectAreaCode(state) {
      //remove area code from list
      // this.$store.dispatch('removeAreaCode',city,this.$store.getters.selectedState)
      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(this.$store.getters.selectedState);
      console.log(state, "state");
      selected_area.area_codes = _.filter(selected_area.area_codes, function (next_item) {
        return next_item.area_code != state.area_code;
      });

      _.forEach(_.filter(state.additional_areacodes, ['flag', 'true']), function (code) {
        selected_area.area_codes = _.filter(selected_area.area_codes, function (next_item) {
          return next_item.area_code != code.areacode;
        });
      });

      this.$store.commit('updateSelectedArea', selected_area);
      if (!selected_area.area_codes.length) {
        this.$store.commit('removeSelectedArea', selected_area.abbreviation);
      }

      state.selected = false;
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    parsePolyStrings: function parsePolyStrings(ps) {
      var i,
          j,
          lat,
          lng,
          tmp,
          tmpArr,
          arr = [],

      //match '(' and ')' plus contents between them which contain anything other than '(' or ')'
      m = ps.match(/\([^\(\)]+\)/g);
      if (m !== null) {
        for (i = 0; i < m.length; i++) {
          //match all numeric strings
          tmp = m[i].match(/-?\d+\.?\d*/g);
          if (tmp !== null) {
            //convert all the coordinate sets in tmp from strings to Numbers and convert to LatLng objects
            for (j = 0, tmpArr = []; j < tmp.length; j += 2) {
              lng = Number(tmp[j]);
              lat = Number(tmp[j + 1]);
              tmpArr.push(new google.maps.LatLng(lat, lng));
            }
            arr.push(tmpArr);
          }
        }
      }
      //array of arrays of LatLng objects, or empty array
      return arr;
    },
    unselectEntireState: function unselectEntireState() {
      var state = this.$store.getters.selectedState;
      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(state);
      if (selected_area) {
        selected_area.status = "Not Active";
        selected_area.area_codes = [];
        this.$store.commit('updateSelectedArea', selected_area);
      } else {
        console.log("Not selected area found for the state");
      }

      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
      var context = this;
      _.forEach(this.$store.getters.areaCodes, function (city) {
        city.selected = false;
        if (city.mapLabel && city.polygon) {
          city.mapLabel.setContent("<div style='font-size:" + context.current_size + "px;' class='maplabel fs-1 text-center '>" + city.display + "</div>");
          city.polygon.setOptions({ fillColor: '#8A8E93', strokeColor: '#8A8E93', zIndex: 10 });
        }
      });
    },
    selectEntireState: function selectEntireState() {
      // _.forEach(this.$store.getters.areaCodes, (area_code)=>{
      //   this.$store.dispatch('addAreaCode', {city:area_code, selectedstate: this.$store.getters.selectedState})
      // })
      // this.initialziSelected()
      var state = this.$store.getters.selectedState;
      var is_new = false;
      var selected_area = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getSelectedArea(state);
      if (selected_area && selected_area.filter_set_id) {
        selected_area.total_area_codes = this.$store.getters.areaCodes.length;
      }

      if (!selected_area) {
        is_new = true;
        selected_area = {
          abbreviation: __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__["a" /* default */].getAbbreviationByState(state),
          state: state,
          area_codes: [],
          total_area_codes: this.$store.getters.areaCodes.length
        };
      }
      selected_area.status = "Active";
      selected_area.area_codes = [];

      _.forEach(this.$store.getters.areaCodes, function (next_item) {
        selected_area.area_codes.push({
          zip_code: next_item.zipcode,
          area_code: next_item.area_code
        });
        // this.$store.dispatch('addAreaCode', {"area_code": next_item, "state": this.$store.getters.selectedState})
      });

      if (is_new) {
        this.$store.dispatch('addSelectedArea', selected_area);
      } else {
        this.$store.commit('updateSelectedArea', selected_area);
      }

      this.initialziSelected();
      this.all_selected = selected_area.area_codes.length == selected_area.total_area_codes;
    },
    retriveStateData: function retriveStateData() {
      var _this9 = this;

      // let abbr = getAbbreviation()
      var state_abbr = __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__["a" /* default */].getAbbreviationByState(this.$store.getters.selectedState);

      this.$http.get('https://jockey.irelo.com/api/reporting/moving/map-counts/' + state_abbr + '?month=1').then(function (response) {
        _this9.stateData = response.data;
        console.log(_this9.stateData);
        // this.stateData.two_rooms_or_more_percentage = stateData.two_rooms_or_more/this.stateData.total_leads
      }).catch(function (error) {});
    },
    backToMap: function backToMap() {
      this.$router.push('/pickup/get-state');
    }
  }
});

/***/ }),

/***/ "Df45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader h-100"},[_c('svg',{attrs:{"version":"1.1","id":"dc-spinner","xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","width":"220","height":"220","viewBox":"0 0 38 38","preserveAspectRatio":"xMinYMin meet"}},[_c('text',{staticStyle:{"letter-spacing":"0.3","font-weight":"bold"},attrs:{"x":"11.5","y":"19","font-family":"Open Sans","font-size":"4px","fill":"white"}},[_vm._v("Loading\n     "),_c('animate',{attrs:{"attributeName":"opacity","values":"0;1;0","dur":"1.8s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('text',{staticStyle:{"letter-spacing":"0.3","font-weight":"bold"},attrs:{"x":"8.2","y":"24","font-family":"Open Sans","font-size":"4px","fill":"white"}},[_vm._v("Mover Map\n     "),_c('animate',{attrs:{"attributeName":"opacity","values":"0;1;0","dur":"1.8s","repeatCount":"indefinite"}})]),_vm._v(" "),_c('path',{attrs:{"fill":"#373a42","d":"M20,35c-8.271,0-15-6.729-15-15S11.729,5,20,5s15,6.729,15,15S28.271,35,20,35z M20,5.203\n    C11.841,5.203,5.203,11.841,5.203,20c0,8.159,6.638,14.797,14.797,14.797S34.797,28.159,34.797,20\n    C34.797,11.841,28.159,5.203,20,5.203z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#373a42","d":"M20,33.125c-7.237,0-13.125-5.888-13.125-13.125S12.763,6.875,20,6.875S33.125,12.763,33.125,20\n    S27.237,33.125,20,33.125z M20,7.078C12.875,7.078,7.078,12.875,7.078,20c0,7.125,5.797,12.922,12.922,12.922\n    S32.922,27.125,32.922,20C32.922,12.875,27.125,7.078,20,7.078z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#7FB847","stroke":"#7FB847","stroke-width":"0.6027","stroke-miterlimit":"10","d":"M5.203,20\n      c0-8.159,6.638-14.797,14.797-14.797V5C11.729,5,5,11.729,5,20s6.729,15,15,15v-0.203C11.841,34.797,5.203,28.159,5.203,20z"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","calcMode":"spline","keySplines":"0.4, 0, 0.2, 1","keyTimes":"0;1","dur":"2s","repeatCount":"indefinite"}})],1),_vm._v(" "),_c('path',{attrs:{"fill":"#859900","stroke":"#859900","stroke-width":"0.2027","stroke-miterlimit":"10","d":"M7.078,20\n  c0-7.125,5.797-12.922,12.922-12.922V6.875C12.763,6.875,6.875,12.763,6.875,20S12.763,33.125,20,33.125v-0.203\n  C12.875,32.922,7.078,27.125,7.078,20z"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"1.8s","repeatCount":"indefinite"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EyOh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F4Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_thankyou_script_js__ = __webpack_require__("MZMM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fca5722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_thankyou_template_html__ = __webpack_require__("teaw");
function injectStyle (ssrContext) {
  __webpack_require__("h46u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_thankyou_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fca5722_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_thankyou_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("0EFW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IIcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_script_js__ = __webpack_require__("4k7M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7074426f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_loader_template_html__ = __webpack_require__("Df45");
function injectStyle (ssrContext) {
  __webpack_require__("LQCu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7074426f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_loader_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_map__ = __webpack_require__("Zvfd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__("bREw");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		map: __WEBPACK_IMPORTED_MODULE_2__modules_map__["a" /* default */],
		user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */]
	}
}));

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("k0Yb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("vkIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jonm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_state_script_js__ = __webpack_require__("aa/Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8ad890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_state_template_html__ = __webpack_require__("skbe");
function injectStyle (ssrContext) {
  __webpack_require__("bhEM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_state_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8ad890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_state_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBoundaries; });
function getBoundaries() {
	return {
		'Alabama': [new google.maps.LatLng(34.984, -85.605), //  top right
		new google.maps.LatLng(32.864, -85.184), //  mid right
		new google.maps.LatLng(32.426, -84.964), new google.maps.LatLng(32.326, -85.006), new google.maps.LatLng(32.261, -84.889), new google.maps.LatLng(32.133, -85.062), new google.maps.LatLng(31.84, -85.141), new google.maps.LatLng(31.538, -85.041), new google.maps.LatLng(31.188, -85.108), new google.maps.LatLng(31, -85.002), //  bottom right
		new google.maps.LatLng(30.997, -87.598), //  bottom mid
		new google.maps.LatLng(30.846, -87.625), new google.maps.LatLng(30.655, -87.397), new google.maps.LatLng(30.466, -87.426), new google.maps.LatLng(30.348, -88.394), //  bottom left
		new google.maps.LatLng(31.894, -88.473), new google.maps.LatLng(32.732, -88.37), new google.maps.LatLng(32.747, -88.368), new google.maps.LatLng(34.892, -88.097), new google.maps.LatLng(34.995, -88.2) //  top left
		],
		'Arkansas': [new google.maps.LatLng(33.004, -91.166), //  bottom right
		new google.maps.LatLng(33.059, -91.121), new google.maps.LatLng(33.125, -91.201), new google.maps.LatLng(33.136, -91.093), new google.maps.LatLng(33.275, -91.043), new google.maps.LatLng(33.301, -91.141), new google.maps.LatLng(33.449, -91.059), new google.maps.LatLng(33.378, -91.148), new google.maps.LatLng(33.407, -91.209), new google.maps.LatLng(33.473, -91.125), new google.maps.LatLng(33.437, -91.231), new google.maps.LatLng(33.561, -91.23), new google.maps.LatLng(33.607, -91.129), new google.maps.LatLng(33.69, -91.222), new google.maps.LatLng(33.681, -91.037), new google.maps.LatLng(33.726, -91.14), new google.maps.LatLng(33.783, -90.986), new google.maps.LatLng(33.967, -91.09), new google.maps.LatLng(34.026, -90.893), new google.maps.LatLng(34.164, -90.927), new google.maps.LatLng(34.159, -90.809), new google.maps.LatLng(34.238, -90.934), new google.maps.LatLng(34.207, -90.848), new google.maps.LatLng(34.364, -90.762), new google.maps.LatLng(34.314, -90.661), new google.maps.LatLng(34.418, -90.573), new google.maps.LatLng(34.689, -90.569), new google.maps.LatLng(34.624, -90.535), new google.maps.LatLng(34.684, -90.461), new google.maps.LatLng(34.711, -90.567), new google.maps.LatLng(34.785, -90.547), new google.maps.LatLng(34.737, -90.459), new google.maps.LatLng(34.892, -90.464), new google.maps.LatLng(34.848, -90.306), new google.maps.LatLng(34.924, -90.241), new google.maps.LatLng(34.995, -90.308), //   bottom of tennessee border

		new google.maps.LatLng(35.139, -90.065), new google.maps.LatLng(35.265, -90.16), new google.maps.LatLng(35.277, -90.168), new google.maps.LatLng(35.386, -90.08), new google.maps.LatLng(35.421, -90.169), new google.maps.LatLng(35.429, -90.002), new google.maps.LatLng(35.547, -90.04), new google.maps.LatLng(35.514, -89.916), new google.maps.LatLng(35.592, -89.955), new google.maps.LatLng(35.639, -89.853), new google.maps.LatLng(35.729, -89.957), new google.maps.LatLng(35.814, -89.71), new google.maps.LatLng(35.909, -89.742), new google.maps.LatLng(35.892, -89.642), new google.maps.LatLng(36.001, -89.733), //  top right
		new google.maps.LatLng(35.996, -90.377), new google.maps.LatLng(36.303, -90.064), new google.maps.LatLng(36.497, -90.151), new google.maps.LatLng(36.499, -90.789), new google.maps.LatLng(36.499, -90.802), new google.maps.LatLng(36.499, -94.617), //  top left
		new google.maps.LatLng(35.398, -94.431), new google.maps.LatLng(33.637, -94.485), new google.maps.LatLng(33.545, -94.386), new google.maps.LatLng(33.551, -94.043), new google.maps.LatLng(33.019, -94.042) //  bottom left
		],
		'Arizona': [new google.maps.LatLng(37, -114.049), //  top left
		new google.maps.LatLng(36.194, -114.045), new google.maps.LatLng(36.016, -114.21), new google.maps.LatLng(36.142, -114.369), new google.maps.LatLng(36.103, -114.735), new google.maps.LatLng(35.804, -114.71), new google.maps.LatLng(35.79, -114.698), new google.maps.LatLng(35.181, -114.568), new google.maps.LatLng(35.001, -114.632), //  top of cali section
		new google.maps.LatLng(34.456, -114.384), new google.maps.LatLng(34.261, -114.129), new google.maps.LatLng(34.106, -114.415), new google.maps.LatLng(33.937, -114.533), new google.maps.LatLng(33.554, -114.524), new google.maps.LatLng(33.406, -114.723), new google.maps.LatLng(33.304, -114.73), new google.maps.LatLng(33.088, -114.706), new google.maps.LatLng(33.024, -114.51), new google.maps.LatLng(32.845, -114.469), new google.maps.LatLng(32.719, -114.718), //  bottom of cali section
		new google.maps.LatLng(32.619135, -114.809875), new google.maps.LatLng(32.488914, -114.807129), //  bottom left
		new google.maps.LatLng(31.332525, -111.071777), new google.maps.LatLng(31.332, -109.049), //  bottom right
		new google.maps.LatLng(34.96, -109.045), new google.maps.LatLng(36.002, -109.045), new google.maps.LatLng(36.999, -109.044) //  top right
		],
		'California': [new google.maps.LatLng(41.998284, -124.212112), //  top left
		new google.maps.LatLng(41.995, -119.998), //  top right
		new google.maps.LatLng(39, -120), new google.maps.LatLng(36.972, -117.166), new google.maps.LatLng(35.001, -114.632), //  top of AZ section
		new google.maps.LatLng(34.456, -114.384), new google.maps.LatLng(34.261, -114.129), new google.maps.LatLng(34.106, -114.415), new google.maps.LatLng(33.937, -114.533), new google.maps.LatLng(33.554, -114.524), new google.maps.LatLng(33.406, -114.723), new google.maps.LatLng(33.304, -114.73), new google.maps.LatLng(33.088, -114.706), new google.maps.LatLng(33.024, -114.51), new google.maps.LatLng(32.845, -114.469), new google.maps.LatLng(32.719, -114.718), //  bottom right
		new google.maps.LatLng(32.534151, -117.124472), //  bottom left
		new google.maps.LatLng(32.542255, -117.124729), new google.maps.LatLng(32.557665, -117.131081), new google.maps.LatLng(32.564971, -117.133055), new google.maps.LatLng(32.577051, -117.133226), new google.maps.LatLng(32.611978, -117.135544), new google.maps.LatLng(32.646891, -117.149792), new google.maps.LatLng(32.671677, -117.169619), new google.maps.LatLng(32.678396, -117.179918), new google.maps.LatLng(32.687137, -117.197256), new google.maps.LatLng(32.686631, -117.214079), new google.maps.LatLng(32.681782, -117.22351), new google.maps.LatLng(32.671279, -117.236223), new google.maps.LatLng(32.668425, -117.237082), new google.maps.LatLng(32.665716, -117.239184), new google.maps.LatLng(32.664813, -117.242746), new google.maps.LatLng(32.666366, -117.244678), new google.maps.LatLng(32.68273, -117.24957), new google.maps.LatLng(32.69204, -117.253422), new google.maps.LatLng(32.694803, -117.254237), new google.maps.LatLng(32.699353, -117.255642), new google.maps.LatLng(32.703488, -117.255739), new google.maps.LatLng(32.714782, -117.256629), new google.maps.LatLng(32.719584, -117.25738), new google.maps.LatLng(32.725361, -117.25841), new google.maps.LatLng(32.730613, -117.257359), new google.maps.LatLng(32.733357, -117.257445), new google.maps.LatLng(32.736218, -117.2562), new google.maps.LatLng(32.744963, -117.255621), new google.maps.LatLng(32.754185, -117.253132), new google.maps.LatLng(32.756151, -117.252402), new google.maps.LatLng(32.759003, -117.254119), new google.maps.LatLng(32.768819, -117.253218), new google.maps.LatLng(32.778651, -117.253625), new google.maps.LatLng(32.795825, -117.257102), new google.maps.LatLng(32.801759, -117.259698), //   palisades Park
		new google.maps.LatLng(32.807512, -117.264655), new google.maps.LatLng(32.807557, -117.26724), new google.maps.LatLng(32.807864, -117.267938), new google.maps.LatLng(32.814059, -117.273399), new google.maps.LatLng(32.815402, -117.274075), new google.maps.LatLng(32.817728, -117.273592), new google.maps.LatLng(32.818125, -117.27562), new google.maps.LatLng(32.81891, -117.276843), new google.maps.LatLng(32.820641, -117.279772), new google.maps.LatLng(32.82202, -117.281027), new google.maps.LatLng(32.827493, -117.28019), new google.maps.LatLng(32.832568, -117.28225), new google.maps.LatLng(32.847577, -117.278366), new google.maps.LatLng(32.870793, -117.253132), new google.maps.LatLng(32.915188, -117.258453), new google.maps.LatLng(32.959994, -117.268581), new google.maps.LatLng(32.989876, -117.27416), new google.maps.LatLng(33.077231, -117.310638), new google.maps.LatLng(33.195029, -117.385569), new google.maps.LatLng(33.347307, -117.524099), new google.maps.LatLng(33.382576, -117.589417), new google.maps.LatLng(33.385801, -117.595167), new google.maps.LatLng(33.434951, -117.637739), new google.maps.LatLng(33.459874, -117.715244), //   Dana Point Marine Life Refuge
		new google.maps.LatLng(33.553842, -117.819872), new google.maps.LatLng(33.606149, -117.928448), new google.maps.LatLng(33.686139, -118.039427), new google.maps.LatLng(33.729908, -118.090668), new google.maps.LatLng(33.723108, -118.136909), new google.maps.LatLng(33.723108, -118.206303), new google.maps.LatLng(33.7037, -118.267522), new google.maps.LatLng(33.705313, -118.28855), new google.maps.LatLng(33.704706, -118.294516), new google.maps.LatLng(33.713774, -118.317604), //   white point state park
		new google.maps.LatLng(33.727266, -118.35155), new google.maps.LatLng(33.736332, -118.369617), new google.maps.LatLng(33.736225, -118.398242), new google.maps.LatLng(33.741007, -118.411288), new google.maps.LatLng(33.751712, -118.414721), new google.maps.LatLng(33.763379, -118.42236), new google.maps.LatLng(33.766198, -118.423948), new google.maps.LatLng(33.773868, -118.428369), new google.maps.LatLng(33.782679, -118.422704), new google.maps.LatLng(33.788207, -118.414936), new google.maps.LatLng(33.796731, -118.408713), new google.maps.LatLng(33.800262, -118.404593), new google.maps.LatLng(33.802081, -118.400087), new google.maps.LatLng(33.815595, -118.391204), new google.maps.LatLng(33.834633, -118.390517), new google.maps.LatLng(33.849924, -118.400817), new google.maps.LatLng(33.855449, -118.400259), new google.maps.LatLng(33.867351, -118.404508), new google.maps.LatLng(33.894429, -118.418412), new google.maps.LatLng(33.925165, -118.434591), new google.maps.LatLng(33.950124, -118.448668), new google.maps.LatLng(33.960162, -118.455491), new google.maps.LatLng(33.964647, -118.459547), new google.maps.LatLng(33.975147, -118.465576), new google.maps.LatLng(33.983563, -118.472915), new google.maps.LatLng(33.985467, -118.476455), //  Venice Beach Park
		new google.maps.LatLng(33.990947, -118.479481), new google.maps.LatLng(34.003364, -118.490596), new google.maps.LatLng(34.011831, -118.501496), new google.maps.LatLng(34.025028, -118.517118), new google.maps.LatLng(34.027588, -118.521237), new google.maps.LatLng(34.032425, -118.530936), new google.maps.LatLng(34.036373, -118.540034), new google.maps.LatLng(34.037973, -118.54321), new google.maps.LatLng(34.038934, -118.54836), new google.maps.LatLng(34.037831, -118.554239), new google.maps.LatLng(34.037831, -118.555999), new google.maps.LatLng(34.041423, -118.56926), new google.maps.LatLng(34.039396, -118.576469), new google.maps.LatLng(34.037475, -118.58398), new google.maps.LatLng(34.039289, -118.593807), new google.maps.LatLng(34.038934, -118.600588), new google.maps.LatLng(34.03648, -118.609343), new google.maps.LatLng(34.0368, -118.615179), new google.maps.LatLng(34.036978, -118.626466), new google.maps.LatLng(34.036124, -118.636165), new google.maps.LatLng(34.037369, -118.649125), new google.maps.LatLng(34.038827, -118.668652), new google.maps.LatLng(34.036764, -118.676677), new google.maps.LatLng(34.034097, -118.67835), new google.maps.LatLng(34.032354, -118.67938), new google.maps.LatLng(34.03111, -118.68114), new google.maps.LatLng(34.030683, -118.683157), new google.maps.LatLng(34.032283, -118.695774), new google.maps.LatLng(34.029616, -118.705816), new google.maps.LatLng(34.029509, -118.70676), new google.maps.LatLng(34.031038, -118.719077), new google.maps.LatLng(34.031679, -118.723111), new google.maps.LatLng(34.032603, -118.739204), new google.maps.LatLng(34.031358, -118.74783), new google.maps.LatLng(34.025703, -118.756242), new google.maps.LatLng(34.024174, -118.77079), new google.maps.LatLng(34.021506, -118.783665), new google.maps.LatLng(34.011866, -118.792505), new google.maps.LatLng(34.008345, -118.793664), new google.maps.LatLng(34.006815, -118.794994), new google.maps.LatLng(34.005427, -118.80229), new google.maps.LatLng(34.000411, -118.805208), new google.maps.LatLng(34.000055, -118.806796), new google.maps.LatLng(34.001443, -118.808727), new google.maps.LatLng(34.026486, -118.83894), new google.maps.LatLng(34.039431, -118.89782), new google.maps.LatLng(34.041458, -118.915329), new google.maps.LatLng(34.045263, -118.945885), new google.maps.LatLng(34.051948, -118.964252), new google.maps.LatLng(34.069156, -119.012661), new google.maps.LatLng(34.085365, -119.061928), new google.maps.LatLng(34.096169, -119.082699), new google.maps.LatLng(34.094748, -119.110336), new google.maps.LatLng(34.100434, -119.131966), new google.maps.LatLng(34.130279, -119.176254), new google.maps.LatLng(34.14431, -119.210136), new google.maps.LatLng(34.145597, -119.216241), new google.maps.LatLng(34.15919, -119.229298), new google.maps.LatLng(34.186956, -119.243202), new google.maps.LatLng(34.394445, -119.726257), //   Santa Barbara
		new google.maps.LatLng(34.406839, -119.877577), new google.maps.LatLng(34.468071, -120.113697), new google.maps.LatLng(34.468071, -120.238323), new google.maps.LatLng(34.466655, -120.278149), new google.maps.LatLng(34.450237, -120.419941), new google.maps.LatLng(34.442168, -120.452385), new google.maps.LatLng(34.448113, -120.471439), new google.maps.LatLng(34.46708, -120.474186), new google.maps.LatLng(34.495522, -120.496674), new google.maps.LatLng(34.516458, -120.50663), new google.maps.LatLng(34.541207, -120.553493), new google.maps.LatLng(34.556194, -120.585766), new google.maps.LatLng(34.553508, -120.623531), new google.maps.LatLng(34.56298, -120.638981), new google.maps.LatLng(34.576974, -120.650654), //  Arguello
		new google.maps.LatLng(34.624168, -120.631342), new google.maps.LatLng(34.684817, -120.606108), new google.maps.LatLng(34.696743, -120.602245), new google.maps.LatLng(34.708669, -120.601773), new google.maps.LatLng(34.714595, -120.607395), new google.maps.LatLng(34.723167, -120.612073), new google.maps.LatLng(34.734877, -120.619197), new google.maps.LatLng(34.73791, -120.62602), new google.maps.LatLng(34.744434, -120.630355), new google.maps.LatLng(34.751028, -120.630956), new google.maps.LatLng(34.755999, -120.637693), new google.maps.LatLng(34.811619, -120.617952), new google.maps.LatLng(34.85875, -120.611515), new google.maps.LatLng(34.873679, -120.628166), new google.maps.LatLng(34.880439, -120.639324), new google.maps.LatLng(34.89283, -120.642672), new google.maps.LatLng(34.899237, -120.645075), new google.maps.LatLng(34.901771, -120.670652), new google.maps.LatLng(34.902967, -120.671682), new google.maps.LatLng(34.930134, -120.666704), new google.maps.LatLng(34.963482, -120.652971), new google.maps.LatLng(35.012143, -120.637951), new google.maps.LatLng(35.055224, -120.630827), new google.maps.LatLng(35.098844, -120.630569), new google.maps.LatLng(35.128403, -120.638208), new google.maps.LatLng(35.146021, -120.649796), new google.maps.LatLng(35.152618, -120.673656), new google.maps.LatLng(35.159846, -120.687046), new google.maps.LatLng(35.172826, -120.704041), new google.maps.LatLng(35.175071, -120.726013), new google.maps.LatLng(35.175562, -120.753136), new google.maps.LatLng(35.155776, -120.749531), new google.maps.LatLng(35.159775, -120.759573), new google.maps.LatLng(35.186155, -120.807724), new google.maps.LatLng(35.234403, -120.884628), new google.maps.LatLng(35.255432, -120.899391), new google.maps.LatLng(35.369735, -120.870037), //  morro bay
		new google.maps.LatLng(35.434379, -120.887375), new google.maps.LatLng(35.46067, -121.005478), new google.maps.LatLng(35.663991, -121.284943), new google.maps.LatLng(35.885712, -121.461411), new google.maps.LatLng(36.020781, -121.571274), new google.maps.LatLng(36.232643, -121.812286), new google.maps.LatLng(36.302987, -121.899662), new google.maps.LatLng(36.307241, -121.902752), new google.maps.LatLng(36.354951, -121.907043), new google.maps.LatLng(36.581349, -121.977768), new google.maps.LatLng(36.636468, -121.935196), new google.maps.LatLng(36.786192, -121.79512), new google.maps.LatLng(36.950441, -121.881638), new google.maps.LatLng(36.949892, -122.027206), //  Santa Cruz
		new google.maps.LatLng(36.975678, -122.153549), new google.maps.LatLng(37.089692, -122.275772), new google.maps.LatLng(37.112693, -122.330704), new google.maps.LatLng(37.118716, -122.338257), new google.maps.LatLng(37.148277, -122.358856), new google.maps.LatLng(37.195878, -122.405548), new google.maps.LatLng(37.245635, -122.419281), new google.maps.LatLng(37.439974, -122.444687), new google.maps.LatLng(37.483577, -122.453613), new google.maps.LatLng(37.496652, -122.500992), new google.maps.LatLng(37.534777, -122.520905), new google.maps.LatLng(37.594104, -122.518158), new google.maps.LatLng(37.782112, -122.512665), //  Sea Cliff
		new google.maps.LatLng(37.837988, -122.549744), new google.maps.LatLng(37.859134, -122.585449), new google.maps.LatLng(37.881899, -122.628021), new google.maps.LatLng(37.89653, -122.641068), new google.maps.LatLng(37.893279, -122.704926), new google.maps.LatLng(37.903574, -122.726212), new google.maps.LatLng(37.947446, -122.781143), new google.maps.LatLng(38.028352, -122.908173), new google.maps.LatLng(37.989804, -122.964478), new google.maps.LatLng(37.991834, -122.995205), new google.maps.LatLng(37.99508, -123.024044), new google.maps.LatLng(38.23818, -122.994003), new google.maps.LatLng(38.322266, -123.076401), new google.maps.LatLng(38.425084, -123.118286), new google.maps.LatLng(38.565616, -123.333206), new google.maps.LatLng(38.848264, -123.648376), new google.maps.LatLng(38.954069, -123.739014), new google.maps.LatLng(39.451571, -123.814545), new google.maps.LatLng(39.726729, -123.832054), new google.maps.LatLng(39.867588, -123.909302), new google.maps.LatLng(40.028666, -124.07959), //  Shelter Cove Airport
		new google.maps.LatLng(40.261451, -124.363518), new google.maps.LatLng(40.440154, -124.409351), new google.maps.LatLng(40.652513, -124.308243), new google.maps.LatLng(40.713826, -124.263439), new google.maps.LatLng(40.791459, -124.211769), new google.maps.LatLng(40.922852, -124.138641), new google.maps.LatLng(41.046864, -124.125595), new google.maps.LatLng(41.051007, -124.150143), new google.maps.LatLng(41.053207, -124.153233), new google.maps.LatLng(41.072493, -124.159241), new google.maps.LatLng(41.101604, -124.162846), new google.maps.LatLng(41.141174, -124.161816), //  Patricks Point State Park
		new google.maps.LatLng(41.235995, -124.108772), //  Dry Lagoon State Park
		new google.maps.LatLng(41.451991, -124.0662), new google.maps.LatLng(41.509863, -124.081306), new google.maps.LatLng(41.524435, -124.084976), new google.maps.LatLng(41.53621, -124.082165), new google.maps.LatLng(41.545878, -124.082379), new google.maps.LatLng(41.548255, -124.083066), new google.maps.LatLng(41.551081, -124.088817), new google.maps.LatLng(41.553072, -124.092336), new google.maps.LatLng(41.560683, -124.096584), new google.maps.LatLng(41.563926, -124.098902), new google.maps.LatLng(41.569064, -124.101133), new google.maps.LatLng(41.571247, -124.101562), new google.maps.LatLng(41.574297, -124.102292), new google.maps.LatLng(41.579113, -124.102206), new google.maps.LatLng(41.579594, -124.101863), new google.maps.LatLng(41.583511, -124.098601), new google.maps.LatLng(41.588935, -124.101348), new google.maps.LatLng(41.591054, -124.102378), new google.maps.LatLng(41.594295, -124.104867), new google.maps.LatLng(41.594777, -124.104695), new google.maps.LatLng(41.600281, -124.100833), new google.maps.LatLng(41.605872, -124.104728), new google.maps.LatLng(41.606739, -124.105403), new google.maps.LatLng(41.611432, -124.109159), new google.maps.LatLng(41.614127, -124.111401), new google.maps.LatLng(41.614961, -124.11581), new google.maps.LatLng(41.61525, -124.115896), new google.maps.LatLng(41.621089, -124.11551), new google.maps.LatLng(41.621859, -124.115725), new google.maps.LatLng(41.622565, -124.11581), new google.maps.LatLng(41.628724, -124.115982), new google.maps.LatLng(41.630777, -124.116883), new google.maps.LatLng(41.632637, -124.118686), new google.maps.LatLng(41.634049, -124.119501), new google.maps.LatLng(41.639052, -124.11963), new google.maps.LatLng(41.642035, -124.121432), new google.maps.LatLng(41.643382, -124.122934), new google.maps.LatLng(41.645562, -124.124007), new google.maps.LatLng(41.646396, -124.125423), new google.maps.LatLng(41.648641, -124.126797), new google.maps.LatLng(41.651335, -124.127827), new google.maps.LatLng(41.652906, -124.130015), new google.maps.LatLng(41.656433, -124.134521), new google.maps.LatLng(41.657427, -124.135466), new google.maps.LatLng(41.666917, -124.13847), new google.maps.LatLng(41.668616, -124.138513), new google.maps.LatLng(41.671245, -124.138598), new google.maps.LatLng(41.672078, -124.140916), new google.maps.LatLng(41.672719, -124.141173), new google.maps.LatLng(41.675188, -124.139371), new google.maps.LatLng(41.676983, -124.138298), new google.maps.LatLng(41.680509, -124.138598), new google.maps.LatLng(41.681502, -124.139585), new google.maps.LatLng(41.682784, -124.14083), new google.maps.LatLng(41.687912, -124.143534), new google.maps.LatLng(41.691149, -124.143233), new google.maps.LatLng(41.696436, -124.143877), new google.maps.LatLng(41.696661, -124.143491), new google.maps.LatLng(41.707074, -124.144778), new google.maps.LatLng(41.713033, -124.145207), new google.maps.LatLng(41.716845, -124.147053), new google.maps.LatLng(41.724693, -124.151816), new google.maps.LatLng(41.740354, -124.165421), new google.maps.LatLng(41.743684, -124.171), new google.maps.LatLng(41.745221, -124.176621), new google.maps.LatLng(41.745765, -124.177952), new google.maps.LatLng(41.739585, -124.183574), new google.maps.LatLng(41.736159, -124.190998), new google.maps.LatLng(41.736735, -124.194775), new google.maps.LatLng(41.745509, -124.200697), new google.maps.LatLng(41.746149, -124.203186), new google.maps.LatLng(41.748263, -124.206362), new google.maps.LatLng(41.749928, -124.212027), new google.maps.LatLng(41.750632, -124.215202), new google.maps.LatLng(41.750696, -124.216146), new google.maps.LatLng(41.7514, -124.216404), new google.maps.LatLng(41.751849, -124.215031), new google.maps.LatLng(41.753706, -124.215374), new google.maps.LatLng(41.755498, -124.22061), new google.maps.LatLng(41.756459, -124.222069), new google.maps.LatLng(41.757099, -124.222155), new google.maps.LatLng(41.762605, -124.227648), new google.maps.LatLng(41.767407, -124.235973), new google.maps.LatLng(41.77208, -124.242496), new google.maps.LatLng(41.770415, -124.246616), new google.maps.LatLng(41.7708, -124.247732), new google.maps.LatLng(41.771632, -124.249449), new google.maps.LatLng(41.770095, -124.252796), new google.maps.LatLng(41.770864, -124.254255), new google.maps.LatLng(41.776817, -124.251165), new google.maps.LatLng(41.778353, -124.254684), new google.maps.LatLng(41.781553, -124.255199), new google.maps.LatLng(41.782961, -124.2558), new google.maps.LatLng(41.785201, -124.254341), new google.maps.LatLng(41.813291, -124.233055), new google.maps.LatLng(41.83702, -124.22267), new google.maps.LatLng(41.884515, -124.209795), new google.maps.LatLng(41.894611, -124.207478), new google.maps.LatLng(41.904257, -124.206619), new google.maps.LatLng(41.912625, -124.205675), new google.maps.LatLng(41.920098, -124.204817), new google.maps.LatLng(41.927633, -124.204903), new google.maps.LatLng(41.932231, -124.204731), new google.maps.LatLng(41.937403, -124.203701), new google.maps.LatLng(41.945447, -124.204903), new google.maps.LatLng(41.94583, -124.207478), new google.maps.LatLng(41.94583, -124.216404), new google.maps.LatLng(41.951065, -124.217091), new google.maps.LatLng(41.971743, -124.205246), new google.maps.LatLng(41.989226, -124.208851), new google.maps.LatLng(41.998284, -124.212112) //  top left
		],
		'Colorado': [new google.maps.LatLng(36.999, -109.044), //  bottom left
		new google.maps.LatLng(37, -103.001), new google.maps.LatLng(36.993, -102.041), //  bottom right
		new google.maps.LatLng(41.002, -102.051), //  top right
		new google.maps.LatLng(41, -109.049) //  top left
		],
		'Connecticut': [new google.maps.LatLng(41.423, -71.798), //   bottom right
		new google.maps.LatLng(42.008, -71.8), //   top of RI section
		new google.maps.LatLng(42.023, -71.8), //   top right
		new google.maps.LatLng(42.049, -73.488), //   top left
		new google.maps.LatLng(41.295, -73.551), new google.maps.LatLng(41.212, -73.482), new google.maps.LatLng(41.101, -73.728), new google.maps.LatLng(40.991, -73.659) //   bottom left
		],
		'Delaware': [new google.maps.LatLng(38.78781, -75.012589), //  bottom of NJ border
		new google.maps.LatLng(39.057584, -75.168457), new google.maps.LatLng(39.076776, -75.18837), new google.maps.LatLng(39.250334, -75.319519), new google.maps.LatLng(39.384202, -75.478134), new google.maps.LatLng(39.455282, -75.559845), new google.maps.LatLng(39.496093, -75.559158), new google.maps.LatLng(39.497153, -75.528259), new google.maps.LatLng(39.541117, -75.532379), new google.maps.LatLng(39.563353, -75.513153), new google.maps.LatLng(39.606217, -75.557098), new google.maps.LatLng(39.630019, -75.559845), new google.maps.LatLng(39.697149, -75.506973), new google.maps.LatLng(39.763158, -75.461655), new google.maps.LatLng(39.777408, -75.448608), new google.maps.LatLng(39.796403, -75.404663), new google.maps.LatLng(39.802, -75.415), //  bottom of PA border
		new google.maps.LatLng(39.795876, -75.405006), // top right
		new google.maps.LatLng(39.802, -75.415), new google.maps.LatLng(39.820667, -75.454102), new google.maps.LatLng(39.837805, -75.526886), new google.maps.LatLng(39.83675, -75.59967), new google.maps.LatLng(39.82304, -75.657692), new google.maps.LatLng(39.807, -75.693), new google.maps.LatLng(39.788, -75.721), new google.maps.LatLng(39.721, -75.789), //  top left
		new google.maps.LatLng(38.46, -75.693), new google.maps.LatLng(38.451, -75.093), new google.maps.LatLng(38.451, -75.058), new google.maps.LatLng(38.451, -75.049) //  bottom right
		],
		'District of Columbia': [new google.maps.LatLng(38.9343, -77.1198), new google.maps.LatLng(38.9954, -77.041), new google.maps.LatLng(38.8929, -76.9096), new google.maps.LatLng(38.7917, -77.039), new google.maps.LatLng(38.8148, -77.0374), new google.maps.LatLng(38.8242, -77.0389), new google.maps.LatLng(38.8322, -77.0373), new google.maps.LatLng(38.8592, -77.0263), new google.maps.LatLng(38.88, -77.0463), new google.maps.LatLng(38.9297, -77.1164)],
		'Florida': [new google.maps.LatLng(30.727, -81.494), //  top right
		new google.maps.LatLng(30.791, -82.016), new google.maps.LatLng(30.374, -82.037), new google.maps.LatLng(30.358, -82.16), new google.maps.LatLng(30.568, -82.215), new google.maps.LatLng(30.711, -84.864), new google.maps.LatLng(31, -85.002), //  left side of GA border
		new google.maps.LatLng(30.997, -87.598), //  top left
		new google.maps.LatLng(30.846, -87.625), new google.maps.LatLng(30.655, -87.397), new google.maps.LatLng(30.466, -87.426), //  bottom left of panhandle

		// Coastline
		new google.maps.LatLng(30.447194, -87.370834), new google.maps.LatLng(30.441422, -87.367229), new google.maps.LatLng(30.435354, -87.367229), new google.maps.LatLng(30.431062, -87.370491), new google.maps.LatLng(30.41774, -87.394695), new google.maps.LatLng(30.409449, -87.404652), new google.maps.LatLng(30.410042, -87.424049), new google.maps.LatLng(30.397753, -87.434006), new google.maps.LatLng(30.390498, -87.441044), new google.maps.LatLng(30.382057, -87.438641), new google.maps.LatLng(30.368284, -87.450485), new google.maps.LatLng(30.346361, -87.450829), new google.maps.LatLng(30.334065, -87.462845), new google.maps.LatLng(30.328138, -87.501469), new google.maps.LatLng(30.323545, -87.504902), new google.maps.LatLng(30.309171, -87.50473), new google.maps.LatLng(30.304873, -87.491169), new google.maps.LatLng(30.310949, -87.450314), new google.maps.LatLng(30.300427, -87.452545), new google.maps.LatLng(30.287976, -87.500095), new google.maps.LatLng(30.283974, -87.518291), new google.maps.LatLng(30.278786, -87.51812), new google.maps.LatLng(30.297611, -87.419243), //  Gulf Islands National Seashore
		new google.maps.LatLng(30.319248, -87.313843), new google.maps.LatLng(30.315543, -87.268696), new google.maps.LatLng(30.320878, -87.204494), new google.maps.LatLng(30.354065, -87.012749), new google.maps.LatLng(30.378947, -86.861), new google.maps.LatLng(30.389757, -86.765556), new google.maps.LatLng(30.395088, -86.676464), new google.maps.LatLng(30.392867, -86.594582), new google.maps.LatLng(30.380724, -86.510811), new google.maps.LatLng(30.38028, -86.504631), new google.maps.LatLng(30.382797, -86.454506), new google.maps.LatLng(30.375393, -86.377258), new google.maps.LatLng(30.36621, -86.317005), new google.maps.LatLng(30.329324, -86.174355), new google.maps.LatLng(30.29598, -86.070671), new google.maps.LatLng(30.270484, -86.00029), new google.maps.LatLng(30.235934, -85.919609), new google.maps.LatLng(30.166946, -85.792923), //  Panama City Beach
		new google.maps.LatLng(30.136517, -85.750179), new google.maps.LatLng(30.12167, -85.733185), new google.maps.LatLng(30.117809, -85.729408), new google.maps.LatLng(30.093603, -85.690956), new google.maps.LatLng(30.052008, -85.594139), new google.maps.LatLng(30.033433, -85.578346), new google.maps.LatLng(30.008166, -85.551567), new google.maps.LatLng(29.995678, -85.539894), new google.maps.LatLng(29.978729, -85.519123), new google.maps.LatLng(29.960884, -85.489597), new google.maps.LatLng(29.957165, -85.47226), new google.maps.LatLng(29.958207, -85.461617), new google.maps.LatLng(29.949878, -85.430717), new google.maps.LatLng(29.942887, -85.412521), new google.maps.LatLng(29.893341, -85.36068), new google.maps.LatLng(29.876672, -85.390205), new google.maps.LatLng(29.866549, -85.406942), new google.maps.LatLng(29.859925, -85.411835), new google.maps.LatLng(29.83506, -85.4181), new google.maps.LatLng(29.816668, -85.416727), new google.maps.LatLng(29.785833, -85.411062), new google.maps.LatLng(29.759385, -85.403938), new google.maps.LatLng(29.731067, -85.394068), new google.maps.LatLng(29.707139, -85.384111), new google.maps.LatLng(29.682535, -85.370035), new google.maps.LatLng(29.660833, -85.353041), new google.maps.LatLng(29.656283, -85.346861), new google.maps.LatLng(29.657253, -85.345058), new google.maps.LatLng(29.66844, -85.346947), new google.maps.LatLng(29.683728, -85.302057), new google.maps.LatLng(29.682237, -85.26721), new google.maps.LatLng(29.676346, -85.242405), new google.maps.LatLng(29.675973, -85.21966), new google.maps.LatLng(29.653822, -85.168505), new google.maps.LatLng(29.637411, -85.146189), new google.maps.LatLng(29.630473, -85.132713), new google.maps.LatLng(29.628235, -85.123272), new google.maps.LatLng(29.623609, -85.098124), new google.maps.LatLng(29.585699, -85.051003), //  (less detail after this point)
		new google.maps.LatLng(29.628981, -84.91024), new google.maps.LatLng(29.897657, -84.345989), new google.maps.LatLng(29.900782, -84.341354), new google.maps.LatLng(29.923845, -84.331741), new google.maps.LatLng(29.971294, -84.330368), new google.maps.LatLng(30.070282, -84.166946), new google.maps.LatLng(30.067905, -83.997345), //  big cove
		new google.maps.LatLng(29.970104, -83.83049), new google.maps.LatLng(29.757821, -83.586044), new google.maps.LatLng(29.673735, -83.455582), new google.maps.LatLng(29.501769, -83.404083), new google.maps.LatLng(29.428235, -83.2901), new google.maps.LatLng(29.288196, -83.169937), new google.maps.LatLng(29.090377, -83.082733), new google.maps.LatLng(28.940261, -82.779236), new google.maps.LatLng(28.7207, -82.746964), //  homosassa Bay
		new google.maps.LatLng(28.572462, -82.665253), new google.maps.LatLng(28.401065, -82.718811), new google.maps.LatLng(28.21487, -82.86026), new google.maps.LatLng(27.84879, -82.86026), //  Indian Shores
		new google.maps.LatLng(27.527758, -82.757263), new google.maps.LatLng(27.046895, -82.451019), new google.maps.LatLng(26.784847, -82.279358), new google.maps.LatLng(26.667096, -82.271118), new google.maps.LatLng(26.464426, -82.184601), new google.maps.LatLng(26.431228, -82.147522), new google.maps.LatLng(26.41524, -82.081604), new google.maps.LatLng(26.436147, -81.959381), // Fort Myers Beach
		new google.maps.LatLng(26.256473, -81.839905), new google.maps.LatLng(26.093788, -81.815186), new google.maps.LatLng(25.839449, -81.698456), new google.maps.LatLng(25.688563, -81.363373), new google.maps.LatLng(25.226063, -81.186218), new google.maps.LatLng(25.147771, -81.151886), new google.maps.LatLng(25.10301, -81.090088), new google.maps.LatLng(25.010951, -80.776978), new google.maps.LatLng(25.060721, -80.419922), //  Key Largo
		new google.maps.LatLng(25.438314, -80.128784), new google.maps.LatLng(25.815963, -80.106812), // Miami Beach
		new google.maps.LatLng(26.832649, -80.005188), // North Palm Beach
		new google.maps.LatLng(27.927687, -80.399323), new google.maps.LatLng(28.455411, -80.500946), new google.maps.LatLng(28.591757, -80.550385), new google.maps.LatLng(29.602118, -81.12854), new google.maps.LatLng(30.168876, -81.318054), new google.maps.LatLng(30.704058, -81.400452)],
		'Georgia': [new google.maps.LatLng(32.032964, -80.837059), //  coast ( bottom tip of SC)
		new google.maps.LatLng(32.099299, -81.081333), //  savannah area
		new google.maps.LatLng(32.226, -81.144), new google.maps.LatLng(32.464, -81.186), new google.maps.LatLng(32.628, -81.418), new google.maps.LatLng(33.01, -81.495), new google.maps.LatLng(33.147, -81.751), new google.maps.LatLng(33.347, -81.94), new google.maps.LatLng(33.465, -81.929), new google.maps.LatLng(33.945, -82.557), new google.maps.LatLng(34.474, -82.877), new google.maps.LatLng(34.682, -83.342), new google.maps.LatLng(35, -83.108), //  top right
		new google.maps.LatLng(34.988, -84.322), //  left side of NC segment
		new google.maps.LatLng(34.984, -85.605), //  top left
		new google.maps.LatLng(32.864, -85.184), new google.maps.LatLng(32.426, -84.964), new google.maps.LatLng(32.326, -85.006), new google.maps.LatLng(32.261, -84.889), new google.maps.LatLng(32.133, -85.062), new google.maps.LatLng(31.84, -85.141), new google.maps.LatLng(31.538, -85.041), new google.maps.LatLng(31.188, -85.108), new google.maps.LatLng(31, -85.002), //  bottom of AL border
		new google.maps.LatLng(31, -85.002), //  bottom left
		new google.maps.LatLng(30.711, -84.864), new google.maps.LatLng(30.568, -82.215), new google.maps.LatLng(30.358, -82.16), new google.maps.LatLng(30.374, -82.037), new google.maps.LatLng(30.791, -82.016), new google.maps.LatLng(30.727, -81.494) //  bottom right
		],
		'Idaho': [new google.maps.LatLng(48.9991, -117.0323), //  top left
		new google.maps.LatLng(48.999, -117.031), new google.maps.LatLng(46.354, -117.06), new google.maps.LatLng(46.168, -116.921), new google.maps.LatLng(46.088, -116.981), new google.maps.LatLng(45.995, -116.914), //  top of OR border
		new google.maps.LatLng(45.824, -116.779), new google.maps.LatLng(45.752, -116.547), new google.maps.LatLng(45.603, -116.462), new google.maps.LatLng(45.025, -116.844), new google.maps.LatLng(44.881, -116.855), new google.maps.LatLng(44.727, -117.06), new google.maps.LatLng(44.393, -117.241), new google.maps.LatLng(44.273, -117.196), new google.maps.LatLng(44.17, -116.894), new google.maps.LatLng(43.83, -117.031), new google.maps.LatLng(42.002, -117.024), //  bottom left
		new google.maps.LatLng(41.994, -114.04), //  left of UT border
		new google.maps.LatLng(42.001, -111.045), //  bottom right
		new google.maps.LatLng(44.475, -111.052), //  bottom of MT border
		new google.maps.LatLng(44.755, -111.383), new google.maps.LatLng(44.643, -111.514), new google.maps.LatLng(44.541, -111.471), new google.maps.LatLng(44.569, -112.284), new google.maps.LatLng(44.45, -112.383), new google.maps.LatLng(44.485, -112.778), new google.maps.LatLng(44.359, -112.854), new google.maps.LatLng(44.453, -113.004), new google.maps.LatLng(44.774, -113.135), new google.maps.LatLng(44.864, -113.451), new google.maps.LatLng(45.058, -113.45), new google.maps.LatLng(45.26, -113.689), new google.maps.LatLng(45.603, -113.807), new google.maps.LatLng(45.696, -113.937), new google.maps.LatLng(45.459, -114.332), new google.maps.LatLng(45.558, -114.563), new google.maps.LatLng(45.704, -114.495), new google.maps.LatLng(45.777, -114.562), new google.maps.LatLng(45.885, -114.386), new google.maps.LatLng(46.147, -114.525), new google.maps.LatLng(46.172, -114.444), new google.maps.LatLng(46.647, -114.319), new google.maps.LatLng(46.7, -114.769), new google.maps.LatLng(47.253, -115.317), new google.maps.LatLng(47.427, -115.756), new google.maps.LatLng(47.48, -115.627), new google.maps.LatLng(47.55, -115.754), new google.maps.LatLng(47.696, -115.723), new google.maps.LatLng(47.978, -116.047), new google.maps.LatLng(49, -116.048) //  top right
		],
		'Illinois': [new google.maps.LatLng(42.492, -87.802), //  top right of land border
		new google.maps.LatLng(42.495, -88.94), new google.maps.LatLng(42.508, -90.64), //  top left
		new google.maps.LatLng(42.35, -90.44), new google.maps.LatLng(42.336, -90.428), new google.maps.LatLng(42.288, -90.427), new google.maps.LatLng(42.281, -90.43), new google.maps.LatLng(42.112, -90.161), new google.maps.LatLng(41.808, -90.181), new google.maps.LatLng(41.522, -90.462), new google.maps.LatLng(41.412, -91.046), new google.maps.LatLng(41.242, -91.113), new google.maps.LatLng(41.1, -90.948), new google.maps.LatLng(40.953, -90.952), new google.maps.LatLng(40.67, -91.123), new google.maps.LatLng(40.557, -91.402), new google.maps.LatLng(40.378, -91.419), //  bottom of IA border
		new google.maps.LatLng(40.125, -91.51), new google.maps.LatLng(39.728, -91.367), new google.maps.LatLng(39.257, -90.731), new google.maps.LatLng(38.888, -90.625), new google.maps.LatLng(38.967, -90.451), new google.maps.LatLng(38.844, -90.109), new google.maps.LatLng(38.326, -90.373), new google.maps.LatLng(38.212, -90.351), new google.maps.LatLng(37.958, -89.925), new google.maps.LatLng(37.88, -89.949), new google.maps.LatLng(37.903, -89.839), new google.maps.LatLng(37.693, -89.517), new google.maps.LatLng(37.387, -89.421), new google.maps.LatLng(37.261, -89.522), new google.maps.LatLng(37.038, -89.376), new google.maps.LatLng(36.989, -89.276), new google.maps.LatLng(37.072, -89.254), new google.maps.LatLng(36.982, -89.133), //  bottom of MO border
		new google.maps.LatLng(37.067, -89.173), new google.maps.LatLng(37.224, -89.17), new google.maps.LatLng(37.159, -88.761), new google.maps.LatLng(37.145, -88.735), new google.maps.LatLng(37.075, -88.459), new google.maps.LatLng(37.391, -88.474), new google.maps.LatLng(37.488, -88.065), new google.maps.LatLng(37.656, -88.16), new google.maps.LatLng(37.799, -88.027), //  top of KY border
		new google.maps.LatLng(37.901, -88.097), new google.maps.LatLng(37.891, -88.014), new google.maps.LatLng(38.046, -88.042), new google.maps.LatLng(38.162, -87.911), new google.maps.LatLng(38.256, -87.988), new google.maps.LatLng(38.28, -87.841), new google.maps.LatLng(38.739, -87.496), new google.maps.LatLng(38.952, -87.512), new google.maps.LatLng(39.136, -87.658), new google.maps.LatLng(39.348, -87.531), new google.maps.LatLng(41.712, -87.524) //  top of left part of IN border
		],
		'Indiana': [new google.maps.LatLng(41.696, -84.806), //  top of OH border
		new google.maps.LatLng(39.105, -84.819), //  bottom right
		new google.maps.LatLng(39.055, -84.897), new google.maps.LatLng(38.785, -84.813), new google.maps.LatLng(38.688, -85.171), new google.maps.LatLng(38.728, -85.435), new google.maps.LatLng(38.715, -85.447), new google.maps.LatLng(38.534, -85.421), new google.maps.LatLng(38.299, -85.677), new google.maps.LatLng(38.278, -85.826), new google.maps.LatLng(38.025, -85.923), new google.maps.LatLng(37.958, -86.039), new google.maps.LatLng(38.056, -86.266), new google.maps.LatLng(38.198, -86.362), new google.maps.LatLng(38.138, -86.324), new google.maps.LatLng(38.121, -86.46), new google.maps.LatLng(37.927, -86.509), new google.maps.LatLng(37.843, -86.637), new google.maps.LatLng(37.999, -86.816), new google.maps.LatLng(37.782, -87.111), new google.maps.LatLng(37.976, -87.589), new google.maps.LatLng(37.833, -87.613), new google.maps.LatLng(37.928, -87.893), new google.maps.LatLng(37.807, -87.907), new google.maps.LatLng(37.799, -88.027), //  bottom left
		new google.maps.LatLng(37.901, -88.097), new google.maps.LatLng(37.891, -88.014), new google.maps.LatLng(38.046, -88.042), new google.maps.LatLng(38.162, -87.911), new google.maps.LatLng(38.256, -87.988), new google.maps.LatLng(38.28, -87.841), new google.maps.LatLng(38.739, -87.496), new google.maps.LatLng(38.952, -87.512), new google.maps.LatLng(39.136, -87.658), new google.maps.LatLng(39.348, -87.531), new google.maps.LatLng(41.712, -87.524), //  top left
		new google.maps.LatLng(41.76, -86.825), new google.maps.LatLng(41.76, -84.806) //  top right
		],
		'Iowa': [new google.maps.LatLng(43.5, -96.453), //  top left
		new google.maps.LatLng(43.5, -96.598), new google.maps.LatLng(43.385, -96.52), new google.maps.LatLng(43.269, -96.585), new google.maps.LatLng(43.12, -96.436), new google.maps.LatLng(42.737, -96.637), new google.maps.LatLng(42.489, -96.443), //  top of NE border
		new google.maps.LatLng(42.167, -96.347), new google.maps.LatLng(41.798, -96.066), new google.maps.LatLng(41.608, -96.116), new google.maps.LatLng(41.601, -96.113), new google.maps.LatLng(41.452, -95.919), new google.maps.LatLng(41.346, -95.957), new google.maps.LatLng(41.302, -95.872), new google.maps.LatLng(41.201, -95.927), new google.maps.LatLng(41.177, -95.841), new google.maps.LatLng(40.895, -95.809), new google.maps.LatLng(40.734, -95.888), new google.maps.LatLng(40.585, -95.765), //  bottom left
		new google.maps.LatLng(40.614, -91.728), new google.maps.LatLng(40.403, -91.505), new google.maps.LatLng(40.4, -91.5), new google.maps.LatLng(40.378, -91.419), //  bottom right
		new google.maps.LatLng(40.557, -91.402), new google.maps.LatLng(40.67, -91.123), new google.maps.LatLng(40.953, -90.952), new google.maps.LatLng(41.1, -90.948), new google.maps.LatLng(41.242, -91.113), new google.maps.LatLng(41.412, -91.046), new google.maps.LatLng(41.522, -90.462), new google.maps.LatLng(41.808, -90.181), new google.maps.LatLng(42.112, -90.161), new google.maps.LatLng(42.281, -90.43), new google.maps.LatLng(42.288, -90.427), new google.maps.LatLng(42.336, -90.428), new google.maps.LatLng(42.35, -90.44), new google.maps.LatLng(42.508, -90.64), //  bottom of WI border
		new google.maps.LatLng(42.634, -90.707), new google.maps.LatLng(42.751, -91.065), new google.maps.LatLng(43.125, -91.178), new google.maps.LatLng(43.252, -91.059), new google.maps.LatLng(43.258, -91.062), new google.maps.LatLng(43.353, -91.206), new google.maps.LatLng(43.501, -91.217) //  top right
		],
		'Kansas': [new google.maps.LatLng(40.003, -102.051), //  top left
		new google.maps.LatLng(40, -95.307), //  top right
		new google.maps.LatLng(39.874, -95.13), new google.maps.LatLng(39.887, -94.928), new google.maps.LatLng(39.744, -94.861), new google.maps.LatLng(39.741, -94.962), new google.maps.LatLng(39.542, -95.109), new google.maps.LatLng(39.386, -94.882), new google.maps.LatLng(39.213, -94.827), new google.maps.LatLng(39.148, -94.588), new google.maps.LatLng(36.998, -94.618), //  bottom right
		new google.maps.LatLng(36.993, -102.041) //  bottom left
		],
		'Kentucky': [new google.maps.LatLng(39.105, -84.819), //  top of IN border
		new google.maps.LatLng(39.055, -84.897), new google.maps.LatLng(38.785, -84.813), new google.maps.LatLng(38.688, -85.171), new google.maps.LatLng(38.728, -85.435), new google.maps.LatLng(38.715, -85.447), new google.maps.LatLng(38.534, -85.421), new google.maps.LatLng(38.299, -85.677), new google.maps.LatLng(38.278, -85.826), new google.maps.LatLng(38.025, -85.923), new google.maps.LatLng(37.958, -86.039), new google.maps.LatLng(38.056, -86.266), new google.maps.LatLng(38.198, -86.362), new google.maps.LatLng(38.138, -86.324), new google.maps.LatLng(38.121, -86.46), new google.maps.LatLng(37.927, -86.509), new google.maps.LatLng(37.843, -86.637), new google.maps.LatLng(37.999, -86.816), new google.maps.LatLng(37.782, -87.111), new google.maps.LatLng(37.976, -87.589), new google.maps.LatLng(37.833, -87.613), new google.maps.LatLng(37.928, -87.893), new google.maps.LatLng(37.807, -87.907), new google.maps.LatLng(37.799, -88.027), //  top of IL border
		new google.maps.LatLng(37.656, -88.16), new google.maps.LatLng(37.488, -88.065), new google.maps.LatLng(37.391, -88.474), new google.maps.LatLng(37.075, -88.459), new google.maps.LatLng(37.145, -88.735), new google.maps.LatLng(37.159, -88.761), new google.maps.LatLng(37.224, -89.17), new google.maps.LatLng(37.067, -89.173), new google.maps.LatLng(36.982, -89.133), //  top of MO border
		new google.maps.LatLng(36.666, -89.159), new google.maps.LatLng(36.567, -89.236), new google.maps.LatLng(36.625, -89.366), new google.maps.LatLng(36.499, -89.417), new google.maps.LatLng(36.497, -89.485), new google.maps.LatLng(36.497218, -89.484673), new google.maps.LatLng(36.582, -89.53), new google.maps.LatLng(36.498, -89.539), //  bottom left
		new google.maps.LatLng(36.497, -89.485), new google.maps.LatLng(36.499, -89.417), new google.maps.LatLng(36.497, -88.053), new google.maps.LatLng(36.678, -88.07), new google.maps.LatLng(36.601, -83.675), //  bottom of VA Border
		new google.maps.LatLng(36.745, -83.133), new google.maps.LatLng(36.852, -83.074), new google.maps.LatLng(36.897, -82.873), new google.maps.LatLng(37.121, -82.721), new google.maps.LatLng(37.538, -81.968), //  bottom WV Border
		new google.maps.LatLng(37.678, -82.304), new google.maps.LatLng(37.93, -82.5), new google.maps.LatLng(37.98, -82.464), new google.maps.LatLng(38.162, -82.643), new google.maps.LatLng(38.421, -82.594), //  right OH Border
		new google.maps.LatLng(38.59, -82.843), new google.maps.LatLng(38.755, -82.889), new google.maps.LatLng(38.596, -83.293), new google.maps.LatLng(38.703, -83.526), new google.maps.LatLng(38.626, -83.668), new google.maps.LatLng(38.761, -83.869), new google.maps.LatLng(38.808, -84.215), new google.maps.LatLng(39.119, -84.451), new google.maps.LatLng(39.105, -84.819) //  left OH Border
		],
		'Louisiana': [new google.maps.LatLng(33.019, -94.042), //  top left
		new google.maps.LatLng(31.992, -94.041), new google.maps.LatLng(31.777, -93.825), new google.maps.LatLng(31.585, -93.834), new google.maps.LatLng(31.509, -93.712), new google.maps.LatLng(31.031, -93.508), new google.maps.LatLng(30.538, -93.739), new google.maps.LatLng(30.137, -93.691), new google.maps.LatLng(29.999, -93.769), //  bottom left
		new google.maps.LatLng(29.795368, -93.927612), new google.maps.LatLng(29.764377, -93.891907), new google.maps.LatLng(29.683281, -93.834229), new google.maps.LatLng(29.59376, -93.810883), new google.maps.LatLng(29.616446, -92.774048), new google.maps.LatLng(29.51611, -92.298889), new google.maps.LatLng(29.458731, -91.819611), new google.maps.LatLng(29.227692, -91.271667), new google.maps.LatLng(29.018949, -90.920105), new google.maps.LatLng(29.053769, -90.22522), new google.maps.LatLng(28.906004, -89.420471), new google.maps.LatLng(28.960089, -89.110107), new google.maps.LatLng(29.186936, -88.981018), new google.maps.LatLng(30.147502, -89.077148), new google.maps.LatLng(30.212202, -89.183578), new google.maps.LatLng(30.180154, -89.265289), new google.maps.LatLng(30.176593, -89.421844), new google.maps.LatLng(30.157002, -89.508362), new google.maps.LatLng(30.193805, -89.531021), new google.maps.LatLng(30.192618, -89.547501), new google.maps.LatLng(30.182528, -89.559174), new google.maps.LatLng(30.181341, -89.57222), new google.maps.LatLng(30.202114, -89.589386), new google.maps.LatLng(30.221695, -89.614105), new google.maps.LatLng(30.216, -89.604), //  bottom right
		new google.maps.LatLng(30.664, -89.848), new google.maps.LatLng(31.004, -89.733), new google.maps.LatLng(30.999, -91.637), new google.maps.LatLng(31.054, -91.559), new google.maps.LatLng(31.257, -91.653), new google.maps.LatLng(31.278, -91.513), new google.maps.LatLng(31.407, -91.577), new google.maps.LatLng(31.373, -91.472), new google.maps.LatLng(31.524, -91.521), new google.maps.LatLng(31.573, -91.406), new google.maps.LatLng(31.63, -91.515), new google.maps.LatLng(31.619, -91.403), new google.maps.LatLng(31.746, -91.369), new google.maps.LatLng(31.754, -91.262), new google.maps.LatLng(31.76, -91.363), new google.maps.LatLng(31.847, -91.341), new google.maps.LatLng(31.813, -91.254), new google.maps.LatLng(32.011, -91.08), new google.maps.LatLng(32.074, -91.156), new google.maps.LatLng(32.145, -91.004), new google.maps.LatLng(32.134, -91.167), new google.maps.LatLng(32.197, -91.163), new google.maps.LatLng(32.193, -90.994), new google.maps.LatLng(32.367, -90.877), new google.maps.LatLng(32.354, -90.994), new google.maps.LatLng(32.436, -90.967), new google.maps.LatLng(32.481, -91.115), new google.maps.LatLng(32.547, -91.095), new google.maps.LatLng(32.494, -90.987), new google.maps.LatLng(32.543, -91.072), new google.maps.LatLng(32.64, -91.013), new google.maps.LatLng(32.618, -91.152), new google.maps.LatLng(32.719, -91.053), new google.maps.LatLng(32.778, -91.163), new google.maps.LatLng(32.905, -91.063), new google.maps.LatLng(32.989, -91.105), new google.maps.LatLng(32.916, -91.209), new google.maps.LatLng(33.004, -91.166) //  top right
		],
		'Maine': [new google.maps.LatLng(45.306286, -71.08429), //  top left
		new google.maps.LatLng(45.314495, -71.059227), new google.maps.LatLng(45.311115, -71.033821), new google.maps.LatLng(45.328979, -71.004982), new google.maps.LatLng(45.346596, -71.011162), new google.maps.LatLng(45.332116, -70.984039), new google.maps.LatLng(45.339357, -70.951424), new google.maps.LatLng(45.312563, -70.918808), new google.maps.LatLng(45.296626, -70.911598), new google.maps.LatLng(45.279235, -70.921555), new google.maps.LatLng(45.252172, -70.895119), new google.maps.LatLng(45.24347, -70.897179), new google.maps.LatLng(45.230173, -70.85804), new google.maps.LatLng(45.236459, -70.838127), new google.maps.LatLng(45.243953, -70.848427), new google.maps.LatLng(45.263772, -70.84877), new google.maps.LatLng(45.293728, -70.835037), new google.maps.LatLng(45.297834, -70.816498), new google.maps.LatLng(45.337909, -70.819588), new google.maps.LatLng(45.398932, -70.825768), new google.maps.LatLng(45.429299, -70.795212), new google.maps.LatLng(45.428335, -70.756073), new google.maps.LatLng(45.391217, -70.712128), new google.maps.LatLng(45.395316, -70.682945), new google.maps.LatLng(45.386877, -70.661316), new google.maps.LatLng(45.377714, -70.659599), new google.maps.LatLng(45.383019, -70.63488), new google.maps.LatLng(45.415081, -70.63488), new google.maps.LatLng(45.489742, -70.717964), new google.maps.LatLng(45.514046, -70.722771), new google.maps.LatLng(45.569111, -70.687065), new google.maps.LatLng(45.666846, -70.559349), new google.maps.LatLng(45.706419, -70.466652), new google.maps.LatLng(45.728712, -70.396614), new google.maps.LatLng(45.794818, -70.4179), new google.maps.LatLng(45.836454, -70.369148), new google.maps.LatLng(45.893115, -70.266151), new google.maps.LatLng(45.92417, -70.262718), //  lac du portage
		new google.maps.LatLng(45.963084, -70.31559), new google.maps.LatLng(46.064417, -70.309753), new google.maps.LatLng(46.099424, -70.284691), new google.maps.LatLng(46.100376, -70.254822), new google.maps.LatLng(46.150346, -70.240059), new google.maps.LatLng(46.191002, -70.292931), new google.maps.LatLng(46.291443, -70.231133), new google.maps.LatLng(46.329624, -70.208817), new google.maps.LatLng(46.359487, -70.174141), new google.maps.LatLng(46.381044, -70.126762), new google.maps.LatLng(46.409694, -70.096207), new google.maps.LatLng(46.415612, -70.057411), new google.maps.LatLng(46.696316, -69.9963), //  Lac-Frontiere
		new google.maps.LatLng(47.459898, -69.225197), new google.maps.LatLng(47.457112, -69.178505), new google.maps.LatLng(47.433661, -69.062462), new google.maps.LatLng(47.42739, -69.043236), new google.maps.LatLng(47.408109, -69.029846), new google.maps.LatLng(47.383474, -69.040146), new google.maps.LatLng(47.377895, -69.054222), new google.maps.LatLng(47.306939, -69.048386), new google.maps.LatLng(47.253602, -69.045982), new google.maps.LatLng(47.206508, -68.943329), new google.maps.LatLng(47.178746, -68.900414), new google.maps.LatLng(47.215604, -68.813553), new google.maps.LatLng(47.241949, -68.715019), new google.maps.LatLng(47.258495, -68.59314), //  Fort Kent
		new google.maps.LatLng(47.287846, -68.57769), new google.maps.LatLng(47.296229, -68.513489), new google.maps.LatLng(47.297161, -68.47229), new google.maps.LatLng(47.288079, -68.414955), new google.maps.LatLng(47.288079, -68.37719), new google.maps.LatLng(47.304145, -68.385086), new google.maps.LatLng(47.349291, -68.3741), new google.maps.LatLng(47.35999, -68.327408), new google.maps.LatLng(47.35999, -68.285866), new google.maps.LatLng(47.353711, -68.230591), new google.maps.LatLng(47.325792, -68.15712), new google.maps.LatLng(47.306939, -68.14991), new google.maps.LatLng(47.27457, -68.086395), new google.maps.LatLng(47.237753, -68.018417), new google.maps.LatLng(47.206975, -67.970352), new google.maps.LatLng(47.196945, -67.951813), new google.maps.LatLng(47.147933, -67.909584), //  saint-leonard-parent
		new google.maps.LatLng(47.100278, -67.867012), new google.maps.LatLng(47.06755, -67.790108), new google.maps.LatLng(45.941601, -67.780151), new google.maps.LatLng(45.918199, -67.750626), new google.maps.LatLng(45.897655, -67.767792), new google.maps.LatLng(45.882839, -67.802811), new google.maps.LatLng(45.823536, -67.755432), new google.maps.LatLng(45.730629, -67.782211), new google.maps.LatLng(45.676921, -67.769852), new google.maps.LatLng(45.688914, -67.732773), new google.maps.LatLng(45.681239, -67.7108), new google.maps.LatLng(45.623643, -67.641449), new google.maps.LatLng(45.605391, -67.452621), new google.maps.LatLng(45.573678, -67.422409), new google.maps.LatLng(45.502978, -67.416916), new google.maps.LatLng(45.488539, -67.501373), new google.maps.LatLng(45.377232, -67.418289), new google.maps.LatLng(45.27392, -67.477341), new google.maps.LatLng(45.125382, -67.340012), new google.maps.LatLng(45.190748, -67.285767), new google.maps.LatLng(45.163642, -67.164917), // champlain
		new google.maps.LatLng(45.110362, -67.109985), new google.maps.LatLng(44.953623, -67.020721), new google.maps.LatLng(44.910359, -66.968536), new google.maps.LatLng(44.82763, -66.96373), new google.maps.LatLng(44.825195, -66.932831), new google.maps.LatLng(44.794018, -66.885452), new google.maps.LatLng(44.775499, -66.902618), new google.maps.LatLng(44.698433, -67.031708), // near end of line (on map) that represents coastal border
		new google.maps.LatLng(44.134913, -68.230591), new google.maps.LatLng(43.992815, -68.626099), new google.maps.LatLng(43.940428, -69.185028), // tenants harbor
		new google.maps.LatLng(43.693694, -69.833221), new google.maps.LatLng(43.560491, -70.197144), new google.maps.LatLng(43.358137, -70.426483), new google.maps.LatLng(43.219188, -70.573425), new google.maps.LatLng(43.016697, -70.675049), //  bottom left
		new google.maps.LatLng(43.055844, -70.698395), new google.maps.LatLng(43.129052, -70.827484), new google.maps.LatLng(43.228194, -70.811005), //  rollinsford
		new google.maps.LatLng(43.335167, -70.9552), new google.maps.LatLng(43.478833, -70.97168), new google.maps.LatLng(43.574422, -70.973053), //  Great East Lake
		new google.maps.LatLng(44.76258, -71.038113) //  umbagog lake
		],
		'Maryland': [
		// new google.maps.LatLng(38.015, -75.387),    //  bottom left-ish
		// new google.maps.LatLng(37.979, -75.632),
		// new google.maps.LatLng(37.883, -76.234),
		// new google.maps.LatLng(37.993, -76.576),
		// new google.maps.LatLng(38.042, -76.512),
		// new google.maps.LatLng(38.144, -76.616),
		// new google.maps.LatLng(38.155, -76.705),
		// new google.maps.LatLng(38.065, -76.691),
		// new google.maps.LatLng(38.164, -76.774),
		// new google.maps.LatLng(38.195, -76.989),
		// new google.maps.LatLng(38.4, -77.05),
		// new google.maps.LatLng(38.351, -77.363),
		// new google.maps.LatLng(38.357, -77.29),
		// new google.maps.LatLng(38.438, -77.37),
		// new google.maps.LatLng(38.394, -77.312),
		// new google.maps.LatLng(38.659, -77.243),
		// new google.maps.LatLng(38.72, -77.045),
		// new google.maps.LatLng(38.911, -77.101),
		// new google.maps.LatLng(38.934, -77.12),
		// new google.maps.LatLng(39.077, -77.463),
		// new google.maps.LatLng(39.14, -77.526),
		// new google.maps.LatLng(39.225, -77.458),
		// new google.maps.LatLng(39.307, -77.636),
		// new google.maps.LatLng(39.31, -77.648),
		// new google.maps.LatLng(39.321, -77.719),    //  top of virginia
		// new google.maps.LatLng(39.496, -77.766),
		// new google.maps.LatLng(39.552, -77.887),
		// new google.maps.LatLng(39.603, -77.834),
		// new google.maps.LatLng(39.696, -78.174),
		// new google.maps.LatLng(39.624, -78.428),
		// new google.maps.LatLng(39.516, -78.468),
		// new google.maps.LatLng(39.544, -78.687),
		// new google.maps.LatLng(39.645, -78.776),
		// new google.maps.LatLng(39.441, -78.958),
		// new google.maps.LatLng(39.474, -79.105),
		// new google.maps.LatLng(39.202, -79.473),
		// new google.maps.LatLng(39.721, -79.477),    //  top left
		// new google.maps.LatLng(39.721, -75.789),     //  top right
		// new google.maps.LatLng(38.46, -75.693),
		// new google.maps.LatLng(38.451, -75.093),
		// new google.maps.LatLng(38.451, -75.058),
		// new google.maps.LatLng(38.451, -75.049)     //  coast end
		new google.maps.LatLng(39.7214, -79.4772), new google.maps.LatLng(39.5316, -79.4833), new google.maps.LatLng(39.3454, -79.484), new google.maps.LatLng(39.3444, -79.4854), new google.maps.LatLng(39.2546, -79.4861), new google.maps.LatLng(39.2051, -79.4861), new google.maps.LatLng(39.2073, -79.4696), new google.maps.LatLng(39.2535, -79.4044), new google.maps.LatLng(39.3014, -79.3282), new google.maps.LatLng(39.3449, -79.2705), new google.maps.LatLng(39.3853, -79.1936), new google.maps.LatLng(39.4553, -79.1043), new google.maps.LatLng(39.4738, -79.0604), new google.maps.LatLng(39.4834, -79.0542), new google.maps.LatLng(39.4426, -78.9725), new google.maps.LatLng(39.4913, -78.9203), new google.maps.LatLng(39.5549, -78.8571), new google.maps.LatLng(39.6036, -78.8187), new google.maps.LatLng(39.6036, -78.7912), new google.maps.LatLng(39.6438, -78.7775), new google.maps.LatLng(39.6184, -78.7363), new google.maps.LatLng(39.6015, -78.772), new google.maps.LatLng(39.5888, -78.739), new google.maps.LatLng(39.5337, -78.6676), new google.maps.LatLng(39.5189, -78.5687), new google.maps.LatLng(39.5146, -78.4698), new google.maps.LatLng(39.5464, -78.4232), new google.maps.LatLng(39.575, -78.4245), new google.maps.LatLng(39.5824, -78.4177), new google.maps.LatLng(39.6036, -78.4067), new google.maps.LatLng(39.612, -78.3765), new google.maps.LatLng(39.6438, -78.3517), new google.maps.LatLng(39.6226, -78.2776), new google.maps.LatLng(39.6586, -78.2281), new google.maps.LatLng(39.6839, -78.2419), new google.maps.LatLng(39.6839, -78.2062), new google.maps.LatLng(39.6945, -78.1924), new google.maps.LatLng(39.6924, -78.143), new google.maps.LatLng(39.6247, -78.0222), new google.maps.LatLng(39.6078, -77.9974), new google.maps.LatLng(39.6015, -77.8821), new google.maps.LatLng(39.5591, -77.8848), new google.maps.LatLng(39.5231, -77.8656), new google.maps.LatLng(39.5337, -77.8354), new google.maps.LatLng(39.521, -77.8217), new google.maps.LatLng(39.5062, -77.8436), new google.maps.LatLng(39.5019, -77.7859), new google.maps.LatLng(39.4606, -77.7997), new google.maps.LatLng(39.4367, -77.8038), new google.maps.LatLng(39.4288, -77.7602), new google.maps.LatLng(39.381, -77.7544), new google.maps.LatLng(39.3383, -77.7626), new google.maps.LatLng(39.3202, -77.7159), new google.maps.LatLng(39.3067, -77.6321), new google.maps.LatLng(39.3051, -77.5666), new google.maps.LatLng(39.2269, -77.4577), new google.maps.LatLng(39.1804, -77.5092), new google.maps.LatLng(39.1218, -77.5202), new google.maps.LatLng(39.0792, -77.4636), new google.maps.LatLng(39.0717, -77.4351), new google.maps.LatLng(39.0634, -77.3431), new google.maps.LatLng(39.024, -77.2462), new google.maps.LatLng(38.9773, -77.2335), new google.maps.LatLng(38.957, -77.1395), new google.maps.LatLng(38.9343, -77.1198), new google.maps.LatLng(38.9954, -77.041), new google.maps.LatLng(38.8929, -76.9096), new google.maps.LatLng(38.7917, -77.039), new google.maps.LatLng(38.7187, -77.0361), new google.maps.LatLng(38.7112, -77.076), new google.maps.LatLng(38.6737, -77.1378), new google.maps.LatLng(38.6373, -77.1281), new google.maps.LatLng(38.5954, -77.249), new google.maps.LatLng(38.5514, -77.2737), new google.maps.LatLng(38.4525, -77.3135), new google.maps.LatLng(38.332, -77.2627), new google.maps.LatLng(38.3697, -77.1432), new google.maps.LatLng(38.3697, -77.0897), new google.maps.LatLng(38.4009, -77.043), new google.maps.LatLng(38.3761, -77.0114), new google.maps.LatLng(38.3093, -77.0306), new google.maps.LatLng(38.2748, -76.9908), new google.maps.LatLng(38.208, -76.9482), new google.maps.LatLng(38.1637, -76.8494), new google.maps.LatLng(38.167, -76.7601), new google.maps.LatLng(38.1616, -76.6928), new google.maps.LatLng(38.1464, -76.6063), new google.maps.LatLng(38.0751, -76.5363), new google.maps.LatLng(38.0275, -76.517), new google.maps.LatLng(38.0146, -76.4703), new google.maps.LatLng(37.9669, -76.4154), new google.maps.LatLng(37.9474, -76.3454), new google.maps.LatLng(37.8889, -76.2396), new google.maps.LatLng(37.9529, -76.0584), new google.maps.LatLng(37.9464, -75.943), new google.maps.LatLng(37.9095, -75.9512), new google.maps.LatLng(37.9117, -75.8084), new google.maps.LatLng(37.9529, -75.7288), new google.maps.LatLng(37.9464, -75.6436), new google.maps.LatLng(37.9951, -75.623), new google.maps.LatLng(37.9962, -75.6079), new google.maps.LatLng(38.0275, -75.2316), new google.maps.LatLng(38.02, -74.9721), new google.maps.LatLng(38.4482, -74.8581), new google.maps.LatLng(38.4611, -75.6944), new google.maps.LatLng(38.9498, -75.7329), new google.maps.LatLng(39.3152, -75.7617), new google.maps.LatLng(39.5655, -75.7809), new google.maps.LatLng(39.722, -75.7878), new google.maps.LatLng(39.722, -78.36), new google.maps.LatLng(39.722, -79.4778)],
		'Massachusetts': [new google.maps.LatLng(42.869, -70.828), //  top right
		new google.maps.LatLng(42.859, -71.031), new google.maps.LatLng(42.697, -71.295), new google.maps.LatLng(42.727, -72.459), new google.maps.LatLng(42.746, -73.265), //  top left (top of NY border)
		new google.maps.LatLng(42.086248, -73.508148), new google.maps.LatLng(42.049675, -73.496861), //  bottom left (bottom of NY border)
		new google.maps.LatLng(42.049, -73.488), //   left of CT border
		new google.maps.LatLng(42.023, -71.8), new google.maps.LatLng(42.008, -71.8), //  Left of RI border
		new google.maps.LatLng(42.018, -71.381), new google.maps.LatLng(41.776, -71.318), new google.maps.LatLng(41.775, -71.316), new google.maps.LatLng(41.763, -71.287), new google.maps.LatLng(41.759, -71.279), new google.maps.LatLng(41.718, -71.232), new google.maps.LatLng(41.674, -71.195), new google.maps.LatLng(41.66, -71.136), new google.maps.LatLng(41.647, -71.134), new google.maps.LatLng(41.496, -71.121) //  bottom of RI border
		],
		'Michigan': [new google.maps.LatLng(42.493365, -87.020302), //  bottom of Wisconsin
		new google.maps.LatLng(42.73264, -87.053947), new google.maps.LatLng(43.378602, -87.147331), new google.maps.LatLng(43.499507, -87.137032), new google.maps.LatLng(43.670355, -87.125359), new google.maps.LatLng(43.733399, -87.114029), new google.maps.LatLng(43.999483, -87.046051), new google.maps.LatLng(44.130232, -87.013092), new google.maps.LatLng(44.161273, -87.000046), new google.maps.LatLng(44.499934, -86.85482), new google.maps.LatLng(44.881661, -86.685219), new google.maps.LatLng(45.081036, -86.499481), new google.maps.LatLng(45.236218, -86.250916), //
		new google.maps.LatLng(45.437008, -86.750793), new google.maps.LatLng(45.437008, -87.102356), new google.maps.LatLng(45.205263, -87.40448), new google.maps.LatLng(45.0774, -87.442932), new google.maps.LatLng(45.096, -87.585), //  marionette
		new google.maps.LatLng(45.175, -87.735), new google.maps.LatLng(45.369, -87.66), new google.maps.LatLng(45.353, -87.884), new google.maps.LatLng(45.685, -87.783), new google.maps.LatLng(45.81, -88.131), new google.maps.LatLng(45.921, -88.103), new google.maps.LatLng(46.272, -89.8), new google.maps.LatLng(46.3, -89.929), new google.maps.LatLng(46.566, -90.417), //  top of wi land border
		new google.maps.LatLng(48.014272, -89.483643), //  top of minnesota
		new google.maps.LatLng(47.975214, -89.338074), new google.maps.LatLng(48.244797, -88.676147), new google.maps.LatLng(48.303294, -88.371277), new google.maps.LatLng(46.888355, -84.858398), new google.maps.LatLng(46.630579, -84.759521), new google.maps.LatLng(46.454889, -84.550781), new google.maps.LatLng(46.451105, -84.476624), new google.maps.LatLng(46.528635, -84.119568), new google.maps.LatLng(46.059891, -83.952026), new google.maps.LatLng(46.120845, -83.825684), new google.maps.LatLng(45.99887, -83.432922), new google.maps.LatLng(45.775186, -83.636169), new google.maps.LatLng(45.771355, -83.482361), new google.maps.LatLng(45.338633, -82.518311), new google.maps.LatLng(43.58238, -82.120056), new google.maps.LatLng(43.002639, -82.408447), //  samia
		new google.maps.LatLng(42.813537, -82.482605), new google.maps.LatLng(42.763146, -82.466125), new google.maps.LatLng(42.616781, -82.515564), new google.maps.LatLng(42.54701, -82.610321), new google.maps.LatLng(42.554092, -82.637787), new google.maps.LatLng(42.37072, -82.831421), new google.maps.LatLng(42.31997, -83.049774), new google.maps.LatLng(42.126747, -83.118439), // Grosse lle
		new google.maps.LatLng(42.039094, -83.148651), new google.maps.LatLng(41.957448, -83.114319), //  bottom right-ish
		new google.maps.LatLng(41.731355, -83.416443), new google.maps.LatLng(41.733, -83.454), new google.maps.LatLng(41.696, -84.806), new google.maps.LatLng(41.76, -84.806), //  right of IN border
		new google.maps.LatLng(41.76, -86.825)],
		'Minnesota': [new google.maps.LatLng(43.5, -96.453), //  bottom left
		new google.maps.LatLng(45.301, -96.453), new google.maps.LatLng(45.606, -96.857), new google.maps.LatLng(45.817, -96.585), new google.maps.LatLng(45.935, -96.562), //  top of SD border
		new google.maps.LatLng(46.316, -96.596), new google.maps.LatLng(46.709, -96.788), new google.maps.LatLng(46.72, -96.785), new google.maps.LatLng(47.598, -96.851), new google.maps.LatLng(48.143, -97.146), new google.maps.LatLng(48.563, -97.174), new google.maps.LatLng(48.686, -97.094), new google.maps.LatLng(49, -97.229), //  top left
		new google.maps.LatLng(49.000042, -95.155334), new google.maps.LatLng(49.377008, -95.152588), new google.maps.LatLng(49.321542, -94.817505), new google.maps.LatLng(48.871941, -94.680176), new google.maps.LatLng(48.830374, -94.699402), new google.maps.LatLng(48.776103, -94.691162), new google.maps.LatLng(48.694586, -94.441223), new google.maps.LatLng(48.631093, -93.856201), new google.maps.LatLng(48.523881, -93.815002), new google.maps.LatLng(48.589326, -93.46344), new google.maps.LatLng(48.640169, -93.210754), new google.maps.LatLng(48.631093, -92.949829), new google.maps.LatLng(48.545705, -92.636719), // leatherdale landing
		new google.maps.LatLng(48.412796, -92.455444), new google.maps.LatLng(48.222843, -92.367554), new google.maps.LatLng(48.246626, -92.271423), new google.maps.LatLng(48.352599, -92.25769), new google.maps.LatLng(48.359899, -92.054443), new google.maps.LatLng(48.199049, -91.71936), new google.maps.LatLng(48.067068, -91.450195), new google.maps.LatLng(48.244797, -90.884399), // saganaga lake
		new google.maps.LatLng(48.092757, -90.75531), new google.maps.LatLng(48.085419, -90.027466), new google.maps.LatLng(47.986245, -89.87915), new google.maps.LatLng(48.011975, -89.489136), // top right
		new google.maps.LatLng(47.290408, -89.958801), new google.maps.LatLng(47.309034, -90.653687), new google.maps.LatLng(46.702202, -92.015991), new google.maps.LatLng(46.748801, -92.088432), //  superior
		new google.maps.LatLng(46.664, -92.291), new google.maps.LatLng(46.074, -92.293), new google.maps.LatLng(45.891, -92.712), new google.maps.LatLng(45.707, -92.87), new google.maps.LatLng(45.574, -92.882), new google.maps.LatLng(45.438, -92.645), new google.maps.LatLng(45.289, -92.761), new google.maps.LatLng(44.751, -92.808), new google.maps.LatLng(44.569, -92.549), new google.maps.LatLng(44.363, -91.965), new google.maps.LatLng(44.2, -91.875), new google.maps.LatLng(43.996, -91.431), new google.maps.LatLng(43.776, -91.245), new google.maps.LatLng(43.501, -91.217) //  bottom right
		],
		'Mississippi': [new google.maps.LatLng(30.216, -89.604), //  bottom left
		new google.maps.LatLng(30.664, -89.848), new google.maps.LatLng(31.004, -89.733), new google.maps.LatLng(30.999, -91.637), new google.maps.LatLng(31.054, -91.559), new google.maps.LatLng(31.257, -91.653), new google.maps.LatLng(31.278, -91.513), new google.maps.LatLng(31.407, -91.577), new google.maps.LatLng(31.373, -91.472), new google.maps.LatLng(31.524, -91.521), new google.maps.LatLng(31.573, -91.406), new google.maps.LatLng(31.63, -91.515), new google.maps.LatLng(31.619, -91.403), new google.maps.LatLng(31.746, -91.369), new google.maps.LatLng(31.754, -91.262), new google.maps.LatLng(31.76, -91.363), new google.maps.LatLng(31.847, -91.341), new google.maps.LatLng(31.813, -91.254), new google.maps.LatLng(32.011, -91.08), new google.maps.LatLng(32.074, -91.156), new google.maps.LatLng(32.145, -91.004), new google.maps.LatLng(32.134, -91.167), new google.maps.LatLng(32.197, -91.163), new google.maps.LatLng(32.193, -90.994), new google.maps.LatLng(32.367, -90.877), new google.maps.LatLng(32.354, -90.994), new google.maps.LatLng(32.436, -90.967), new google.maps.LatLng(32.481, -91.115), new google.maps.LatLng(32.547, -91.095), new google.maps.LatLng(32.494, -90.987), new google.maps.LatLng(32.543, -91.072), new google.maps.LatLng(32.64, -91.013), new google.maps.LatLng(32.618, -91.152), new google.maps.LatLng(32.719, -91.053), new google.maps.LatLng(32.778, -91.163), new google.maps.LatLng(32.905, -91.063), new google.maps.LatLng(32.989, -91.105), new google.maps.LatLng(32.916, -91.209), new google.maps.LatLng(33.004, -91.166), //  top of LA Border
		new google.maps.LatLng(33.059, -91.121), new google.maps.LatLng(33.125, -91.201), new google.maps.LatLng(33.136, -91.093), new google.maps.LatLng(33.275, -91.043), new google.maps.LatLng(33.301, -91.141), new google.maps.LatLng(33.449, -91.059), new google.maps.LatLng(33.378, -91.148), new google.maps.LatLng(33.407, -91.209), new google.maps.LatLng(33.473, -91.125), new google.maps.LatLng(33.437, -91.231), new google.maps.LatLng(33.561, -91.23), new google.maps.LatLng(33.607, -91.129), new google.maps.LatLng(33.69, -91.222), new google.maps.LatLng(33.681, -91.037), new google.maps.LatLng(33.726, -91.14), new google.maps.LatLng(33.783, -90.986), new google.maps.LatLng(33.967, -91.09), new google.maps.LatLng(34.026, -90.893), new google.maps.LatLng(34.164, -90.927), new google.maps.LatLng(34.159, -90.809), new google.maps.LatLng(34.238, -90.934), new google.maps.LatLng(34.207, -90.848), new google.maps.LatLng(34.364, -90.762), new google.maps.LatLng(34.314, -90.661), new google.maps.LatLng(34.418, -90.573), new google.maps.LatLng(34.689, -90.569), new google.maps.LatLng(34.624, -90.535), new google.maps.LatLng(34.684, -90.461), new google.maps.LatLng(34.711, -90.567), new google.maps.LatLng(34.785, -90.547), new google.maps.LatLng(34.737, -90.459), new google.maps.LatLng(34.892, -90.464), new google.maps.LatLng(34.848, -90.306), new google.maps.LatLng(34.924, -90.241), new google.maps.LatLng(34.995, -90.308), //  top left
		new google.maps.LatLng(34.995, -88.2), //  top right
		new google.maps.LatLng(34.892, -88.097), new google.maps.LatLng(32.747, -88.368), new google.maps.LatLng(32.732, -88.37), new google.maps.LatLng(31.894, -88.473), new google.maps.LatLng(30.348, -88.394) //  bottom right
		],
		'Missouri': [new google.maps.LatLng(36.625, -89.366), new google.maps.LatLng(36.567, -89.236), new google.maps.LatLng(36.666, -89.159), new google.maps.LatLng(36.982, -89.133), //  bottom of IL border
		new google.maps.LatLng(37.072, -89.254), new google.maps.LatLng(36.989, -89.276), new google.maps.LatLng(37.038, -89.376), new google.maps.LatLng(37.261, -89.522), new google.maps.LatLng(37.387, -89.421), new google.maps.LatLng(37.693, -89.517), new google.maps.LatLng(37.903, -89.839), new google.maps.LatLng(37.88, -89.949), new google.maps.LatLng(37.958, -89.925), new google.maps.LatLng(38.212, -90.351), new google.maps.LatLng(38.326, -90.373), new google.maps.LatLng(38.844, -90.109), new google.maps.LatLng(38.967, -90.451), new google.maps.LatLng(38.888, -90.625), new google.maps.LatLng(39.257, -90.731), new google.maps.LatLng(39.728, -91.367), new google.maps.LatLng(40.125, -91.51), new google.maps.LatLng(40.378, -91.419), //  top right
		new google.maps.LatLng(40.4, -91.5), new google.maps.LatLng(40.403, -91.505), new google.maps.LatLng(40.614, -91.728), new google.maps.LatLng(40.585, -95.765), //  top left
		new google.maps.LatLng(40.538, -95.652), new google.maps.LatLng(40.311, -95.656), new google.maps.LatLng(40.242, -95.477), new google.maps.LatLng(40.041, -95.415), new google.maps.LatLng(40, -95.307), //  top of KS border
		new google.maps.LatLng(39.874, -95.13), new google.maps.LatLng(39.887, -94.928), new google.maps.LatLng(39.744, -94.861), new google.maps.LatLng(39.741, -94.962), new google.maps.LatLng(39.542, -95.109), new google.maps.LatLng(39.386, -94.882), new google.maps.LatLng(39.213, -94.827), new google.maps.LatLng(39.148, -94.588), new google.maps.LatLng(36.998, -94.618), //  top of OK border
		new google.maps.LatLng(36.499, -94.617), //  bottom left
		new google.maps.LatLng(36.499, -90.802), new google.maps.LatLng(36.499, -90.789), new google.maps.LatLng(36.497, -90.151), new google.maps.LatLng(36.303, -90.064), new google.maps.LatLng(35.996, -90.377), new google.maps.LatLng(36.001, -89.733), //  bottom right
		new google.maps.LatLng(36.134, -89.592), new google.maps.LatLng(36.25, -89.698), new google.maps.LatLng(36.25, -89.537), new google.maps.LatLng(36.323, -89.62), new google.maps.LatLng(36.356, -89.514), new google.maps.LatLng(36.498, -89.539), new google.maps.LatLng(36.578868, -89.520378), new google.maps.LatLng(36.497, -89.485), new google.maps.LatLng(36.457464, -89.469223), new google.maps.LatLng(36.499, -89.417) //  top of TN border
		],
		'Montana': [new google.maps.LatLng(49, -104.047), //  top right
		new google.maps.LatLng(45.944, -104.045), //  top of SD border
		new google.maps.LatLng(44.998, -104.057), //  bottom right
		new google.maps.LatLng(45.001, -111.054), new google.maps.LatLng(44.475, -111.052), //  left side of WY border
		new google.maps.LatLng(44.755, -111.383), new google.maps.LatLng(44.643, -111.514), new google.maps.LatLng(44.541, -111.471), new google.maps.LatLng(44.569, -112.284), new google.maps.LatLng(44.45, -112.383), new google.maps.LatLng(44.485, -112.778), new google.maps.LatLng(44.359, -112.854), new google.maps.LatLng(44.453, -113.004), new google.maps.LatLng(44.774, -113.135), new google.maps.LatLng(44.864, -113.451), new google.maps.LatLng(45.058, -113.45), new google.maps.LatLng(45.26, -113.689), new google.maps.LatLng(45.603, -113.807), new google.maps.LatLng(45.696, -113.937), new google.maps.LatLng(45.459, -114.332), new google.maps.LatLng(45.558, -114.563), new google.maps.LatLng(45.704, -114.495), new google.maps.LatLng(45.777, -114.562), new google.maps.LatLng(45.885, -114.386), new google.maps.LatLng(46.147, -114.525), new google.maps.LatLng(46.172, -114.444), new google.maps.LatLng(46.647, -114.319), new google.maps.LatLng(46.7, -114.769), new google.maps.LatLng(47.253, -115.317), new google.maps.LatLng(47.427, -115.756), new google.maps.LatLng(47.48, -115.627), new google.maps.LatLng(47.55, -115.754), new google.maps.LatLng(47.696, -115.723), new google.maps.LatLng(47.978, -116.047), new google.maps.LatLng(49, -116.048) //  top left
		],
		'Nebraska': [new google.maps.LatLng(43.002, -104.056), //  top left
		new google.maps.LatLng(42.998, -98.499), new google.maps.LatLng(42.762, -98.013), new google.maps.LatLng(42.858, -97.874), new google.maps.LatLng(42.851, -97.232), new google.maps.LatLng(42.489, -96.443), //  top right
		new google.maps.LatLng(42.167, -96.347), new google.maps.LatLng(41.798, -96.066), new google.maps.LatLng(41.608, -96.116), new google.maps.LatLng(41.601, -96.113), new google.maps.LatLng(41.452, -95.919), new google.maps.LatLng(41.346, -95.957), new google.maps.LatLng(41.302, -95.872), new google.maps.LatLng(41.201, -95.927), new google.maps.LatLng(41.177, -95.841), new google.maps.LatLng(40.895, -95.809), new google.maps.LatLng(40.734, -95.888), new google.maps.LatLng(40.585, -95.765), //  top of MO border
		new google.maps.LatLng(40.538, -95.652), new google.maps.LatLng(40.311, -95.656), new google.maps.LatLng(40.242, -95.477), new google.maps.LatLng(40.041, -95.415), new google.maps.LatLng(40, -95.307), //  bottom right
		new google.maps.LatLng(40.003, -102.051), //  left of KS border
		new google.maps.LatLng(41.002, -102.051), new google.maps.LatLng(41.001, -104.053) //  bottom left
		],
		'Nevada': [new google.maps.LatLng(37, -114.049), //  bottom of UT
		new google.maps.LatLng(41.994, -114.04), //  top right
		new google.maps.LatLng(42.002, -117.024), //  right of oregan
		new google.maps.LatLng(41.995, -119.998), //  top left
		new google.maps.LatLng(39, -120), new google.maps.LatLng(36.972, -117.166), new google.maps.LatLng(35.001, -114.632), //  bottom tip
		new google.maps.LatLng(35.181, -114.568), new google.maps.LatLng(35.79, -114.698), new google.maps.LatLng(35.804, -114.71), new google.maps.LatLng(36.103, -114.735), new google.maps.LatLng(36.142, -114.369), new google.maps.LatLng(36.142, -114.369), new google.maps.LatLng(36.016, -114.21), new google.maps.LatLng(36.194, -114.045), new google.maps.LatLng(37, -114.049) //  top of AZ section
		],
		'New Hampshire': [new google.maps.LatLng(45.013, -71.502), //  top left
		new google.maps.LatLng(44.752, -71.632), new google.maps.LatLng(44.588, -71.535), new google.maps.LatLng(44.506, -71.58), new google.maps.LatLng(44.319, -72.032), new google.maps.LatLng(44.081, -72.033), new google.maps.LatLng(43.574, -72.38), new google.maps.LatLng(43.005, -72.445), new google.maps.LatLng(42.872, -72.555), new google.maps.LatLng(42.727, -72.459), //  bottom left
		new google.maps.LatLng(42.697, -71.295), new google.maps.LatLng(42.859, -71.031), new google.maps.LatLng(42.869, -70.828), //  bottom right
		new google.maps.LatLng(43.016697, -70.675049), //  bottom left of Maine
		new google.maps.LatLng(43.055844, -70.698395), new google.maps.LatLng(43.129052, -70.827484), new google.maps.LatLng(43.228194, -70.811005), //  rollinsford
		new google.maps.LatLng(43.335167, -70.9552), new google.maps.LatLng(43.478833, -70.97168), new google.maps.LatLng(43.574422, -70.973053), //  Great East Lake
		new google.maps.LatLng(44.76258, -71.038113), //  umbagog lake
		new google.maps.LatLng(45.306286, -71.08429), //  top right
		new google.maps.LatLng(45.241053, -71.143341), new google.maps.LatLng(45.302905, -71.28479), new google.maps.LatLng(45.237185, -71.442719), new google.maps.LatLng(45.078369, -71.496277)],
		'New Jersey': [new google.maps.LatLng(38.78781, -75.012589), //  bottom of DE border
		new google.maps.LatLng(39.057584, -75.168457), new google.maps.LatLng(39.076776, -75.18837), new google.maps.LatLng(39.250334, -75.319519), new google.maps.LatLng(39.384202, -75.478134), new google.maps.LatLng(39.455282, -75.559845), new google.maps.LatLng(39.496093, -75.559158), new google.maps.LatLng(39.497153, -75.528259), new google.maps.LatLng(39.541117, -75.532379), new google.maps.LatLng(39.563353, -75.513153), new google.maps.LatLng(39.606217, -75.557098), new google.maps.LatLng(39.630019, -75.559845), new google.maps.LatLng(39.697149, -75.506973), new google.maps.LatLng(39.763158, -75.461655), new google.maps.LatLng(39.777408, -75.448608), new google.maps.LatLng(39.796403, -75.404663), new google.maps.LatLng(39.802, -75.415), //  bottom of PA border
		new google.maps.LatLng(39.844, -75.343), new google.maps.LatLng(39.846, -75.339), new google.maps.LatLng(39.884, -75.147), new google.maps.LatLng(39.95528, -75.132751), new google.maps.LatLng(40.114, -74.831), new google.maps.LatLng(40.119, -74.829), new google.maps.LatLng(40.163, -74.724), new google.maps.LatLng(40.412, -75.044), new google.maps.LatLng(40.415, -75.051), new google.maps.LatLng(40.54, -75.068), new google.maps.LatLng(40.613, -75.201), new google.maps.LatLng(40.75, -75.197), new google.maps.LatLng(40.869, -75.051), new google.maps.LatLng(40.986, -75.132), new google.maps.LatLng(41.357, -74.695), //  top point
		new google.maps.LatLng(41.003, -73.908), new google.maps.LatLng(40.917, -73.918), new google.maps.LatLng(40.882, -73.934), new google.maps.LatLng(40.644, -74.161), new google.maps.LatLng(40.499, -74.259) //  bottom of NY border
		],
		'New Mexico': [new google.maps.LatLng(36.999, -109.044), //  top left
		new google.maps.LatLng(36.002, -109.045), new google.maps.LatLng(34.96, -109.045), new google.maps.LatLng(31.332, -109.049), //  bottom left
		new google.maps.LatLng(31.33335, -108.208551), new google.maps.LatLng(31.78356, -108.208337), new google.maps.LatLng(31.784, -106.528), //  bottom of TX border
		new google.maps.LatLng(31.869, -106.634), new google.maps.LatLng(32, -106.618), new google.maps.LatLng(32, -103.064), new google.maps.LatLng(36.500348, -103.041919), new google.maps.LatLng(36.5, -103.001), //  top of TX border
		new google.maps.LatLng(37, -103.001) //  top of OK border
		],
		'New York': [new google.maps.LatLng(42.049, -73.488), //   top of CT border
		new google.maps.LatLng(41.295, -73.551), new google.maps.LatLng(41.212, -73.482), new google.maps.LatLng(41.101, -73.728), new google.maps.LatLng(40.991, -73.659), //   bottom of CT border

		// insert Island here

		new google.maps.LatLng(40.499, -74.259), //  bottom of NJ border
		new google.maps.LatLng(40.644, -74.161), new google.maps.LatLng(40.882, -73.934), new google.maps.LatLng(40.917, -73.918), new google.maps.LatLng(41.003, -73.908), new google.maps.LatLng(41.357, -74.695), //  right of PA border
		new google.maps.LatLng(41.481, -74.984), new google.maps.LatLng(41.812, -75.071), new google.maps.LatLng(41.864, -75.261), new google.maps.LatLng(42.006, -75.363), new google.maps.LatLng(41.999, -79.761), //  bottom left
		new google.maps.LatLng(42.269, -79.762), new google.maps.LatLng(42.515892, -79.762115), //  top left
		new google.maps.LatLng(42.805477, -78.997192), new google.maps.LatLng(42.843751, -78.925781), new google.maps.LatLng(42.953407, -78.931274), new google.maps.LatLng(43.004647, -79.020538), new google.maps.LatLng(43.055844, -78.999939), new google.maps.LatLng(43.077916, -79.074097), new google.maps.LatLng(43.121034, -79.067917), new google.maps.LatLng(43.171633, -79.052124), new google.maps.LatLng(43.262206, -79.070663), // Niagara-on-the-Lake
		new google.maps.LatLng(43.44943, -79.199066), new google.maps.LatLng(43.634584, -78.688202), new google.maps.LatLng(43.632596, -78.373718), new google.maps.LatLng(43.630111, -77.248993), new google.maps.LatLng(43.629614, -76.775894), new google.maps.LatLng(44.094983, -76.436691), new google.maps.LatLng(44.134174, -76.352921), // Point Alexandria
		new google.maps.LatLng(44.198944, -76.312408), new google.maps.LatLng(44.20362, -76.285973), new google.maps.LatLng(44.203374, -76.244774), new google.maps.LatLng(44.214448, -76.205978), new google.maps.LatLng(44.239542, -76.164093), new google.maps.LatLng(44.280604, -76.161346), new google.maps.LatLng(44.296333, -76.130791), new google.maps.LatLng(44.299282, -76.097488), new google.maps.LatLng(44.331216, -76.045647), new google.maps.LatLng(44.347177, -76.000671), new google.maps.LatLng(44.345704, -75.973892), new google.maps.LatLng(44.343003, -75.970116), new google.maps.LatLng(44.368533, -75.921707), new google.maps.LatLng(44.367796, -75.912094), new google.maps.LatLng(44.432309, -75.82077), new google.maps.LatLng(44.471766, -75.807037), new google.maps.LatLng(44.516093, -75.765495), new google.maps.LatLng(44.543261, -75.72567), //  hillcrest (canada side)
		new google.maps.LatLng(44.60929, -75.634689), new google.maps.LatLng(44.705022, -75.5056), new google.maps.LatLng(44.756486, -75.423889), new google.maps.LatLng(44.772087, -75.413589), new google.maps.LatLng(44.773305, -75.396423), new google.maps.LatLng(44.788414, -75.369301), new google.maps.LatLng(44.808878, -75.343552), new google.maps.LatLng(44.806442, -75.333252), new google.maps.LatLng(44.826413, -75.30201), new google.maps.LatLng(44.836882, -75.306816), // Iroquois Golf Club
		new google.maps.LatLng(44.856842, -75.256004), new google.maps.LatLng(44.866576, -75.241585), new google.maps.LatLng(44.877282, -75.218925), new google.maps.LatLng(44.89285, -75.165367), new google.maps.LatLng(44.914736, -75.134125), new google.maps.LatLng(44.926891, -75.096016), new google.maps.LatLng(44.934426, -75.05928), new google.maps.LatLng(44.958725, -75.004692), new google.maps.LatLng(44.971356, -74.998512), new google.maps.LatLng(44.983256, -74.971733), new google.maps.LatLng(44.983256, -74.907532), new google.maps.LatLng(44.999767, -74.887619), new google.maps.LatLng(45.015787, -74.826508), new google.maps.LatLng(45.014817, -74.801445), new google.maps.LatLng(45.004622, -74.792519), new google.maps.LatLng(45.005593, -74.76368), new google.maps.LatLng(44.994911, -74.759216), new google.maps.LatLng(44.990784, -74.730721), new google.maps.LatLng(45.003166, -74.701195), new google.maps.LatLng(45.000738, -74.672356), new google.maps.LatLng(44.999767, -74.660683), //   Saint-Regis
		new google.maps.LatLng(44.996125, -74.437523), new google.maps.LatLng(44.991755, -74.336929), new google.maps.LatLng(44.991998, -74.222946), new google.maps.LatLng(44.99127, -74.149475), new google.maps.LatLng(45.000495, -73.884087), new google.maps.LatLng(45.002923, -73.696632), new google.maps.LatLng(45.007535, -73.479996), new google.maps.LatLng(45.01069, -73.343697), //  top right
		new google.maps.LatLng(43.752, -73.363), new google.maps.LatLng(43.588, -73.431), new google.maps.LatLng(43.627, -73.304), new google.maps.LatLng(43.533, -73.242), new google.maps.LatLng(42.746, -73.265), //  top of MA border
		new google.maps.LatLng(42.086248, -73.508148), new google.maps.LatLng(42.049675, -73.496861) //  bottom of MA border
		],
		'North Carolina': [new google.maps.LatLng(36.55, -75.929), //  top right
		new google.maps.LatLng(36.55, -75.966), new google.maps.LatLng(36.55, -75.884), new google.maps.LatLng(36.55, -75.894), new google.maps.LatLng(36.55, -75.988), new google.maps.LatLng(36.55, -76.006), new google.maps.LatLng(36.55, -76.035), new google.maps.LatLng(36.55, -76.156), new google.maps.LatLng(36.55, -76.161), new google.maps.LatLng(36.542, -78.917), new google.maps.LatLng(36.542, -79.138), new google.maps.LatLng(36.588, -81.677), //  top left
		new google.maps.LatLng(36.338, -81.706), new google.maps.LatLng(36.301, -81.908), new google.maps.LatLng(36.12, -82.033), new google.maps.LatLng(36.116, -82.354), new google.maps.LatLng(35.955, -82.561), new google.maps.LatLng(36.065, -82.638), new google.maps.LatLng(35.944, -82.898), new google.maps.LatLng(35.773, -82.993), new google.maps.LatLng(35.562, -83.499), new google.maps.LatLng(35.518, -83.881), new google.maps.LatLng(35.274, -84.046), new google.maps.LatLng(35.225, -84.29), new google.maps.LatLng(34.988, -84.322), //  left side of GA border
		new google.maps.LatLng(35, -83.108), new google.maps.LatLng(35.215, -82.394), new google.maps.LatLng(35.149, -81.032), new google.maps.LatLng(35.047, -81.043), new google.maps.LatLng(35.107, -80.935), new google.maps.LatLng(34.935, -80.782), new google.maps.LatLng(34.819, -80.797), new google.maps.LatLng(34.804, -79.675), new google.maps.LatLng(33.856, -78.556), //  bottom right
		new google.maps.LatLng(33.838483, -77.961731), new google.maps.LatLng(34.482788, -77.433701), new google.maps.LatLng(34.580083, -76.533508), new google.maps.LatLng(35.218697, -75.52002), new google.maps.LatLng(35.588085, -75.451355), new google.maps.LatLng(35.721988, -75.484314)],
		'North Dakota': [new google.maps.LatLng(49, -104.047), //  top left
		new google.maps.LatLng(45.944, -104.045), //  bottm left
		new google.maps.LatLng(45.935, -96.562), //  bottom right
		new google.maps.LatLng(46.316, -96.596), new google.maps.LatLng(46.709, -96.788), new google.maps.LatLng(46.72, -96.785), new google.maps.LatLng(47.598, -96.851), new google.maps.LatLng(48.143, -97.146), new google.maps.LatLng(48.563, -97.174), new google.maps.LatLng(48.686, -97.094), new google.maps.LatLng(49, -97.229) //  top right
		],
		'Ohio': [new google.maps.LatLng(39.105, -84.819), //  Bottom Left
		new google.maps.LatLng(39.119, -84.451), new google.maps.LatLng(38.808, -84.215), new google.maps.LatLng(38.761, -83.869), new google.maps.LatLng(38.626, -83.668), new google.maps.LatLng(38.703, -83.526), new google.maps.LatLng(38.596, -83.293), new google.maps.LatLng(38.755, -82.889), new google.maps.LatLng(38.59, -82.843), new google.maps.LatLng(38.421, -82.594), //  bottom of WV border
		new google.maps.LatLng(38.445, -82.328), new google.maps.LatLng(38.593, -82.274), new google.maps.LatLng(38.596, -82.268), new google.maps.LatLng(38.605, -82.176), new google.maps.LatLng(38.787, -82.221), new google.maps.LatLng(39.025, -82.037), new google.maps.LatLng(38.875, -81.899), new google.maps.LatLng(38.923, -81.766), new google.maps.LatLng(39.077, -81.814), new google.maps.LatLng(39.268, -81.686), new google.maps.LatLng(39.268, -81.57), new google.maps.LatLng(39.41, -81.453), new google.maps.LatLng(39.342, -81.375), new google.maps.LatLng(39.387, -81.217), new google.maps.LatLng(39.625, -80.878), new google.maps.LatLng(40.313, -80.602), new google.maps.LatLng(40.584, -80.667), new google.maps.LatLng(40.638, -80.519), new google.maps.LatLng(41.977, -80.519), new google.maps.LatLng(42.327141, -80.519829), //  top right
		new google.maps.LatLng(41.999815, -81.708755), new google.maps.LatLng(41.677015, -82.398148), new google.maps.LatLng(41.675989, -82.681046), new google.maps.LatLng(41.863425, -83.069687), new google.maps.LatLng(41.957448, -83.114319), //  right of Michigan border
		new google.maps.LatLng(41.731355, -83.416443), new google.maps.LatLng(41.733, -83.454), new google.maps.LatLng(41.696, -84.806) //  top left
		],
		'Oklahoma': [new google.maps.LatLng(36.999262, -103.001), //  top left
		new google.maps.LatLng(36.998166, -102.9879), new google.maps.LatLng(36.998714, -102.747574), new google.maps.LatLng(36.994875, -102.701569), new google.maps.LatLng(36.993, -102.041), //  left of KS border
		new google.maps.LatLng(36.998, -94.618), //  top right
		new google.maps.LatLng(36.499, -94.617), //  top of AK border
		new google.maps.LatLng(35.398, -94.431), new google.maps.LatLng(33.637, -94.485), //  bottom right
		new google.maps.LatLng(33.961, -95.227), new google.maps.LatLng(33.873, -95.28), new google.maps.LatLng(33.939, -95.6), new google.maps.LatLng(33.845, -95.776), new google.maps.LatLng(33.838, -96.147), new google.maps.LatLng(33.687, -96.352), new google.maps.LatLng(33.843, -96.625), new google.maps.LatLng(33.894, -96.587), new google.maps.LatLng(33.823, -96.758), new google.maps.LatLng(33.955, -96.985), new google.maps.LatLng(33.718, -97.135), new google.maps.LatLng(33.914, -97.218), new google.maps.LatLng(33.819, -97.427), new google.maps.LatLng(33.991, -97.669), new google.maps.LatLng(33.856, -97.84), new google.maps.LatLng(33.881, -97.97), new google.maps.LatLng(33.989, -97.946), new google.maps.LatLng(34.011, -98.091), new google.maps.LatLng(34.153, -98.117), new google.maps.LatLng(34.148, -98.35), new google.maps.LatLng(34.057, -98.458), new google.maps.LatLng(34.161, -98.631), new google.maps.LatLng(34.114, -98.741), new google.maps.LatLng(34.213, -99.186), new google.maps.LatLng(34.453, -99.361), new google.maps.LatLng(34.373, -99.405), new google.maps.LatLng(34.381, -99.71), new google.maps.LatLng(34.579164, -99.94606), new google.maps.LatLng(34.578104, -99.954386), new google.maps.LatLng(34.561354, -99.976873), new google.maps.LatLng(34.560506, -100.000305), new google.maps.LatLng(36.5, -100.003), new google.maps.LatLng(36.5, -103.001) //  bottom left
		],
		'Oregon': [new google.maps.LatLng(41.998, -124.215), //  bottom left
		new google.maps.LatLng(42.002, -117.024), //  bottom right
		new google.maps.LatLng(43.83, -117.031), new google.maps.LatLng(44.17, -116.894), new google.maps.LatLng(44.273, -117.196), new google.maps.LatLng(44.393, -117.241), new google.maps.LatLng(44.727, -117.06), new google.maps.LatLng(44.881, -116.855), new google.maps.LatLng(45.025, -116.844), new google.maps.LatLng(45.603, -116.462), new google.maps.LatLng(45.752, -116.547), new google.maps.LatLng(45.824, -116.779), new google.maps.LatLng(45.995, -116.914), //  top right
		new google.maps.LatLng(46, -118.985), new google.maps.LatLng(45.699, -120.401), new google.maps.LatLng(45.746, -120.633), new google.maps.LatLng(45.606, -121.182), new google.maps.LatLng(45.705, -121.336), new google.maps.LatLng(45.707, -121.809), new google.maps.LatLng(45.544, -122.295), new google.maps.LatLng(45.657, -122.762), new google.maps.LatLng(46.084, -122.902), new google.maps.LatLng(46.161, -123.226), new google.maps.LatLng(46.224, -123.426), new google.maps.LatLng(46.262, -123.664), new google.maps.LatLng(46.256, -123.951), new google.maps.LatLng(46.267, -123.97), new google.maps.LatLng(46.298, -124.028), new google.maps.LatLng(46.267, -124.034) //  top left
		],
		'Pennsylvania': [new google.maps.LatLng(42.327141, -80.519829), //  top left
		new google.maps.LatLng(40.638, -80.519), //  top of WV border
		new google.maps.LatLng(39.721, -80.519), //  bottom left
		new google.maps.LatLng(39.721, -79.477), //  right of WV border
		new google.maps.LatLng(39.721, -75.789), //  right of Maryland Border
		new google.maps.LatLng(39.788, -75.721), new google.maps.LatLng(39.807, -75.693), new google.maps.LatLng(39.82304, -75.657692), new google.maps.LatLng(39.83675, -75.59967), new google.maps.LatLng(39.837805, -75.526886), new google.maps.LatLng(39.820667, -75.454102), new google.maps.LatLng(39.802, -75.415), //  bottom of NJ border
		new google.maps.LatLng(39.844, -75.343), new google.maps.LatLng(39.846, -75.339), new google.maps.LatLng(39.884, -75.147), new google.maps.LatLng(39.95528, -75.132751), new google.maps.LatLng(40.114, -74.831), new google.maps.LatLng(40.119, -74.829), new google.maps.LatLng(40.163, -74.724), new google.maps.LatLng(40.412, -75.044), new google.maps.LatLng(40.415, -75.051), new google.maps.LatLng(40.54, -75.068), new google.maps.LatLng(40.613, -75.201), new google.maps.LatLng(40.75, -75.197), new google.maps.LatLng(40.869, -75.051), new google.maps.LatLng(40.986, -75.132), new google.maps.LatLng(41.357, -74.695), //  top point of NJ
		new google.maps.LatLng(41.481, -74.984), new google.maps.LatLng(41.812, -75.071), new google.maps.LatLng(41.864, -75.261), new google.maps.LatLng(42.006, -75.363), new google.maps.LatLng(41.999, -79.761), new google.maps.LatLng(42.269, -79.762), new google.maps.LatLng(42.515892, -79.762115) //  top right

		],
		'Rhode Island': [new google.maps.LatLng(41.423, -71.798), //   bottom left
		new google.maps.LatLng(42.008, -71.8), //   top left
		new google.maps.LatLng(42.018, -71.381), new google.maps.LatLng(41.776, -71.318), new google.maps.LatLng(41.775, -71.316), new google.maps.LatLng(41.763, -71.287), new google.maps.LatLng(41.759, -71.279), new google.maps.LatLng(41.718, -71.232), new google.maps.LatLng(41.674, -71.195), new google.maps.LatLng(41.66, -71.136), new google.maps.LatLng(41.647, -71.134), new google.maps.LatLng(41.496, -71.121) //  bottom right
		],
		'South Carolina': [new google.maps.LatLng(33.183537, -79.170227), new google.maps.LatLng(32.99945, -79.354248), new google.maps.LatLng(32.669437, -79.881592), new google.maps.LatLng(32.032964, -80.837059), //  coast ( bottom tip of SC)
		new google.maps.LatLng(32.099299, -81.081333), //  savannah area
		new google.maps.LatLng(32.226, -81.144), new google.maps.LatLng(32.464, -81.186), new google.maps.LatLng(32.628, -81.418), new google.maps.LatLng(33.01, -81.495), new google.maps.LatLng(33.147, -81.751), new google.maps.LatLng(33.347, -81.94), new google.maps.LatLng(33.465, -81.929), new google.maps.LatLng(33.945, -82.557), new google.maps.LatLng(34.474, -82.877), new google.maps.LatLng(34.682, -83.342), new google.maps.LatLng(35, -83.108), //  top left
		new google.maps.LatLng(35.215, -82.394), new google.maps.LatLng(35.149, -81.032), new google.maps.LatLng(35.047, -81.043), new google.maps.LatLng(35.107, -80.935), new google.maps.LatLng(34.935, -80.782), new google.maps.LatLng(34.819, -80.797), new google.maps.LatLng(34.804, -79.675), new google.maps.LatLng(33.856, -78.556) //  top right
		],
		'South Dakota': [new google.maps.LatLng(45.944, -104.045), //  top left
		new google.maps.LatLng(44.998, -104.057), //  bottom of MT border
		new google.maps.LatLng(43.002, -104.056), //  bottom left
		new google.maps.LatLng(42.998, -98.499), new google.maps.LatLng(42.762, -98.013), new google.maps.LatLng(42.858, -97.874), new google.maps.LatLng(42.851, -97.232), new google.maps.LatLng(42.489, -96.443), //  bottom right
		new google.maps.LatLng(42.737, -96.637), new google.maps.LatLng(43.12, -96.436), new google.maps.LatLng(43.269, -96.585), new google.maps.LatLng(43.385, -96.52), new google.maps.LatLng(43.5, -96.598), new google.maps.LatLng(43.5, -96.453), //  top of IA border
		new google.maps.LatLng(45.301, -96.453), new google.maps.LatLng(45.606, -96.857), new google.maps.LatLng(45.817, -96.585), new google.maps.LatLng(45.935, -96.562) //  top right
		],
		'Tennessee': [new google.maps.LatLng(36.588, -81.677), //  top right
		new google.maps.LatLng(36.338, -81.706), new google.maps.LatLng(36.301, -81.908), new google.maps.LatLng(36.12, -82.033), new google.maps.LatLng(36.116, -82.354), new google.maps.LatLng(35.955, -82.561), new google.maps.LatLng(36.065, -82.638), new google.maps.LatLng(35.944, -82.898), new google.maps.LatLng(35.773, -82.993), new google.maps.LatLng(35.562, -83.499), new google.maps.LatLng(35.518, -83.881), new google.maps.LatLng(35.274, -84.046), new google.maps.LatLng(35.225, -84.29), new google.maps.LatLng(34.988, -84.322), //  bottom right
		new google.maps.LatLng(34.984, -85.605), //  right of AL border
		new google.maps.LatLng(34.995, -88.2), //  right of MS border
		new google.maps.LatLng(34.995, -90.308), //  bottom left
		new google.maps.LatLng(35.139, -90.065), new google.maps.LatLng(35.265, -90.16), new google.maps.LatLng(35.277, -90.168), new google.maps.LatLng(35.386, -90.08), new google.maps.LatLng(35.421, -90.169), new google.maps.LatLng(35.429, -90.002), new google.maps.LatLng(35.547, -90.04), new google.maps.LatLng(35.514, -89.916), new google.maps.LatLng(35.592, -89.955), new google.maps.LatLng(35.639, -89.853), new google.maps.LatLng(35.729, -89.957), new google.maps.LatLng(35.814, -89.71), new google.maps.LatLng(35.909, -89.742), new google.maps.LatLng(35.892, -89.642), new google.maps.LatLng(36.001, -89.733), //  bottom of Missouri border
		new google.maps.LatLng(36.134, -89.592), new google.maps.LatLng(36.25, -89.698), new google.maps.LatLng(36.25, -89.537), new google.maps.LatLng(36.323, -89.62), new google.maps.LatLng(36.356, -89.514), new google.maps.LatLng(36.498, -89.539), new google.maps.LatLng(36.497, -89.485), new google.maps.LatLng(36.457464, -89.469223), new google.maps.LatLng(36.499, -89.417), //  top left
		new google.maps.LatLng(36.499, -89.417), new google.maps.LatLng(36.497, -88.053), new google.maps.LatLng(36.678, -88.07), new google.maps.LatLng(36.601, -83.675) //  left of VA Border
		],
		'Texas': [new google.maps.LatLng(29.999, -93.769), //  bottom right
		new google.maps.LatLng(30.137, -93.691), new google.maps.LatLng(30.538, -93.739), new google.maps.LatLng(31.031, -93.508), new google.maps.LatLng(31.509, -93.712), new google.maps.LatLng(31.585, -93.834), new google.maps.LatLng(31.777, -93.825), new google.maps.LatLng(31.992, -94.041), new google.maps.LatLng(33.019, -94.042), //  bottom of AK border
		new google.maps.LatLng(33.551, -94.043), new google.maps.LatLng(33.545, -94.386), new google.maps.LatLng(33.637, -94.485), //  right of OK border
		new google.maps.LatLng(33.961, -95.227), new google.maps.LatLng(33.873, -95.28), new google.maps.LatLng(33.939, -95.6), new google.maps.LatLng(33.845, -95.776), new google.maps.LatLng(33.838, -96.147), new google.maps.LatLng(33.687, -96.352), new google.maps.LatLng(33.843, -96.625), new google.maps.LatLng(33.894, -96.587), new google.maps.LatLng(33.823, -96.758), new google.maps.LatLng(33.955, -96.985), new google.maps.LatLng(33.718, -97.135), new google.maps.LatLng(33.914, -97.218), new google.maps.LatLng(33.819, -97.427), new google.maps.LatLng(33.991, -97.669), new google.maps.LatLng(33.856, -97.84), new google.maps.LatLng(33.881, -97.97), new google.maps.LatLng(33.989, -97.946), new google.maps.LatLng(34.011, -98.091), new google.maps.LatLng(34.153, -98.117), new google.maps.LatLng(34.148, -98.35), new google.maps.LatLng(34.057, -98.458), new google.maps.LatLng(34.161, -98.631), new google.maps.LatLng(34.114, -98.741), new google.maps.LatLng(34.213, -99.186), new google.maps.LatLng(34.453, -99.361), new google.maps.LatLng(34.373, -99.405), new google.maps.LatLng(34.381, -99.71), new google.maps.LatLng(34.579164, -99.94606), new google.maps.LatLng(34.578104, -99.954386), new google.maps.LatLng(34.561354, -99.976873), new google.maps.LatLng(34.560506, -100.000305), new google.maps.LatLng(36.5, -100.003), new google.maps.LatLng(36.5, -103.001), //  top left
		new google.maps.LatLng(36.500348, -103.041919), new google.maps.LatLng(32, -103.064), new google.maps.LatLng(32, -106.618), new google.maps.LatLng(31.869, -106.634), new google.maps.LatLng(31.784, -106.528), //  bottom of NM Border

		// Mexican Border
		new google.maps.LatLng(31.461468, -106.199341), new google.maps.LatLng(30.272707, -104.761505), new google.maps.LatLng(29.910901, -104.676361), new google.maps.LatLng(29.632879, -104.508605), new google.maps.LatLng(29.392346, -104.16481), //  el Mulato
		new google.maps.LatLng(28.972104, -103.154755), new google.maps.LatLng(28.985394, -103.115015), new google.maps.LatLng(29.224096, -102.866364), new google.maps.LatLng(29.760801, -102.386742), new google.maps.LatLng(29.782556, -101.929436), new google.maps.LatLng(29.332951, -100.940666), //  acuna (ciudad acuna)
		new google.maps.LatLng(26.397559, -99.08432), new google.maps.LatLng(25.836977, -97.394314), new google.maps.LatLng(25.956347, -97.146091), //  south tip

		// Coastal Border
		new google.maps.LatLng(26.145268, -97.166862), new google.maps.LatLng(26.225679, -97.177162), new google.maps.LatLng(26.290645, -97.190895), new google.maps.LatLng(26.410936, -97.219391), new google.maps.LatLng(26.809364, -97.349167), new google.maps.LatLng(27.045367, -97.378693), new google.maps.LatLng(27.205938, -97.365303), //  Yarborough
		new google.maps.LatLng(27.83456, -97.044575), new google.maps.LatLng(28.334604, -96.415329), new google.maps.LatLng(28.93305, -95.292664), //  freeport
		new google.maps.LatLng(29.683281, -93.834229), new google.maps.LatLng(29.764377, -93.891907), new google.maps.LatLng(29.795368, -93.927612)],
		'Utah': [new google.maps.LatLng(41.994, -114.04), //  top left
		new google.maps.LatLng(37, -114.049), //  bottom left
		new google.maps.LatLng(36.999, -109.044), //  bottom right
		new google.maps.LatLng(41, -109.049), //  top right
		new google.maps.LatLng(41, -111.045), new google.maps.LatLng(42.001, -111.045) //  top of Wyoming
		],
		'Vermont': [new google.maps.LatLng(42.727, -72.459), //  bottom right
		new google.maps.LatLng(42.872, -72.555), new google.maps.LatLng(43.005, -72.445), new google.maps.LatLng(43.574, -72.38), new google.maps.LatLng(44.081, -72.033), new google.maps.LatLng(44.319, -72.032), new google.maps.LatLng(44.506, -71.58), new google.maps.LatLng(44.588, -71.535), new google.maps.LatLng(44.752, -71.632), new google.maps.LatLng(45.013, -71.502), //  top right
		new google.maps.LatLng(45.01069, -73.343697), //  top left
		new google.maps.LatLng(43.752, -73.363), new google.maps.LatLng(43.588, -73.431), new google.maps.LatLng(43.627, -73.304), new google.maps.LatLng(43.533, -73.242), new google.maps.LatLng(42.746, -73.265) //  bottom left
		],
		'Virginia': [new google.maps.LatLng(38.015, -75.387), //  top right
		new google.maps.LatLng(37.979, -75.632), new google.maps.LatLng(37.883, -76.234), new google.maps.LatLng(37.993, -76.576), new google.maps.LatLng(38.042, -76.512), new google.maps.LatLng(38.144, -76.616), new google.maps.LatLng(38.155, -76.705), new google.maps.LatLng(38.065, -76.691), new google.maps.LatLng(38.164, -76.774), new google.maps.LatLng(38.195, -76.989), new google.maps.LatLng(38.4, -77.05), new google.maps.LatLng(38.351, -77.363), new google.maps.LatLng(38.357, -77.29), new google.maps.LatLng(38.438, -77.37), new google.maps.LatLng(38.394, -77.312), new google.maps.LatLng(38.659, -77.243), new google.maps.LatLng(38.72, -77.045), new google.maps.LatLng(38.911, -77.101), new google.maps.LatLng(38.934, -77.12), new google.maps.LatLng(39.077, -77.463), new google.maps.LatLng(39.14, -77.526), new google.maps.LatLng(39.225, -77.458), new google.maps.LatLng(39.307, -77.636), new google.maps.LatLng(39.31, -77.648), new google.maps.LatLng(39.321, -77.719), //  right of WV border
		new google.maps.LatLng(39.132, -77.828), new google.maps.LatLng(39.465, -78.347), new google.maps.LatLng(39.166, -78.405), new google.maps.LatLng(38.762, -78.869), new google.maps.LatLng(38.846, -78.999), new google.maps.LatLng(38.421, -79.28), new google.maps.LatLng(38.591, -79.649), new google.maps.LatLng(38.271, -79.788), new google.maps.LatLng(37.689, -80.307), new google.maps.LatLng(37.627, -80.221), new google.maps.LatLng(37.508, -80.299), new google.maps.LatLng(37.426, -80.466), new google.maps.LatLng(37.429, -80.859), new google.maps.LatLng(37.317, -80.896), new google.maps.LatLng(37.234, -81.225), new google.maps.LatLng(37.337, -81.362), new google.maps.LatLng(37.201, -81.677), new google.maps.LatLng(37.359, -81.927), new google.maps.LatLng(37.538, -81.968), //  left of WV border
		new google.maps.LatLng(37.121, -82.721), new google.maps.LatLng(36.897, -82.873), new google.maps.LatLng(36.852, -83.074), new google.maps.LatLng(36.745, -83.133), new google.maps.LatLng(36.601, -83.675), //  bottom left
		new google.maps.LatLng(36.588, -81.677), //  right of TN border
		new google.maps.LatLng(36.542, -79.138), new google.maps.LatLng(36.542, -78.917), new google.maps.LatLng(36.55, -76.161), new google.maps.LatLng(36.55, -76.156), new google.maps.LatLng(36.55, -76.035), new google.maps.LatLng(36.55, -76.006), new google.maps.LatLng(36.55, -75.988), new google.maps.LatLng(36.55, -75.894), new google.maps.LatLng(36.55, -75.884), new google.maps.LatLng(36.55, -75.966), new google.maps.LatLng(36.55, -75.929) //  bottom right
		],
		'Washington': [new google.maps.LatLng(48.499318, -124.744263), //  top left
		new google.maps.LatLng(48.224673, -123.53714), new google.maps.LatLng(48.283193, -123.244629), new google.maps.LatLng(48.422821, -123.11142), new google.maps.LatLng(48.691867, -123.270721), new google.maps.LatLng(48.766147, -123.005676), new google.maps.LatLng(48.831278, -123.00705), new google.maps.LatLng(49.001619, -123.32119), new google.maps.LatLng(49.00252, -122.497902), new google.maps.LatLng(48.997339, -121.755638), new google.maps.LatLng(49.000042, -121.385193), new google.maps.LatLng(49.000042, -120.669022), new google.maps.LatLng(48.999366, -120.051727), new google.maps.LatLng(49.000042, -119.621887), new google.maps.LatLng(49.000042, -119.102097), new google.maps.LatLng(49.000042, -118.652687), new google.maps.LatLng(49.000267, -118.22216), new google.maps.LatLng(48.999817, -117.933769), new google.maps.LatLng(49.000493, -117.635765), new google.maps.LatLng(48.9991, -117.0323), //  top right
		new google.maps.LatLng(48.999, -117.031), new google.maps.LatLng(46.354, -117.06), new google.maps.LatLng(46.168, -116.921), new google.maps.LatLng(46.088, -116.981), new google.maps.LatLng(45.995, -116.914), //  bottom right
		new google.maps.LatLng(46, -118.985), new google.maps.LatLng(45.699, -120.401), new google.maps.LatLng(45.746, -120.633), new google.maps.LatLng(45.606, -121.182), new google.maps.LatLng(45.705, -121.336), new google.maps.LatLng(45.707, -121.809), new google.maps.LatLng(45.544, -122.295), new google.maps.LatLng(45.657, -122.762), new google.maps.LatLng(46.084, -122.902), new google.maps.LatLng(46.161, -123.226), new google.maps.LatLng(46.224, -123.426), new google.maps.LatLng(46.262, -123.664), new google.maps.LatLng(46.256, -123.951), new google.maps.LatLng(46.267, -123.97), new google.maps.LatLng(46.298, -124.028), new google.maps.LatLng(46.267, -124.034) //  bottom left
		],
		'West Virginia': [new google.maps.LatLng(39.321, -77.719), //  right of virginia border
		new google.maps.LatLng(39.132, -77.828), new google.maps.LatLng(39.465, -78.347), new google.maps.LatLng(39.166, -78.405), new google.maps.LatLng(38.762, -78.869), new google.maps.LatLng(38.846, -78.999), new google.maps.LatLng(38.421, -79.28), new google.maps.LatLng(38.591, -79.649), new google.maps.LatLng(38.271, -79.788), new google.maps.LatLng(37.689, -80.307), new google.maps.LatLng(37.627, -80.221), new google.maps.LatLng(37.508, -80.299), new google.maps.LatLng(37.426, -80.466), new google.maps.LatLng(37.429, -80.859), new google.maps.LatLng(37.317, -80.896), new google.maps.LatLng(37.234, -81.225), new google.maps.LatLng(37.337, -81.362), new google.maps.LatLng(37.201, -81.677), new google.maps.LatLng(37.359, -81.927), new google.maps.LatLng(37.538, -81.968), //  left of virigina border
		new google.maps.LatLng(37.678, -82.304), new google.maps.LatLng(37.93, -82.5), new google.maps.LatLng(37.98, -82.464), new google.maps.LatLng(38.162, -82.643), new google.maps.LatLng(38.421, -82.594), //  top of Kentucky Border
		new google.maps.LatLng(38.445, -82.328), new google.maps.LatLng(38.593, -82.274), new google.maps.LatLng(38.596, -82.268), new google.maps.LatLng(38.605, -82.176), new google.maps.LatLng(38.787, -82.221), new google.maps.LatLng(39.025, -82.037), new google.maps.LatLng(38.875, -81.899), new google.maps.LatLng(38.923, -81.766), new google.maps.LatLng(39.077, -81.814), new google.maps.LatLng(39.268, -81.686), new google.maps.LatLng(39.268, -81.57), new google.maps.LatLng(39.41, -81.453), new google.maps.LatLng(39.342, -81.375), new google.maps.LatLng(39.387, -81.217), new google.maps.LatLng(39.625, -80.878), new google.maps.LatLng(40.313, -80.602), new google.maps.LatLng(40.584, -80.667), new google.maps.LatLng(40.638, -80.519), //  top point
		new google.maps.LatLng(39.721, -80.519), new google.maps.LatLng(39.721, -79.477), //  right of Pennsylvania border
		new google.maps.LatLng(39.202, -79.473), new google.maps.LatLng(39.474, -79.105), new google.maps.LatLng(39.441, -78.958), new google.maps.LatLng(39.645, -78.776), new google.maps.LatLng(39.544, -78.687), new google.maps.LatLng(39.516, -78.468), new google.maps.LatLng(39.624, -78.428), new google.maps.LatLng(39.696, -78.174), new google.maps.LatLng(39.603, -77.834), new google.maps.LatLng(39.552, -77.887), new google.maps.LatLng(39.496, -77.766), new google.maps.LatLng(39.321, -77.719) //  top of virginia
		],
		'Wisconsin': [new google.maps.LatLng(43.501, -91.217), //  top of Iowa border
		new google.maps.LatLng(43.353, -91.206), new google.maps.LatLng(43.258, -91.062), new google.maps.LatLng(43.252, -91.059), new google.maps.LatLng(43.125, -91.178), new google.maps.LatLng(42.751, -91.065), new google.maps.LatLng(42.634, -90.707), new google.maps.LatLng(42.508, -90.64), //  bottom left
		new google.maps.LatLng(42.493365, -87.020302), //  bottom right
		new google.maps.LatLng(42.73264, -87.053947), new google.maps.LatLng(43.378602, -87.147331), new google.maps.LatLng(43.499507, -87.137032), new google.maps.LatLng(43.670355, -87.125359), new google.maps.LatLng(43.733399, -87.114029), new google.maps.LatLng(43.999483, -87.046051), new google.maps.LatLng(44.130232, -87.013092), new google.maps.LatLng(44.161273, -87.000046), new google.maps.LatLng(44.499934, -86.85482), new google.maps.LatLng(44.881661, -86.685219), new google.maps.LatLng(45.081036, -86.499481), new google.maps.LatLng(45.236218, -86.250916), new google.maps.LatLng(45.437008, -86.750793), new google.maps.LatLng(45.437008, -87.102356), new google.maps.LatLng(45.205263, -87.40448), new google.maps.LatLng(45.0774, -87.442932), new google.maps.LatLng(45.096, -87.585), //  marionette
		new google.maps.LatLng(45.175, -87.735), new google.maps.LatLng(45.369, -87.66), new google.maps.LatLng(45.353, -87.884), new google.maps.LatLng(45.685, -87.783), new google.maps.LatLng(45.81, -88.131), new google.maps.LatLng(45.921, -88.103), new google.maps.LatLng(46.272, -89.8), new google.maps.LatLng(46.3, -89.929), new google.maps.LatLng(46.566, -90.417), //  top of wi right land border
		new google.maps.LatLng(47.290408, -89.958801), new google.maps.LatLng(47.309034, -90.653687), new google.maps.LatLng(46.702202, -92.015991), new google.maps.LatLng(46.748801, -92.088432), //  superior
		new google.maps.LatLng(46.664, -92.291), new google.maps.LatLng(46.074, -92.293), new google.maps.LatLng(45.891, -92.712), new google.maps.LatLng(45.707, -92.87), new google.maps.LatLng(45.574, -92.882), new google.maps.LatLng(45.438, -92.645), new google.maps.LatLng(45.289, -92.761), new google.maps.LatLng(44.751, -92.808), new google.maps.LatLng(44.569, -92.549), new google.maps.LatLng(44.363, -91.965), new google.maps.LatLng(44.2, -91.875), new google.maps.LatLng(43.996, -91.431), new google.maps.LatLng(43.776, -91.245), new google.maps.LatLng(43.501, -91.217) //  bottom right
		],
		'Wyoming': [new google.maps.LatLng(41.001, -104.053), //  bottom right
		new google.maps.LatLng(43.002, -104.056), //  top of NE border
		new google.maps.LatLng(44.998, -104.057), //  top right
		new google.maps.LatLng(45.001, -111.054), //  top left
		new google.maps.LatLng(44.475, -111.052), //  left side of WY border
		new google.maps.LatLng(42.001, -111.045), //  bottom of Idaho border
		new google.maps.LatLng(41, -111.045) //  bottom left
		]
	};
}



/***/ }),

/***/ "LQCu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d0873a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Q0cO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d0873a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

// import { getAbbreviation } from '../../helpers/state-abbreviation'
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'thankyou',
	created: function created() {},
	mounted: function mounted() {
		// console.log('im here', this.$store.getters.selectedAreas)
		// this.abbr = getAbbreviation()
		// console.log(this.abbr)
		this.initData();
	},
	data: function data() {
		return {
			// polygons : {},
			// excludedAreas: [],
			// selectedAreas: [],
			// abbr: {},
			company: null
		};
	},

	methods: {
		initData: function initData() {
			this.company = this.$store.getters.company;
			// this.selectedAreas = _.groupBy(this.$store.getters.selectedAreas,function(area){ return area.state })
			// let context = this;
			// _.forEach(context.selectedAreas,function (area,index) {
			// 	context.selectedAreas[index] = _.map(area,"area_code")
			// })

			// this.excludedAreas = this.$store.getters.excludedAreas
			// console.log(this.excludedAreas)
		}
	}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__("kpqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Shared_Header_Header__ = __webpack_require__("rEio");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Shared_Loader_Loader__ = __webpack_require__("IIcV");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-header', __WEBPACK_IMPORTED_MODULE_6__pages_Shared_Header_Header__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-loader', __WEBPACK_IMPORTED_MODULE_7__pages_Shared_Loader_Loader__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "PlTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-form-wrapper d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"col-md-6 col-sm-8 search-box p-0 m-0"},[_c('div',{staticClass:"form-wrapper py-4 px-5"},[_c('h1',{staticClass:"xl-font ls-1 text-center my-3"},[_vm._v("Enter Client ID")]),_vm._v(" "),_c('p',{staticClass:"sm-font ls-1"},[_vm._v("Your client ID was emailed to you when you were given access to the mover map tool. Please contact our support team if you need help with your ID.\n            ")]),_vm._v(" "),_c('form',{staticClass:"search-form mx-2 mt-4",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.searchClient($event)}}},[_c('div',{staticClass:"form-group m-0"},[_c('label',{staticClass:"md-font"},[_vm._v("Login")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.login),expression:"login"}],staticClass:"form-control md-font",class:{ error_border: _vm.error_message_login },attrs:{"name":"login","placeholder":"","autocomplete":"off","autofocus":"true"},domProps:{"value":(_vm.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.login=$event.target.value}}}),_vm._v(" "),(_vm.error_message_login)?_c('label',{staticClass:"error md-font ls-1 fw-5"},[_vm._v(_vm._s(_vm.error_message_login))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group m-0 mt-2"},[_c('label',{staticClass:"md-font"},[_vm._v("Client ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.client_id),expression:"client_id"}],staticClass:"form-control md-font",class:{ error_border: _vm.error_message },attrs:{"name":"client_id","placeholder":"","autocomplete":"off"},domProps:{"value":(_vm.client_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.client_id=$event.target.value}}}),_vm._v(" "),(_vm.error_message)?_c('label',{staticClass:"error md-font ls-1 fw-5"},[_vm._v(_vm._s(_vm.error_message))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"submit d-flex justify-content-center mt-3"},[_c('button',{staticClass:"btn get-started l-font ls-1 w-100",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.loading ? "" : "get started")),(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e()])])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info my-4 mx-2 text-center"},[_c('h3',{staticClass:"sm-font ls-1"},[_vm._v("Forgot Client ID or have a question? "),_c('span',{staticClass:"primary pointer"},[_c('a',{staticClass:"primary",attrs:{"href":"mailto:support@irelo.com"}},[_c('u',[_vm._v("Contact Support ")]),_c('i',{staticClass:"fa fa-caret-right",attrs:{"aria-hidden":"true"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q0cO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R1R4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_state_exclusion_script_js__ = __webpack_require__("t/6b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425981d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_state_exclusion_template_html__ = __webpack_require__("hHq0");
function injectStyle (ssrContext) {
  __webpack_require__("EyOh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_state_exclusion_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425981d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_state_exclusion_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wpal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid w-100 p-0 review-wrapper"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"order"},[_c('h1',{staticClass:"xl-font fs-1 heading pb-2 ml-1"},[_vm._v("Filter Set Created")]),_vm._v(" "),_c('div',{staticClass:"order-table py-4"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.partners),function(partner,key){return _c('div',{staticClass:"row order-data w-98 mx-auto mt-3"},[_c('div',{staticClass:"col-md-1 p-4 success text-center d-flex flex-row align-items-center "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(partner.completed),expression:"partner.completed"}],staticClass:"form-control checkbox m-auto",attrs:{"type":"checkbox","name":"completed"},domProps:{"checked":Array.isArray(partner.completed)?_vm._i(partner.completed,null)>-1:(partner.completed)},on:{"change":[function($event){var $$a=partner.completed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(partner, "completed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(partner, "completed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(partner, "completed", $$c)}},function($event){_vm.setCompleted(partner)}]}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3  align-items-center text-center justify-content-center l-font d-flex"},[_c('strong',{class:{strike: partner.completed }},[_vm._v(_vm._s(partner.client_id))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 align-items-center text-center justify-content-center l-font d-flex flex-row flex-wrap"},[_c('p',{staticClass:"m-0",class:{strike: partner.completed }},[_c('strong',[_vm._v(_vm._s(partner.zipcodes))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2  align-items-center text-center justify-content-center l-font d-flex"},[_c('button',{staticClass:"get-started btn py-2",on:{"click":function($event){_vm.refreshUser(partner,key)}}},[_vm._v("Refresh")])])])})],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row w-98 m-auto"},[_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center l-font grey"},[_c('h3',{staticClass:"l-font"},[_vm._v("Partner ID")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-center l-font grey"},[_c('h3',{staticClass:"l-font"},[_vm._v("Filter ID")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YWhn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
    states: {
        "Alabama": "AL",
        "Alaska": "AK",
        "Arizona": "AZ",
        "Arkansas": "AR",
        "California": "CA",
        "Colorado": "CO",
        "Connecticut": "CT",
        "Delaware": "DE",
        "District of Columbia": "DC",
        "Florida": "FL",
        "Georgia": "GA",
        "Hawaii": "HI",
        "Idaho": "ID",
        "Illinois": "IL",
        "Indiana": "IN",
        "Iowa": "IA",
        "Kansas": "KS",
        "Kentucky": "KY",
        "Louisiana": "LA",
        "Maine": "ME",
        "Maryland": "MD",
        "Massachusetts": "MA",
        "Michigan": "MI",
        "Minnesota": "MN",
        "Mississippi": "MS",
        "Missouri": "MO",
        "Montana": "MT",
        "Nebraska": "NE",
        "Nevada": "NV",
        "New Hampshire": "NH",
        "New Jersey": "NJ",
        "New Mexico": "NM",
        "New York": "NY",
        "North Carolina": "NC",
        "North Dakota": "ND",
        "Ohio": "OH",
        "Oklahoma": "OK",
        "Oregon": "OR",
        "Pennsylvania": "PA",
        "Puerto Rico": "PR",
        "Rhode Island": "RI",
        "South Carolina": "SC",
        "South Dakota": "SD",
        "Tennessee": "TN",
        "Texas": "TX",
        "Utah": "UT",
        "Vermont": "VT",
        "Virginia": "VA",
        "Washington": "WA",
        "West Virginia": "WV",
        "Wisconsin": "WI",
        "Wyoming": "WY"
    },
    getAbbreviationByState: function getAbbreviationByState(name) {
        // return _.has(this.states[name]) ? this.states[name] : '';
        return this.states[name];
    },
    getStateByAbbreviation: function getStateByAbbreviation(abbr) {
        var reverse_states = __WEBPACK_IMPORTED_MODULE_0_lodash__["invert"](this.states);
        // return _.has(reverse_states[name]) ? reverse_states[name] : ''; 
        return reverse_states[abbr];
    },
    getStatesByAbbreviations: function getStatesByAbbreviations(abbr) {
        var reverse_states = __WEBPACK_IMPORTED_MODULE_0_lodash__["invert"](this.states);
        var response = [];
        if (abbr && abbr.length) {
            __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](abbr, function (next_item) {
                response.push(reverse_states[next_item]);
            });
        }
        return response;
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home_Home__ = __webpack_require__("n/G1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Pickup_Pickup__ = __webpack_require__("gQs4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Pickup_GetClient_GetClient__ = __webpack_require__("dRyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Pickup_GetState_GetState__ = __webpack_require__("Jonm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Pickup_GetCode_GetCode__ = __webpack_require__("d54m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Pickup_GetExclusion_GetStateExclusion__ = __webpack_require__("R1R4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Review_Review__ = __webpack_require__("f2OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Admin_Admin__ = __webpack_require__("wbxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Thankyou_Thankyou__ = __webpack_require__("F4Cq");












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'home',
		component: __WEBPACK_IMPORTED_MODULE_2__pages_Home_Home__["a" /* default */]
	}, {
		path: '/pickup',
		component: __WEBPACK_IMPORTED_MODULE_3__pages_Pickup_Pickup__["a" /* default */],
		children: [{
			path: 'client-login',
			name: 'client-login',
			component: __WEBPACK_IMPORTED_MODULE_4__pages_Pickup_GetClient_GetClient__["a" /* default */]
		}, {
			path: 'get-state',
			name: 'get-state',
			component: __WEBPACK_IMPORTED_MODULE_5__pages_Pickup_GetState_GetState__["a" /* default */]
		}, {
			path: 'get-state-exclusion',
			name: 'get-state-exclusion',
			component: __WEBPACK_IMPORTED_MODULE_7__pages_Pickup_GetExclusion_GetStateExclusion__["a" /* default */]
		}, {
			path: 'get-code/:state',
			name: 'get-code',
			component: __WEBPACK_IMPORTED_MODULE_6__pages_Pickup_GetCode_GetCode__["a" /* default */],
			props: true
		}]
	}, {
		path: '/review',
		name: 'review',
		component: __WEBPACK_IMPORTED_MODULE_8__pages_Review_Review__["a" /* default */]
	}, {
		path: '/admin',
		name: 'admin',
		component: __WEBPACK_IMPORTED_MODULE_9__pages_Admin_Admin__["a" /* default */]
	}, {
		path: '/thankyou',
		name: 'thankyou',
		component: __WEBPACK_IMPORTED_MODULE_10__pages_Thankyou_Thankyou__["a" /* default */]
	}],
	mode: 'history'
}));

/***/ }),

/***/ "Zvfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var state = {
	map: null,
	states: null,
	selected_state: null,
	area_codes: null,
	// selected_areas: [],
	// excluded_areas: [],
	polygons: {}
};

var getters = {
	map: function map(state) {
		return state.map;
	},
	states: function states(state) {
		return state.states;
	},
	selectedState: function selectedState(state) {
		return state.selected_state;
	},
	areaCodes: function areaCodes(state) {
		return state.area_codes;
	},
	// selectedAreas: state => { return state.selected_areas },
	polygons: function polygons(state) {
		return state.polygons;
	}
};

var mutations = {
	setmap: function setmap(state, map) {
		state.map = map;
	},
	setStates: function setStates(state, boundary) {
		state.states = boundary;
	},
	setSelectedState: function setSelectedState(state, polygon) {
		state.selected_state = polygon;
	},
	setAreaCodes: function setAreaCodes(state, areacodes) {
		state.area_codes = areacodes;
	}
};

var actions = {
	// addAreaCode ({commit}, params) {
	// 	let area = {area_code: params.city.area_code, state: params.selectedstate}
	// 	commit('setSelectedAreas', area)
	// },
	// removeAreaCode ({commit, state}, params) {
	// 	var index = state.selected_areas.findIndex(area => { return area.area_code === params.area_code })
	// 	if (index > -1) {
	// 		commit('removeFromSelectedAreas', index)
	// 	}
	// },
	removePolygons: function removePolygons(_ref) {
		var state = _ref.state;

		__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"](state.polygons, function (polygon) {
			polygon.setMap(null);
			polygon = null;
		});
		console.log('here removing polygons', state.polygons);
		// state.polygons = {}
	},
	removeAreaCodes: function removeAreaCodes(_ref2) {
		var state = _ref2.state;

		__WEBPACK_IMPORTED_MODULE_0_lodash__["forEach"](state.area_codes, function (area) {
			if (!area.mapLabel || !area.polygon) return;
			area.mapLabel.close();
			area.polygon.setMap(null);
		});
		state.area_codes = {};
		state.selected_state = null;
	}
	// addExclusionPolygon ({state}, params) {
	// 	console.log('name', params.state)
	// 	state.excluded_areas.push(params.state)
	// },
	// removeExclusionPolygon ({state}, params) {
	// 	console.log('index', params)
	// 	state.excluded_areas.splice(params.index, 1)
	// }

};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions
});

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "aa/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_state_selector__ = __webpack_require__("KMmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_state_abbreviation__ = __webpack_require__("YWhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__ = __webpack_require__("A0ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_map_helper__ = __webpack_require__("gs7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'get-state',
  data: function data() {
    return {
      polygons: {},
      show_tag_box: false,
      tag_line: 'Begin by selecting a state you pickup moves in.',
      exclusion: false,
      infoboxes: {},
      tootip_display: false,
      tagline_2: false,
      loading: false,
      processing: false,
      showStateHelp: false,
      showUnselectStateHelp: false,
      showStateHelp2: false
    };
  },
  created: function created() {},
  mounted: function mounted() {

    // this.showInitialHelperMsg();
    this.fetchFilterSetsAndDetails();
  },
  destroyed: function destroyed() {
    this.$store.dispatch('removePolygons');
    this.$store.dispatch("removeSelectedAreas");
  },

  methods: {
    showInitialHelperMsg: function showInitialHelperMsg() {
      var _this = this;

      var showText = localStorage.getItem('showGetStateHelpText');
      if (!showText) {
        this.showStateHelp = true;
        localStorage.setItem('showGetStateHelpText', true);
        setTimeout(function () {
          _this.showStateHelp = false;
        }, 7000);
      }
    },
    showSecondHelperMsg: function showSecondHelperMsg() {
      var _this2 = this;

      var showText = localStorage.getItem('showGetStateHelpText2');
      if (!showText) {
        this.showStateHelp2 = true;
        localStorage.setItem('showGetStateHelpText2', true);
        setTimeout(function () {
          _this2.showStateHelp2 = false;
        }, 7000);
      }
    },
    showUnselectHelperMsg: function showUnselectHelperMsg() {
      var _this3 = this;

      var showUnselectText = localStorage.getItem('showUnselectStateHelpText');
      if (!showUnselectText) {
        this.showUnselectStateHelp = true;
        localStorage.setItem('showUnselectStateHelpText', true);
        setTimeout(function () {
          _this3.showUnselectStateHelp = false;
        }, 7000);
      }
    },
    fetchFilterSetsAndDetails: function fetchFilterSetsAndDetails() {
      var _this4 = this;

      if (this.$store.getters.selectedAreas.length < 1) {
        this.loading = true;
        this.fetchAreas().then(function (val) {
          if (_this4.$store.getters.selectedAreas.length) {
            __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].getFilterSetDetails().then(function (val) {
              _this4.loading = false;
            }).catch(function (err) {
              _this4.loading = false;
              alert("Something went Wrong");
            });
          } else {
            _this4.loading = false;
          }
        });
      } else {
        this.checkMap();
      }
    },
    fetchAreas: function fetchAreas() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var api_url = "https://movermap-api.irelo.com" + '/user/' + _this5.$store.getters.clientId;
        var params = {
          'token': _this5.$store.getters.accessToken,
          'w': 'pickups'
        };

        _this5.$http.get(api_url, { params: params }).then(function (response) {
          response = response.data || response;

          if (response) {
            if (response.completed_process) {
              _this5.$router.push('/thankyou');
              return;
            }

            var filter_sets = response.filter_sets || [];
            if (!response.completed_process) {
              filter_sets = [];
            }

            __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].setUserData(response);
            __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].setSelectedAreas(filter_sets);
          }
          _this5.checkMap();

          resolve(true);
        }).catch(function (error) {
          _this5.loading = false;
          if (error.status && error.status == 401) {
            localStorage.setItem('access_token', '');
            localStorage.setItem('client_id', '');
            localStorage.setItem('user', '');

            _this5.$store.commit('setAccessToken', null);
            _this5.$store.commit('setClientId', null);
            _this5.$store.commit('setUser', null);
            _this5.$router.push('/pickup/client-login');
          }
          console.log(error);
        });
      });
    },
    closeHelperMsg: function closeHelperMsg(id) {
      document.getElementById(id).style.display = 'none';
    },
    checkMap: function checkMap() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_5__helpers_map_helper__["a" /* default */]._isGoogleLoaded({ infobox: true }).then(function (val) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_map_helper__["a" /* default */].refreshMap().then(function (val) {
          _this6.makePolygons();
          setTimeout(function () {
            _this6.showInitialHelperMsg();
          }, 1000);
        });
      });
    },
    initSelectedStates: function initSelectedStates() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_5__helpers_map_helper__["a" /* default */].initSelectedStates();
      this.exclusion = false;

      var selected_areas = this.$store.getters.selectedAreas;
      if (selected_areas.length) {

        if (this.showUnselectStateHelp) {
          setTimeout(function () {
            _this7.showSecondHelperMsg();
          }, 7000);
        } else {
          this.showSecondHelperMsg();
        }

        this.exclusion = true;
      }
    },
    polygonHoverListeners: function polygonHoverListeners(stateData) {
      var _this8 = this;

      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseover', function () {
        if (_this8.$store.getters.polygons[stateData]) {
          _this8.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 });
        }
      });
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseout', function () {
        if (stateData !== _this8.$store.getters.selectedState && _this8.$store.getters.polygons[stateData]) {
          _this8.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
        }
      });
    },
    polygonClickListner: function polygonClickListner(stateData) {
      var _this9 = this;

      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'click', function () {
        if (_this9.tootip_display) {
          _this9.hideTooltip(_this9.$store.getters.selectedState);
          _this9.deselectPolygon(_this9.$store.getters.selectedState);
          if (stateData == _this9.$store.getters.selectedState) {
            _this9.$store.commit('setSelectedState', null);
            return;
          }
        }
        _this9.$store.commit('setSelectedState', stateData);
        _this9.showTooltip(stateData);
        _this9.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 });
      });
    },
    makePolygons: function makePolygons() {
      var _this10 = this;

      this.$store.getters.map.setZoom(5);
      var boundaries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_state_selector__["a" /* getBoundaries */])();
      this.$store.commit('setStates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(boundaries));

      __WEBPACK_IMPORTED_MODULE_6_lodash__["forEach"](this.$store.getters.states, function (stateData) {

        __WEBPACK_IMPORTED_MODULE_5__helpers_map_helper__["a" /* default */].makeStatePolygon(stateData, boundaries, []);
        _this10.polygonHoverListeners(stateData);
        _this10.polygonClickListner(stateData);
        _this10.$store.getters.polygons[stateData].setMap(_this10.$store.getters.map);
      });
      this.initSelectedStates();
      return;
    },
    selectPolygon: function selectPolygon(polygon) {
      this.$store.dispatch('removePolygons');
      var bounds = new google.maps.LatLngBounds();
      var boundaries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_state_selector__["a" /* getBoundaries */])();
      for (var i = 0; i < polygon.getPath().length; i++) {
        var point = new google.maps.LatLng(boundaries[this.$store.getters.selectedState][i].lat(), boundaries[this.$store.getters.selectedState][i].lng());
        bounds.extend(point);
      }
      polygon.setOptions({ strokeOpacity: 1, fillOpacity: 0.3 });

      this.hideTooltip(this.$store.getters.selectedState);
      this.$router.push('/pickup/get-code/' + this.$store.getters.selectedState);
    },
    deselectPolygon: function deselectPolygon(stateData) {
      this.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
    },
    startExclusionProcess: function startExclusionProcess() {

      var selected_areas = this.$store.getters.selectedAreas;
      __WEBPACK_IMPORTED_MODULE_6_lodash__["forEach"](selected_areas, function (area) {
        delete area.inner_circle;
        delete area.inner_inner_circle;
        delete area.outer_circle;
        delete area.polygon;
      });

      if (this.tootip_display) {
        this.hideTooltip(this.$store.getters.selectedState);
      }
      this.$router.push('/pickup/get-state-exclusion');
    },
    showTooltip: function showTooltip(state) {
      var selected_area = __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].getSelectedArea(state);
      var template = "";
      if (!selected_area || selected_area && selected_area.area_codes.length == 0) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: " + state + "</h3><div class='m-auto w-100 button_div'><button area='" + state + "' id='selectstate' class='sm-font ls-1 text-center'>Entire State</button><button class='sm-font ls-1 text-center b2' area='" + state + "' id='selectareacodes' >Specific Area Codes</button></div></div>";
      } else if (selected_area && selected_area.area_codes.length && selected_area.area_codes.length < selected_area.total_area_codes) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: " + state + "</h3><div class='m-auto w-100 button_div'><button area='" + state + "' id='selectstate' class='sm-font ls-1 text-center'>Entire State</button><button area='" + state + "' id='deselectstate' class='sm-font ls-1 text-center b2'>Unselect Entire State</button><button class='sm-font ls-1 text-center b2' area='" + state + "' id='selectareacodes' >Specific Area Codes</button></div></div>";
      } else if (selected_area && selected_area.area_codes.length == selected_area.total_area_codes) {
        template = "<div class='arrow_box infobox' ><h3 class='l-font ls-1 text-center infobox_header w-100 m-0'>Pickup: " + state + "</h3><div class='m-auto w-100 button_div'><button area='" + state + "' id='deselectstate' class='sm-font ls-1 text-center'>Unselect Entire State</button><button class='sm-font ls-1 text-center b2' area='" + state + "' id='selectareacodes' >Specific Area Codes</button></div></div>";
      }

      this.infoboxes[state] = new InfoBox({
        content: template,
        disableAutoPan: false,
        maxWidth: 150,
        alignBottom: true,
        pixelOffset: new google.maps.Size(-50, 0),
        zIndex: null,
        boxStyle: {
          opacity: 1,
          zIndex: 999,
          width: "260px"
          // height: (!selected_area || !selected_area.area_codes.length) ? "200px" : "230px",
          // overflow: "hidden"
        },
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        enableEventPropagation: false
      });
      var latlng = new google.maps.LatLng({ lat: this.$store.getters.polygons[state].my_getBounds().getCenter().lat(), lng: this.$store.getters.polygons[state].my_getBounds().getCenter().lng() });
      this.infoboxes[state].setPosition(latlng);
      this.infoboxes[state].open(this.$store.getters.map);
      this.tootip_display = true;
      var context = this;

      context.infoboxes[state].addListener("domready", function (state) {
        document.getElementById("selectareacodes").addEventListener("click", function (e, state) {
          var area = e.target.getAttribute('area');
          context.selectPolygon(context.$store.getters.polygons[area]);
        });
        if (!selected_area || selected_area && (!selected_area.total_area_codes || selected_area.area_codes.length < selected_area.total_area_codes)) {
          document.getElementById("selectstate").addEventListener("click", function (e) {
            var area = e.target.getAttribute('area');
            context.selectEntireState(area);
          });
        }
        if (selected_area && selected_area.area_codes.length) {
          document.getElementById("deselectstate").addEventListener("click", function (e) {
            var area = e.target.getAttribute('area');
            context.unselectEntireState(area);
          });
        }
      });
    },
    hideTooltip: function hideTooltip(state) {
      this.infoboxes[state].setMap(null);
      this.infoboxes[state] = null;
      this.tootip_display = false;
    },
    unselectEntireState: function unselectEntireState(state) {
      this.hideTooltip(state);
      var selected_area = __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].getSelectedArea(state);
      if (selected_area) {
        console.log('state is ', state, selected_area);
        selected_area.area_codes = [];
        selected_area.status = "Not Active";

        this.$store.commit('updateSelectedArea', selected_area);
      }
      this.$store.dispatch('removeSelectedAreas');
      this.deselectPolygon(state);
      this.$store.commit('setSelectedState', null);
      this.initSelectedStates();
    },
    selectEntireState: function selectEntireState(state) {
      var _this11 = this;

      console.log('select entire state', state);
      this.loading = true;
      //fetch area codes, add them to store
      this.hideTooltip(state);
      this.deselectPolygon(state);
      this.$http.get('https://valet.irelo.com/api/service/areacodes/' + state).then(function (response) {
        _this11.$store.dispatch("removeSelectedAreas");
        var area_codes = response.data || response;

        var is_new = false;
        var selected_area = __WEBPACK_IMPORTED_MODULE_4__helpers_mover_helper__["a" /* default */].getSelectedArea(state);
        if (!selected_area) {
          is_new = true;
          selected_area = {
            abbreviation: __WEBPACK_IMPORTED_MODULE_3__helpers_state_abbreviation__["a" /* default */].getAbbreviationByState(state),
            state: state,
            area_codes: []
          };
        }
        selected_area.area_codes = [];
        selected_area.status = "Active";
        __WEBPACK_IMPORTED_MODULE_6_lodash__["forEach"](area_codes, function (next_item) {
          selected_area.area_codes.push({
            zip_code: __WEBPACK_IMPORTED_MODULE_6_lodash__["join"](next_item.zipcode_list, ","),
            area_code: next_item.area_code
          });
          // this.$store.dispatch('addAreaCode', {"area_code": next_item, "state": this.$store.getters.selectedState})
        });
        selected_area.total_area_codes = response.data.length;

        if (is_new) {
          _this11.$store.dispatch('addSelectedArea', selected_area);
        } else {
          _this11.$store.commit('updateSelectedArea', selected_area);
        }

        _this11.$store.commit('setSelectedState', null);
        _this11.loading = false;
        _this11.showUnselectHelperMsg();
        _this11.initSelectedStates();
      });
    }
  }
});

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	user: {},
	access_token: null,
	client_id: null,
	company: null,
	selected_areas: [],
	excluded_areas: [],
	tobe_deactivated: []
};

var getters = {
	user: function user(state) {
		return state.user;
	},
	accessToken: function accessToken(state) {
		return state.access_token;
	},
	clientId: function clientId(state) {
		return state.client_id;
	},
	company: function company(state) {
		return state.company;
	},
	selectedAreas: function selectedAreas(state) {
		return state.selected_areas;
	},
	excludedAreas: function excludedAreas(state) {
		return state.excluded_areas;
	},
	tobeDeactivated: function tobeDeactivated(state) {
		return state.tobe_deactivated;
	}
};

var mutations = {
	setUser: function setUser(state, user) {
		state.user = user;
	},
	setAccessToken: function setAccessToken(state, access_token) {
		state.access_token = access_token;
	},
	setCompany: function setCompany(state, company) {
		state.company = company;
	},
	setClientId: function setClientId(state, client_id) {
		state.client_id = client_id;
	},
	setSelectedAreas: function setSelectedAreas(state, areas) {
		state.selected_areas = areas || [];
	},
	addSelectedArea: function addSelectedArea(state, area) {
		state.selected_areas.push(area);
		console.log('Add Pickups', state.selected_areas);
	},
	removeSelectedArea: function removeSelectedArea(state, state_abbr) {
		state.selected_areas = _.filter(state.selected_areas, function (next_item) {
			if (next_item.abbreviation == state_abbr && next_item.filter_set_id) {
				state.tobe_deactivated.push(next_item);
				return true;
			}
			return next_item.abbreviation != state_abbr;
		});

		// change filter status
		var index = _.findIndex(state.selected_areas, function (area) {
			return area.abbreviation == state_abbr;
		});
		if (index > -1) {
			state.selected_areas[index].status = "Not Active";
		}

		console.log('Remove Pickups', state.selected_areas);
		console.log('To Be Deactivated Pickups', state.tobe_deactivated);
	},
	updateSelectedArea: function updateSelectedArea(state, selected_area) {
		var state_abbr = selected_area.abbreviation;
		var index = _.findIndex(state.selected_areas, { abbreviation: state_abbr });

		if (index > -1) {
			state.selected_areas[index] = selected_area;
			console.log('Updated Pickup', state.selected_areas);
		}
	},
	setExcludedAreas: function setExcludedAreas(state, areas) {
		state.excluded_areas = areas || [];
		console.log('set excluded areas', state.excluded_areas);
		// let new_areas = [] 
		// new_areas = areas.map(area=>{return area.state});
		// console.log(new_areas)
		// state.excluded_areas = new_areas || [];
	}
};

var actions = {
	addSelectedArea: function addSelectedArea(_ref, area) {
		var commit = _ref.commit;

		// let area = {
		// 	area_code: params.area_code, 
		// 	state: params.state
		// }
		commit('addSelectedArea', area);
	},
	removeAreaCode: function removeAreaCode(_ref2, params) {
		var commit = _ref2.commit,
		    state = _ref2.state;

		var index = state.selected_areas.findIndex(function (area) {
			return area.area_code === params.area_code;
		});
		if (index > -1) {
			commit('removeSelectedArea', index);
		}
	},
	fetchAreas: function fetchAreas(_ref3) {
		var state = _ref3.state;

		var api_url = "https://movermap-api.irelo.com" + '/user/' + state.client_id;
		var params = {
			'token': state.access_token,
			'w': 'pickups, exclusions'
		};

		this.$http.get(api_url, params).then(function (response) {
			if (response && response.data) {
				state.selected_areas = response.data.selected || [];
				state.excluded_areas = response.data.excluded || [];
			}
		}).catch(function (error) {
			console.log(error);
		});
	},
	postSelectedAreas: function postSelectedAreas(_ref4) {
		var state = _ref4.state;

		var api_url = "https://movermap-api.irelo.com" + '/pickups';
		var params = {
			'token': state.access_token,
			'pickups': state.selected_areas
		};

		this.$http.post(api_url, params).then(function (response) {}).catch(function (error) {
			console.log(error);
		});
	},
	postExcludedAreas: function postExcludedAreas(_ref5) {
		var state = _ref5.state;

		var api_url = "https://movermap-api.irelo.com" + '/exclusions';
		var params = {
			'token': state.access_token,
			'exclusions': state.excluded_areas
		};

		this.$http.post(api_url, params).then(function (response) {}).catch(function (error) {
			console.log(error);
		});
	},
	removeSelectedAreas: function removeSelectedAreas(_ref6) {
		var state = _ref6.state;

		console.log('remove selected areas');
		_.forEach(state.selected_areas, function (area) {
			if (area.polygon) {
				area.polygon.setMap(null);
				delete area.polygon;
			}
			if (area.inner_circle) {
				area.inner_circle.setMap(null);
				delete area.inner_circle;
			}
			if (area.inner_inner_circle) {
				area.inner_inner_circle.setMap(null);
				delete area.inner_inner_circle;
			}
			if (area.outer_circle) {
				area.outer_circle.setMap(null);
				delete area.outer_circle;
			}
		});
	},
	addExclusionPolygon: function addExclusionPolygon(_ref7, params) {
		var state = _ref7.state;

		console.log('name', params);
		state.excluded_areas.push(params);
	},
	removeExclusionPolygon: function removeExclusionPolygon(_ref8, params) {
		var state = _ref8.state;

		console.log('index', params);
		state.excluded_areas.splice(params.index, 1);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions
});

/***/ }),

/***/ "bhEM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d54m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_code_script_js__ = __webpack_require__("BLLm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c844050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_code_template_html__ = __webpack_require__("43sL");
function injectStyle (ssrContext) {
  __webpack_require__("hsnW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_code_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c844050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_code_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dLd/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dRyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_client_script_js__ = __webpack_require__("uDxB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcbeb32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_client_template_html__ = __webpack_require__("PlTx");
function injectStyle (ssrContext) {
  __webpack_require__("9RQK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_get_client_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcbeb32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_get_client_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ehw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__ = __webpack_require__("A0ws");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var login = to.query.login || null;
    var client_id = to.query.client_id || null;
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    if (login && client_id) {
      var res = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].login(client_id, login).then(function (res) {
        if (res) {
          next("/pickup/get-state");
        } else {
          next(true);
        }
      });
    } else {
      if (user && !user.completed_process) {
        next("/pickup/get-state");
      } else if (user && user.completed_process) {
        next(true);
      } else {
        next(true);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  methods: {
    next: function next() {
      var user = this.$store.getters.user;

      if (!user || !user.token) {
        this.$router.push({ name: "client-login" });
      } else if (user && !user.completed_process) {
        this.$router.push({ name: "get-state" });
      } else if (user && user.completed_process) {
        this.$router.push('/thankyou');
      }
    }
  }
});

/***/ }),

/***/ "f2OH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_review_script_js__ = __webpack_require__("kKGT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862048c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_review_template_html__ = __webpack_require__("8j7n");
function injectStyle (ssrContext) {
  __webpack_require__("5D5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_review_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862048c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_review_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "gB7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"map-wrapper",class:{ compact: _vm.$route.name == 'get-code' }},[_c('div',{attrs:{"id":"map"}})]),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gQs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pickup_script_js__ = __webpack_require__("j3fC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1508920a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_pickup_template_html__ = __webpack_require__("gB7T");
function injectStyle (ssrContext) {
  __webpack_require__("jdHy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pickup_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1508920a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_pickup_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gs7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_abbreviation__ = __webpack_require__("YWhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_selector__ = __webpack_require__("KMmp");







/* harmony default export */ __webpack_exports__["a"] = ({
  _isGoogleLoaded: function _isGoogleLoaded(opts) {
    var _this = this;

    if (!this.static_promise) {
      this.static_promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window['__onGoogleLoaded'] = function (ev) {
          if (opts && opts.infobox) {
            _this.loadInfobox(function () {

              google.maps.Polygon.prototype.my_getBounds = function () {
                var bounds = new google.maps.LatLngBounds();
                this.getPath().forEach(function (element, index) {
                  bounds.extend(element);
                });
                return bounds;
              };

              resolve(window.gapi);
            });
            resolve(window.gapi);
          }
        };
        _this.loadGoogle();
      });
    }
    return this.static_promise;
  },
  loadGoogle: function loadGoogle() {
    var node = document.createElement('script');
    node.src = "https://maps.googleapis.com/maps/api/js?libraries=geometry&callback=__onGoogleLoaded&key=AIzaSyA-bauLzG4wFcSfhaqtDjaqw5wNSgxLp7g&region=US";
    node.type = 'text/javascript';
    document.getElementsByTagName('body')[0].appendChild(node);
  },
  loadInfobox: function loadInfobox(_callback) {
    var node = document.createElement('script');
    node.onload = _callback;
    node.src = '//cdn.irelo.com/shared/js/google/maps/infobox_packed.js';
    node.type = 'text/javascript';
    document.getElementsByTagName('body')[0].appendChild(node);
  },
  refreshMap: function refreshMap() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 37.964253, lng: -91.831833 },
        zoom: 5,
        scrollwheel: false
      });
      __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].commit("setmap", map);
      resolve(true);
    });
  },
  capitalize: function capitalize(name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  },
  createCircle: function createCircle(options, center) {
    var circle = new google.maps.Circle({
      strokeColor: options['strokeColor'] ? options['strokeColor'] : '#DF5435',
      strokeOpacity: options['strokeOpacity'] ? options['strokeOpacity'] : 1,
      strokeWeight: options['strokeWeight'] ? options['strokeWeight'] : 1,
      fillColor: options['fillColor'] ? options['fillColor'] : '#DF5435',
      fillOpacity: options['fillOpacity'] ? options['fillOpacity'] : 0.2,
      map: __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.map,
      radius: options['radius'] ? options['radius'] : 43000,
      center: center,
      zIndex: options['zIndex'] ? options['zIndex'] : 10
    });
    return circle;
  },
  initSelectedStateCircles: function initSelectedStateCircles(state) {
    var center = { lat: state.polygon.my_getBounds().getCenter().lat(), lng: state.polygon.my_getBounds().getCenter().lng() };

    if (state.outer_circle) {
      state.outer_circle.setMap(null);
      state.outer_circle = null;
    }
    if (!state.outer_circle) {
      state.outer_circle = this.createCircle([], center);
    }

    if (state.inner_circle) {
      state.inner_circle.setMap(null);
      state.inner_circle = null;
    }
    if (!state.inner_circle) {
      var options = {
        fillOpacity: 0.5,
        radius: 34000,
        zIndex: 11
      };
      state.inner_circle = this.createCircle(options, center);
    }

    if (state.inner_inner_circle) {
      state.inner_inner_circle.setMap(null);
      state.inner_inner_circle = null;
    }
    if (!state.inner_inner_circle) {
      var _options = {
        fillOpacity: 0.8,
        radius: 22000,
        zIndex: 12
      };
      state.inner_inner_circle = this.createCircle(_options, center);
    }
  },
  initSelectedStates: function initSelectedStates() {
    var states = __WEBPACK_IMPORTED_MODULE_3_lodash__["uniqBy"](__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.selectedAreas, 'state');
    var context = this;
    var boundaries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__state_selector__["a" /* getBoundaries */])();
    __WEBPACK_IMPORTED_MODULE_3_lodash__["forEach"](__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.selectedAreas, function (state) {
      if (state.status == "Not Active") {
        context.exclusion = true;
        return;
      }

      var state_name = context.capitalize(state.state);

      if (state.polygon) {
        state.polygon.setMap(null);
        state.polygon = null;
      }
      state.polygon = new google.maps.Polygon({
        paths: boundaries[state_name],
        strokeColor: '#DF5435',
        strokeOpacity: 0.7,
        strokeWeight: 3,
        fillColor: '#DF5435',
        fillOpacity: 0.3,
        map: __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.map,
        zIndex: 10
      });

      context.initSelectedStateCircles(state);
    });
  },
  makeStatePolygon: function makeStatePolygon(stateData, boundaries, options) {
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.polygons[stateData] = {};
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].getters.polygons[stateData] = new google.maps.Polygon({
      paths: boundaries[stateData],
      strokeColor: options['strokeColor'] ? options['strokeColor'] : '#8A8E93',
      strokeOpacity: 0,
      strokeWeight: options['strokeWeight'] ? options['strokeWeight'] : 3,
      fillColor: options['fillColor'] ? options['fillColor'] : '#8A8E93',
      fillOpacity: 0,
      zIndex: 999
    });
  }
});

/***/ }),

/***/ "h46u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hHq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center w-100 justify-content-center content-wrapper get-exclusion-wrapper"},[(_vm.showHelper)?_c('div',{staticClass:" md-font fs-1 help-text",attrs:{"id":"popup"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closepopup()}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.tag_line))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lower-corner-exclusion d-flex flex-row w-100 justify-content-between px-3 flex-wrap"},[_c('button',{staticClass:"md-font fs-1 get-started map-buttons",on:{"click":function($event){_vm.goBack()}}},[_c('p',{staticClass:"m-0"},[_vm._v("Back to Pickup Selection")])]),_vm._v(" "),_c('button',{staticClass:"md-font fs-1 get-started map-buttons orange",on:{"click":function($event){_vm.finishProcess()}}},[(!_vm.processing)?_c('p',{staticClass:"m-0"},[_vm._v("Finish Map")]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('p',{staticClass:"m-0"},[_vm._v("Saving Data "),_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})]):_vm._e()])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader-map"},[_c('app-loader')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hsnW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ht0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"col-md-12 homepage-wrapper"},[_c('div',{staticClass:"row h-100"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 d-flex get-started-button justify-content-center"},[_c('button',{staticClass:"get-started xl-font fs-1 h-100",on:{"click":function($event){_vm.next()}}},[_vm._v("Get Started")])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 box1"},[_c('section',{staticClass:"homepage-content"},[_c('div',{staticClass:"tagline-wrapper"},[_c('h1',{staticClass:"xxl-font open-sans ls-2"},[_vm._v("Let's create your mover map!")]),_vm._v(" "),_c('p',[_vm._v("Easily update your map to receive leads in your accepted pickups & deliveries through a visual map. Keep us updated on the leads you want only in the routes you move.\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"process-wrapper"},[_c('div',{staticClass:"d-flex flex-row justify-content-between steps-wrapper"},[_c('div',{staticClass:"p-0 col-6 col-sm-6 col-md-5 d-flex flex-column"},[_c('div',{staticClass:"process"},[_c('ul',{staticClass:"process-list d-flex flex-column align-contend-end"},[_c('li',{staticClass:"l-font my-3 py-3"},[_c('img',{attrs:{"src":__webpack_require__("4hlo")}}),_vm._v(" Select Pickup States")]),_vm._v(" "),_c('li',{staticClass:"l-font my-3 py-3"},[_c('img',{attrs:{"src":__webpack_require__("4hlo")}}),_vm._v(" Specify Pickup Area Codes")]),_vm._v(" "),_c('li',{staticClass:"l-font my-3 py-3"},[_c('img',{attrs:{"src":__webpack_require__("4hlo")}}),_vm._v(" Exclude Destination States")])])])]),_vm._v(" "),_c('div',{staticClass:"p-0 col-6 col-sm-7 col-md-7 step-image"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 mr-4 footer"},[_c('p',{staticClass:"xsm-font m-0 pull-right"},[_c('i',{staticClass:"fa fa-copyright",attrs:{"aria-hidden":"true"}}),_vm._v(" 2017 IRELO Chandler, AZ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7LL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j3fC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_state_selector__ = __webpack_require__("KMmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__ = __webpack_require__("A0ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__ = __webpack_require__("gs7E");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pickup',
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__["a" /* default */]._isGoogleLoaded({ infobox: true }).then(function (val) {
      _this.initMap();
    });
  },
  data: function data() {
    return {
      polygons: {},
      areaCodes: {},
      selectedAreas: []
    };
  },

  methods: {
    initMap: function initMap() {

      google.maps.Polygon.prototype.my_getBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        this.getPath().forEach(function (element, index) {
          bounds.extend(element);
        });
        return bounds;
      };
    }
  }
});

/***/ }),

/***/ "jdHy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k0Yb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kKGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__ = __webpack_require__("A0ws");


// import { getAbbreviation } from '../../helpers/state-abbreviation'


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'review',
	created: function created() {},
	mounted: function mounted() {
		console.log('im here', this.$store.getters.selectedAreas);
		// this.abbr = getAbbreviation()
		// console.log(this.abbr)
		// window.document.addEventListener('data_loaded', (e) => { 
		//     this.initData()
		//   });
		this.initData();
	},
	data: function data() {
		return {
			polygons: {},
			excludedAreas: '',
			selectedAreas: [],
			abbr: {},
			processing: false
		};
	},

	methods: {
		initData: function initData() {
			this.selectedAreas = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.selectedAreas));
			this.selectedAreas = __WEBPACK_IMPORTED_MODULE_1_lodash__["filter"](this.selectedAreas, function (selected_area) {
				return selected_area.status == 'Active';
			});

			__WEBPACK_IMPORTED_MODULE_1_lodash__["each"](this.selectedAreas, function (selected_areas) {
				var selected_area_codes = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(selected_areas.area_codes));
				var codes = __WEBPACK_IMPORTED_MODULE_1_lodash__["join"](__WEBPACK_IMPORTED_MODULE_1_lodash__["map"](selected_areas.area_codes, 'area_code'), ',');
				selected_area_codes = __WEBPACK_IMPORTED_MODULE_1_lodash__["filter"](selected_area_codes, function (area) {
					if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](area.additional_areacodes)) {
						return false;
					}
					return true;
				});
				var additonal_codes = __WEBPACK_IMPORTED_MODULE_1_lodash__["join"](__WEBPACK_IMPORTED_MODULE_1_lodash__["map"](selected_area_codes, 'additional_areacodes'), ',');
				var total_codes = additonal_codes ? codes + "," + additonal_codes : codes;
				selected_areas.area_codes = selected_areas.area_codes.length == selected_areas.total_area_codes ? 'Entire State' : total_codes;
			});

			// let context = this;
			// _.forEach(context.selectedAreas,function (area,index) {
			// 	context.selectedAreas[index] = _.map(area,"area_code")
			// })

			this.excludedAreas = __WEBPACK_IMPORTED_MODULE_1_lodash__["join"](__WEBPACK_IMPORTED_MODULE_1_lodash__["map"](this.$store.getters.excludedAreas, 'abbreviation'), ', ');
			if (this.$store.getters.excludedAreas.length) {
				this.excludedAreas += ', ';
			}
			this.excludedAreas += "AK, HI, PR";
			// console.log(this.excludedAreas)
		},
		goBack: function goBack() {
			this.$router.push({ name: "get-state" });
		},
		getLeads: function getLeads() {
			var _this = this;

			// moverHelper.saveClientData().then(response =>{
			// 	this.$router.push({ name: "thankyou" })	
			// 	}).catch(error => {

			// 	})
			var user = this.$store.getters.user;
			if (!user.completed_process) {
				this.updateUser();
			}

			this.processing = true;
			var filter_sets = __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].getFormattedData();
			var params = {
				'pickups': filter_sets,
				'token': this.$store.getters.accessToken
			};
			console.log(params);
			var api_url = "https://movermap-api.irelo.com" + '/filtersets';
			this.$http.post(api_url, params).then(function (response) {
				_this.processing = false;

				// let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
				// if (user && user.id) {
				// 	user.completed_process = 1; 
				// 	localStorage.setItem('user', JSON.stringify(user));
				// 	this.$store.commit('setUser', user);
				// }

				_this.$router.push({ name: "thankyou" });
			}).catch(function (error) {
				_this.processing = false;
				alert("Something Went Wrong");
				console.log(error);
			});
		},
		updateUser: function updateUser() {
			var params = {
				'token': this.$store.getters.accessToken,
				'completed_process': 1
			};
			this.$http.put("https://movermap-api.irelo.com" + '/user/' + this.$store.getters.clientId, params).then(function (response) {
				console.log('user updated successfully');
			}).catch(function (error) {
				console.log('user update failed', error);
			});
		}
	}
});

/***/ }),

/***/ "n/G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_script_js__ = __webpack_require__("ehw0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1406b678_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_home_template_html__ = __webpack_require__("ht0K");
function injectStyle (ssrContext) {
  __webpack_require__("/kSE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1406b678_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_home_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("u54A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rEio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_script_js__ = __webpack_require__("2Ldv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d91e33c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_header_template_html__ = __webpack_require__("7x6V");
function injectStyle (ssrContext) {
  __webpack_require__("i7LL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d91e33c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_header_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center w-100 justify-content-center content-wrapper"},[(_vm.showStateHelp)?_c('div',{staticClass:"help-text md-font ls-1",class:{more_width : _vm.tagline_2 },attrs:{"id":"helper_popup"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closeHelperMsg("helper_popup")}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.tag_line))])]):_vm._e(),_vm._v(" "),(_vm.showUnselectStateHelp)?_c('div',{staticClass:"help-text l-font ls-1 grey",attrs:{"id":"unselect_popup"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closeHelperMsg("unselect_popup")}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v("To deselect a state click on the state again and choose unselect entire state")])]):_vm._e(),_vm._v(" "),(_vm.showStateHelp2)?_c('div',{staticClass:"help-text l-font ls-1 grey",attrs:{"id":"helper_popup_2"}},[_c('span',{staticClass:"close",on:{"click":function($event){_vm.closeHelperMsg("helper_popup_2")}}},[_vm._v("x")]),_vm._v(" "),_c('p',[_vm._v("Continue selecting pickups untill you have a target dot on all states you pickup moves in, then move onto destination exclusions.")])]):_vm._e(),_vm._v(" "),(_vm.exclusion)?_c('button',{staticClass:"more_width get-started lower-corner",attrs:{"type":"button"},on:{"click":function($event){_vm.startExclusionProcess()}}},[(!_vm.processing)?_c('p',{staticClass:"m-0 md-font ls-1"},[_vm._v("Step 2: Destination Exclusions")]):_vm._e(),_vm._v(" "),(_vm.processing)?_c('p',{staticClass:"m-0 md-font ls-1"},[_vm._v("Saving Data "),_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader-map"},[_c('app-loader')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t/6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_state_selector__ = __webpack_require__("KMmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_state_abbreviation__ = __webpack_require__("YWhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mover_helper__ = __webpack_require__("A0ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_map_helper__ = __webpack_require__("gs7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_index__ = __webpack_require__("IcnI");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'get-state',
  data: function data() {
    return {
      polygons: {},
      tag_line: null,
      showHelper: false,
      exclusion: false,
      loading: true
    };
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var selected_areas = __WEBPACK_IMPORTED_MODULE_6__store_index__["a" /* default */].getters.selectedAreas;
    var user = __WEBPACK_IMPORTED_MODULE_6__store_index__["a" /* default */].getters.user;
    if (user && user.completed_process) {
      next('/thankyou');
    } else if (!selected_areas.length) {
      next('/pickup/get-state');
    }
    next(true);
  },
  created: function created() {},
  mounted: function mounted() {
    this.$store.dispatch("removeSelectedAreas");
    this.checkMap();
    this.getExcludedStates();
    this.showInitialHelperMsg();
  },
  destroyed: function destroyed() {
    this.$store.dispatch('removePolygons');
    this.$store.dispatch("removeSelectedAreas");
  },

  methods: {
    showInitialHelperMsg: function showInitialHelperMsg() {
      var _this = this;

      var showText = localStorage.getItem('showGetExclusionHelpText');
      if (!showText) {
        this.showHelper = true;
        this.tag_line = 'Select entire states you do not deliver to. Area code delivery exclusions are not accepted. AK, HI, PR are automatically added as exclusion states', localStorage.setItem('showGetExclusionHelpText', true);
        setTimeout(function () {
          _this.showHelper = false;
        }, 5000);
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: "get-state" });
    },
    closepopup: function closepopup() {
      document.getElementById('popup').style.display = 'none';
    },
    getExcludedStates: function getExcludedStates() {
      var _this2 = this;

      console.log('this.$store.getters.excludedAreas', this.$store.getters.excludedAreas);
      var user = this.$store.getters.user;
      if (!__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"](this.$store.getters.excludedAreas) || !user.completed_process) {
        this.loading = false;
        return;
      }

      var api_url = "https://movermap-api.irelo.com" + '/user/' + this.$store.getters.clientId;
      var params = {
        'token': this.$store.getters.accessToken,
        'w': 'exclusions'
      };

      this.$http.get(api_url, { params: params }).then(function (response) {
        response = response.data || response;

        if (response.completed_process) {
          _this2.$router.push('/thankyou');
          return;
        }
        _this2.$store.commit("setUser", response);

        var exclusions = response.exclusion_states;
        __WEBPACK_IMPORTED_MODULE_3__helpers_mover_helper__["a" /* default */].setExcludedAreas(exclusions);
        _this2.makePolygons();
        _this2.loading = false;
      }).catch(function (error) {
        localStorage.setItem('access_token', '');
        localStorage.setItem('client_id', '');
        localStorage.setItem('user', '');
        _this2.$store.commit('setAccessToken', null);
        _this2.$store.commit('setClientId', null);
        _this2.$store.commit('setUser', null);
        _this2.$router.push('/pickup/client-login');
      });
    },
    checkMap: function checkMap() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__helpers_map_helper__["a" /* default */]._isGoogleLoaded({ infobox: true }).then(function (val) {
        _this3.makePolygons();
      });
    },
    initSelectedStates: function initSelectedStates() {
      __WEBPACK_IMPORTED_MODULE_4__helpers_map_helper__["a" /* default */].initSelectedStates();
    },
    polygonHoverListners: function polygonHoverListners(stateData) {
      var _this4 = this;

      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseover', function () {
        if (_this4.$store.getters.excludedAreas.findIndex(function (estate) {
          return estate.state === stateData;
        }) < 0) {
          _this4.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 });
        }
      });
      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'mouseout', function () {
        if (_this4.$store.getters.excludedAreas.findIndex(function (estate) {
          return estate.state === stateData;
        }) < 0) {
          _this4.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
        }
      });
    },
    polygonClickListner: function polygonClickListner(stateData) {
      var _this5 = this;

      google.maps.event.addListener(this.$store.getters.polygons[stateData], 'click', function () {
        if (!_this5.$store.getters.polygons[stateData]) {
          return;
        }
        if (_this5.$store.getters.excludedAreas.findIndex(function (estate) {
          return estate.state === stateData;
        }) > -1) {
          _this5.unselectPolygon(_this5.$store.getters.polygons[stateData], stateData);
          return;
        }
        _this5.$store.commit('setSelectedState', stateData);
        _this5.selectPolygon(_this5.$store.getters.polygons[stateData], stateData);
      });
    },
    makePolygons: function makePolygons() {
      var _this6 = this;

      this.$store.dispatch('removeAreaCodes');
      this.$store.dispatch('removePolygons');
      this.$store.dispatch("removeSelectedAreas");

      this.$store.getters.map.setZoom(5);
      var boundaries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_state_selector__["a" /* getBoundaries */])();
      this.$store.commit('setStates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(boundaries));
      var options = {
        strokeColor: '#AAB2B5',
        strokeWeight: 2,
        fillColor: '#AAB2B5'
      };
      __WEBPACK_IMPORTED_MODULE_5_lodash__["forEach"](this.$store.getters.states, function (stateData) {

        __WEBPACK_IMPORTED_MODULE_4__helpers_map_helper__["a" /* default */].makeStatePolygon(stateData, boundaries, options);
        if (_this6.$store.getters.excludedAreas.findIndex(function (estate) {
          return estate.state === stateData;
        }) > -1) {
          _this6.$store.getters.polygons[stateData].setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 });
        }
        _this6.polygonHoverListners(stateData);
        _this6.polygonClickListner(stateData);
        _this6.$store.getters.polygons[stateData].setMap(_this6.$store.getters.map);
      });
      this.initSelectedStates();
      return;
    },
    selectPolygon: function selectPolygon(polygon, state) {
      var excluded_area = {
        state: state,
        abbreviation: __WEBPACK_IMPORTED_MODULE_2__helpers_state_abbreviation__["a" /* default */].getAbbreviationByState(state)
      };
      this.$store.dispatch('addExclusionPolygon', excluded_area);
      polygon.setOptions({ strokeOpacity: 0.4, fillOpacity: 0.4 });
    },
    unselectPolygon: function unselectPolygon(polygon, state) {
      var excluded_areas = this.$store.getters.excludedAreas;
      excluded_areas = __WEBPACK_IMPORTED_MODULE_5_lodash__["filter"](excluded_areas, function (next_item) {
        return next_item.state != state;
      });

      this.$store.commit('setExcludedAreas', excluded_areas);
      // this.$store.dispatch('removeExclusionPolygon', {index: this.$store.getters.excludedAreas.findIndex(estate => { return estate === state })})
      polygon.setOptions({ strokeOpacity: 0, fillOpacity: 0 });
    },
    finishProcess: function finishProcess() {
      this.$router.push("../review");
    }
  }
});

/***/ }),

/***/ "teaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid w-100 p-0 thankyou-wrapper"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"order"},[_c('div',{staticClass:"order-text"},[_c('h1',{staticClass:" text-center xl-font ls-1"},[_c('strong',[_vm._v("Thank you, "+_vm._s(_vm.company)+" ")])]),_vm._v(" "),_c('h3',{staticClass:" text-center col-lg-7 col-md-12 col-sm-12 l-font ls-1"},[_vm._v("Your lead service areas have been created and are being reviewed. After your first review, you will be able to access the map at anytime and update your lead selection automatically! You can always check your current lead selection while logged in under settings (lead filters).")])]),_vm._v(" "),_c('div',{staticClass:"image text-center"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u54A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_state_abbreviation__ = __webpack_require__("YWhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__ = __webpack_require__("A0ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__ = __webpack_require__("gs7E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'get-client',
  created: function created() {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__["a" /* default */]._isGoogleLoaded({ infobox: true }).then(function (val) {
      __WEBPACK_IMPORTED_MODULE_3__helpers_map_helper__["a" /* default */].refreshMap().then(function (val) {});
    });
  },
  data: function data() {
    return {
      client_id: null,
      login: null,
      error_message: null,
      error_message_login: null,
      loading: false
    };
  },

  methods: {
    searchClient: function searchClient() {
      var _this = this;

      if (!this.login) {
        this.error_message_login = "Please Enter valid login";
        setTimeout(function () {
          _this.error_message_login = null;
        }, 5000);
        return;
      }
      if (!this.client_id) {
        this.error_message = "Please enter a valid ID";
        setTimeout(function () {
          _this.error_message = null;
        }, 5000);
        return;
      }

      this.loading = true;
      this.$http.post("https://movermap-api.irelo.com" + '/auth/login', { "id": this.client_id, 'login': this.login }).then(function (response) {
        _this.loading = false;
        if (response.status == 200 && !response.data.error) {
          __WEBPACK_IMPORTED_MODULE_2__helpers_mover_helper__["a" /* default */].setUserData(response.data);

          if (response.data.completed_process) {
            _this.$router.push('/thankyou');
          } else {
            _this.next();
          }
        } else {
          if (response.data.error == "login") {
            _this.error_message_login = "Invalid Login";
            setTimeout(function () {
              _this.error_message_login = null;
            }, 5000);
          } else {
            _this.error_message = "Please enter a valid ID";
            setTimeout(function () {
              _this.error_message = null;
            }, 5000);
          }
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
        if (error.status == 401 || error.status == 403) {
          _this.error_message = "Please enter a valid ID";
          setTimeout(function () {
            _this.error_message = null;
          }, 5000);
        } else {
          _this.error_message = "Please enter a valid ID";
          setTimeout(function () {
            _this.error_message = null;
          }, 5000);
        }
      });
    },
    next: function next() {
      this.$router.push({ name: "get-state" });
    }
  }
});

/***/ }),

/***/ "vkIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wbxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_admin_script_js__ = __webpack_require__("2ALQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4ae0598_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_admin_template_html__ = __webpack_require__("Wpal");
function injectStyle (ssrContext) {
  __webpack_require__("1oBF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_admin_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4ae0598_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_admin_template_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    var token = localStorage.getItem('access_token');
    var id = localStorage.getItem('client_id');
    var company = localStorage.getItem('company');
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    if (user && user.id) {
      this.$store.commit('setUser', user);
      this.$store.commit("setAccessToken", user.token);
      this.$store.commit("setClientId", user.id);
      this.$store.commit("setCompany", user.company);
    } else if (token && id) {
      this.$store.commit("setAccessToken", token);
      this.$store.commit("setClientId", id);
      this.$store.commit("setCompany", company);

      var params = {
        'token': token
      };
      this.$http.get("https://movermap-api.irelo.com" + '/user/' + id, { 'params': params }).then(function (response) {
        response = response.data || response;
        _this.$store.commit('setUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response));
        localStorage.setItem('user', response);
      });
    }
  },

  methods: {}
});

/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.961d19bb03adbb7dbd46.js